<template>
  <div class="tab-inner-content">
    <div class="tabs-content-panel tab-pad-wrap">
      <div class="card-panels prev-versions">
        <vs-row vs-justify="center">
          <vs-col class="p-0" type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <!-- Education card html-->
          
            <template v-if="formsAndLettersList.length <=0">
              <div  class="forms_letters dd forms_letters-v2" >
                  <vs-card class="no-card FL-height">               
                      <template v-if="(checkProperty(petition,'intStatusDetails','id')==1 ) && (checkActionButton ||  checkUserAccessBtn || IsAdminUser) && checkNoNotifyUserIds">
                          <template
                            v-if="
                              ([3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].indexOf(getUserRoleId) >
                                -1 ) ||
                              ([3, 4, 5, 6, 7, 8, 9, 10, 11, 12 ,13].indexOf(getUserRoleId) >
                                -1 )
                            "
                          >
                            <div class="pd_upload_actions">

                              <template
                                v-if="
                                  [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].indexOf(
                                    getUserRoleId
                                  ) > -1 &&  (checkIsActiveUser || IsAdminUser) &&
                                  checkProperty(getPetitionDetails, 'status') != false
                                "
                              >
                                <div class="generate_sec ml-auto">
                                
                                  <span
                                    class="primary-btn"
                                    @click="openGenerateFormsLattersPopup()"
                                  >
                                    <figure
                                      v-if="generatingFiles || loadingFormLatters"
                                      class="loader loader2"
                                    >
                                      <img src="@/assets/images/main/loader.gif" />
                                    </figure>
                                    Generate
                                  </span>
                                </div>
                              </template>
                            </div>
                          </template>
                      </template>
                      
                        <NoDataFound
                            ref="NoDataFoundReff"
                            
                            heading="No Documents Found."
                            type="documents"
                            :loading:="false"
                          />
                  </vs-card>
              </div>
            </template>
            <template v-else-if="checkProperty(petition, 'subTypeDetails', 'id') != 15 && formsAndLettersList.length >0">
               <!-----docUserType'] =='Beneficiary' Beneficiary Forms and Documents-->
              <div  class="forms_letters dd forms_letters-v2" @click="docUserType='Beneficiary' ;setdocUserType('Beneficiary')">
                
                  <template >
                    <div :label="'Forms'" >
                      <vs-card class="no-card FL-height">
                        <template v-if="(checkProperty(petition,'intStatusDetails','id')==1 ) && (checkActionButton ||  checkUserAccessBtn || IsAdminUser) && checkNoNotifyUserIds">
                        <template
                          v-if="
                            ([3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].indexOf(getUserRoleId) >
                              -1 ) ||
                            ([3, 4, 5, 6, 7, 8, 9, 10, 11, 12 ,13].indexOf(getUserRoleId) >
                              -1 )
                          "
                        >
                          <div class="pd_upload_actions">
                            
                            <template
                              v-if="
                                [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].indexOf(
                                  getUserRoleId
                                ) > -1 &&  (checkIsActiveUser || IsAdminUser) &&
                                checkProperty(getPetitionDetails, 'status') != false
                              "
                            >
                            <!-- uscisbeneficiaryDownloadDoc uscisspouseDownloadDoc uscischildrenDownloadDoc -->
                              <div class="generate_sec ml-auto">
                                <span class="primary-btn"  
                                v-if="(checkProperty(beneficiaryDownloadDoc, 'documents') && checkProperty(beneficiaryDownloadDoc, 'documents', 'length') > 0) ||
                                (checkProperty(spouseDownloadDoc, 'documents') && checkProperty(spouseDownloadDoc, 'documents', 'length') > 0) ||
                                checkProperty(childrenDownloadDoc, 'length')>0"
                                @click="openDownloadAllPopup(true)" >Download All</span>
                                <span
                                  class="primary-btn"
                                  @click="openGenerateFormsLattersPopup()"
                                >
                                  <figure
                                    v-if="generatingFiles || loadingFormLatters"
                                    class="loader loader2"
                                  >
                                    <img src="@/assets/images/main/loader.gif" />
                                  </figure>
                                  Generate
                                </span>
                              </div>
                            </template>
                          </div>
                        </template>
                      </template>
<!-- {{petitionhistory}} formatDateTime -->
                      <template v-if="[51].indexOf(getUserRoleId)<=-1 && checkProperty(petitionhistory, 'length')>0">
                        <div
                           
                            class="title_des alert_title_des alert_title_desV2">   
                            
                            <span class="notes_head">Notes from Law Office:</span>  
                            <div class="note_text_list" v-for="(comm, ind) in petitionhistory ">
                              <div class="note_text" v-if="checkProperty(comm, 'comment') ">               
                              <p> {{ returnCommentText(checkProperty(comm, 'comment')) | commentSubStr }}                            
                              </p>  
                              <span v-if="checkCommentLength(checkProperty(comm, 'comment'))" class="view_more" @click="showHistoryComment(comm)"> View More</span>     
                            </div>                   
                            <small v-if="checkProperty(comm, 'createdOn')" class="time">{{checkProperty(comm, 'createdOn') | formatDateTime }}</small>
                          </div>
                            
                        </div>
                        
                      </template>
                      <div
                          v-if="uscisFormsAndLettersList.length > 0 && checkSubmitToUscisCompleted && (getUserRoleId !=51 || (getUserRoleId ==51 && checkProperty(petition, 'completedActivities', 'length')>0 &&  petition['completedActivities'].indexOf('REQUEST_BENEFICIARY_SIGN')>-1))  "
                          class="forms_accordian forms_accordian-v2 hidedropdown marb10"
                        >
                          <div
                            v-if="
                            ( (([3, 4].indexOf(getUserRoleId) > -1 || checkDocM) && checkUscisActiveList)  || (!([3, 4].indexOf(getUserRoleId) > -1 || checkDocM) && checkUscisActiveList))
                            "
                          >
                            <vs-list-item class="cards-list-heading">
                              <h2>
                              
                                Beneficiary Forms and Letters - submitted to USCIS
                              
                              </h2>
                              <div class="d-flex">
                                <span
                                v-if="
                                checkProperty(getPetitionDetails, 'status') != false &&
                                [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].indexOf(
                                  getUserRoleId
                                ) > -1 &&
                                (checkIsActiveUser || IsAdminUser)
                              "
                                 class="download-all mr-3" 
                                 @click="
                                 formLetterType='Form';
                                 updateFormat();
                                 depType ='beneficiary';depLabel = 'beneficiary';docUserType ='Beneficiary';
                                 showDocType=true;
                                fuploder = false;
                                parentId = '';
                                entityIdDetails =null;entityId=''
                                fileuploadPopup = true;
                                uploadAfterUSCIS = true;
                                (formerrors.msg = ''),
                                  (uploadMainDocuments = []),
                                  (uploadFinalMainDocuments = []);
                                  resetForms()
                              "
                                 >
                                  Upload
                                  <img src="@/assets/images/main/upload.svg" />
                              </span>
                              

                              <span v-if="checkFormsAndLetters('beneficiary')" class="download-all" @click=" depType ='beneficiary';depLabel = 'beneficiary';docUserType ='Beneficiary';openUscisDownloadPopup(true)">
                                Download
                                <img src="@/assets/images/main/download.svg" />
                              </span>
                              </div>
                            </vs-list-item>
                          </div>
                          <vs-collapse accordion class="forms-letters-accordian" v-if="checkFormsAndLetters('beneficiary')">
                            <template v-for="(forms, index) in uscisFormsAndLettersList">
                            <template v-if="forms['docUserType'] =='Beneficiary'">
                              <!-- v-if="(currentRole ==12 && forms.selectedForSigning ) || currentRole !=12 "-->
                              <div  class="no-accordian" @click="changeTab(forms['type'] ,forms ,'Beneficiary')"
                                v-if="(([3, 4, 9, 10].indexOf(getUserRoleId) > -1) || ( [3, 4, 9, 10].indexOf(getUserRoleId) <= -1 &&  forms.statusId == 2 || forms.statusId == '2'))"
                                :key="index"
                              >
                                <vs-collapse-item
                              
                                  :class="{
                                    closeDropdown: currentRole == 50,
                                    'no-list':
                                      checkProperty(forms, 'reverse_document_versions') &&
                                      forms['reverse_document_versions'].length == 0,
                                  }"
                                  :not-arrow="
                                    !(
                                      checkProperty(forms, 'reverse_document_versions') &&
                                      forms['reverse_document_versions'].length >= 0
                                    )
                                  "
                                >
                                  <div slot="header" class="ss">
                                    <vs-list-item class="documents_accordian">
                                    </vs-list-item>
                                  </div>

                                  <template
                                    v-if="
                                      checkProperty(forms, 'name') ||
                                      (checkProperty(forms, 'reverse_document_versions') &&
                                        [50, 51].indexOf(getUserRoleId) <= -1)
                                    "
                                  >
                                    <div class="list_title">
                                      <div class="documents_accordian_tile">
                                        <docType :item="forms" />
                                        <span
                                          @click="
                                            $store.commit('selectedForEditDocument', null);
                                            fetchSignedUrl(forms);
                                          "
                                          ><em class="fl_scanned_docs" :title="forms.name"  :generated="checkProperty(forms,'generated')?checkProperty(forms,'generated'):'false'"  :id="checkProperty(forms,'_id')" :parent="checkProperty(forms,'parentId')" >{{ forms.name }}
                                            <small class="support_letter_text" v-if="false  && forms['docUserType'] =='Beneficiary'">(Beneficiary)</small>
                                            <small class="support_letter_text" v-if="false  && forms['docUserType'] =='Dependent'">(Dependent)</small>
                                            <template v-if="forms['type']=='Letter' && forms['entityId'] ">
                                                <small class="support_letter_text" v-if="forms['type']=='Letter' && forms['entityId'] =='support_letter'">(Support Letter)</small>
                                                <small  class="support_letter_text" v-else>(Cover Letter)</small>
                                            </template>
                                            
                                            </em>
                                            <small>{{
                                            getformated(forms)
                                          }}</small></span
                                        >
                                      </div>
                                      <div class="d-flex align-center">
                                        <template
                                          v-if="
                                            (checkIsloginUserDoce ||
                                              checkIsloginUserDocm ||
                                              [3, 4].indexOf(getUserRoleId) > -1) &&
                                            checkProperty(getPetitionDetails, 'status') !=
                                              false
                                          "
                                        >
                                          <span
                                            style="margin-right: 30px"
                                            :class="{
                                              status_pending: forms.statusId == 1,
                                              status_active: forms.statusId == 2,
                                              status_rejected: forms.statusId == 3,
                                            }"
                                          >
                                            <template
                                              v-if="checkProperty(forms, 'statusId') == 1"
                                              >Pending</template
                                            >
                                            <template
                                              v-if="checkProperty(forms, 'statusId') == 2"
                                              >Approved</template
                                            >
                                            <template
                                              v-if="checkProperty(forms, 'statusId') == 3"
                                              >Rejected</template
                                            >
                                          </span>
                                        </template>
                                        <div class="vertical-menu">
                                          <span class="menu-icon">
                                            <i class="material-icons">more_vert</i>
                                          </span>
                                          <ul>
                                            <!-- !checkSubmitToUscisCompleted && -->
                                            <li
                                              v-if="
                                                [50, 51].indexOf(currentRole) < 0 &&
                                                
                                                checkProperty(
                                                  getPetitionDetails,
                                                  'status'
                                                ) != false
                                              "
                                              @click="$store.commit('selectedForEditDocument', null);selDoc(forms.mainParentId, forms, false, 'uploadAfterUSCIS')"
                                            >
                                              Upload
                                            </li>
                                            <li @click="$store.commit('selectedForEditDocument', null); fetchSignedUrl(forms, false, true)">
                                              View
                                            </li>
                                            <!-- !isSubmitUscisCompleted && -->
                                            <li
                                              v-if="
                                              
                                              checkProperty(forms, 'statusId') == 2 &&
                                                [50, 51].indexOf(currentRole) < 0 &&
                                               
                                                checkProperty(
                                                  getPetitionDetails,
                                                  'status'
                                                ) != false
                                              "
                                              @click=" $store.commit('selectedForEditDocument', forms); editDocument(forms)"
                                            >
                                              Edit
                                            </li>
                                            <!-- <li @click="fetchSignedUrl(forms, true)">
                                              Download
                                            </li> -->
                                            <li @click="$store.commit('selectedForEditDocument', null); download_or_view(forms)">
                                              Download
                                            </li>
                                            <template v-if="isEnableApproveRejMenu">
                                            <li
                                              v-if="
                                                forms.statusId == 1 &&
                                                (checkDocM ||
                                                  [3, 4].indexOf(getUserRoleId) > -1)
                                              "
                                              @click="
                                              $store.commit('selectedForEditDocument', null);
                                                openApproveOrRejectDocs(
                                                  'APPROVED_BY_DOC_MANAGER'
                                                )
                                              "
                                            >
                                              Approve
                                            </li>
                                            <li
                                              v-if="
                                                forms.statusId == 1 &&
                                                (checkDocM ||
                                                  [3, 4].indexOf(getUserRoleId) > -1)
                                              "
                                              @click="
                                                openApproveOrRejectDocs(
                                                  'REJECT_BY_DOC_MANAGER'
                                                )
                                              "
                                            >
                                              Reject
                                            </li>
                                          </template>
                                            <li
                                              v-if="([3].indexOf(getUserRoleId)>-1 || IsAdminUser) && checkProperty( getPetitionDetails, 'status' ) != false"
                                              @click="openConformPopUp(forms)"
                                            >
                                              Delete
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </template>
                                </vs-collapse-item>
                              </div> 
                              </template>  
                            </template>
                          </vs-collapse>
                          <template v-if="!checkFormsAndLetters('beneficiary')">
                          <NoDataFound  ref="NoDataFoundReff" :content="getContent()"  heading="No Documents Found." type="documents" :loading:="false" />
                          </template>
                        </div> 
                        <div
                          v-if="formsAndLettersList.length > 0  && (getUserRoleId !=51 || 
                          (getUserRoleId ==51 && IsSponsorLogin))"
                          class="forms_accordian forms_accordian-v2 hidedropdown marb10"
                        >
                        <!-- (getUserRoleId ==51 && checkProperty(petition, 'completedActivities', 'length')>0 &&  petition['completedActivities'].indexOf('REQUEST_BENEFICIARY_SIGN')>-1&&!checkProperty(petition, 'petitionerId')) -->
                          <!--download bar 9,10-->
                          <!-- v-if="
                              [3, 4, 9, 10].indexOf(getUserRoleId) > -1 && !checkActiveList 
                            "-->
                          
                          <div
                            v-if="
                            ( (([3, 4].indexOf(getUserRoleId) > -1 || checkDocM) && checkActiveList)  || (!([3, 4].indexOf(getUserRoleId) > -1 || checkDocM) && checkActiveList))
                            "
                          >
                            <vs-list-item class="cards-list-heading">
                              <h2>
                              
                                Beneficiary Forms and Letters
                              
                              </h2>
                              <div class="d-flex">
                                <span
                                v-if="
                                checkProperty(getPetitionDetails, 'status') != false &&
                                [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].indexOf(
                                  getUserRoleId
                                ) > -1 &&
                                (checkIsActiveUser || IsAdminUser)
                              "
                                 class="download-all mr-3" 
                                 @click="
                                 formLetterType='Form';
                                 updateFormat();
                                 depType ='beneficiary';depLabel = 'beneficiary';docUserType ='Beneficiary';
                                 showDocType=true;
                                fuploder = false;
                                parentId = '';
                                entityIdDetails =null;entityId=''
                                fileuploadPopup = true;
                                (formerrors.msg = ''),
                                  (uploadMainDocuments = []),
                                  (uploadFinalMainDocuments = []);
                                  resetForms()
                              "
                                 >
                                  Upload
                                  <img src="@/assets/images/main/upload.svg" />
                              </span>
                              

                              <span v-if="checkFormsAndLetters('beneficiary')" class="download-all" @click=" depType ='beneficiary';depLabel = 'beneficiary';docUserType ='Beneficiary';openDownloadPopup(true)">
                                Download
                                <img src="@/assets/images/main/download.svg" />
                              </span>
                              </div>
                            </vs-list-item>
                          </div>
                          <vs-collapse accordion class="forms-letters-accordian" v-if="checkFormsAndLetters('beneficiary')">
                            <template v-for="(forms, index) in formsAndLettersList">
                            <template v-if="forms['docUserType'] =='Beneficiary'">
                              <!-- v-if="(currentRole ==12 && forms.selectedForSigning ) || currentRole !=12 "-->
                              <div  class="no-accordian" @click="changeTab(forms['type'] ,forms ,'Beneficiary')"
                                v-if="(([3, 4, 9, 10].indexOf(getUserRoleId) > -1) || ( [3, 4, 9, 10].indexOf(getUserRoleId) <= -1 &&  forms.statusId == 2 || forms.statusId == '2'))"
                                :key="index"
                              >
                                <vs-collapse-item
                              
                                  :class="{
                                    closeDropdown: currentRole == 50,
                                    'no-list':
                                      checkProperty(forms, 'reverse_document_versions') &&
                                      forms['reverse_document_versions'].length == 0,
                                  }"
                                  :not-arrow="
                                    !(
                                      checkProperty(forms, 'reverse_document_versions') &&
                                      forms['reverse_document_versions'].length >= 0
                                    )
                                  "
                                >
                                  <div slot="header" class="ss">
                                    <vs-list-item class="documents_accordian">
                                    </vs-list-item>
                                  </div>

                                  <template
                                    v-if="
                                      checkProperty(forms, 'name') ||
                                      (checkProperty(forms, 'reverse_document_versions') &&
                                        [50, 51].indexOf(getUserRoleId) <= -1)
                                    "
                                  >
                                    <div class="list_title">
                                      <div class="documents_accordian_tile">
                                        <docType :item="forms" />
                                        <span
                                          @click="
                                            $store.commit('selectedForEditDocument', null);
                                            fetchSignedUrl(forms);
                                          "
                                          ><em class="fl_scanned_docs" :title="forms.name"  :generated="checkProperty(forms,'generated')?checkProperty(forms,'generated'):'false'"  :id="checkProperty(forms,'_id')" :parent="checkProperty(forms,'parentId')" >{{ forms.name }}
                                            <small class="support_letter_text" v-if="false  && forms['docUserType'] =='Beneficiary'">(Beneficiary)</small>
                                            <small class="support_letter_text" v-if="false  && forms['docUserType'] =='Dependent'">(Dependent)</small>
                                            <template v-if="forms['type']=='Letter' && forms['entityId'] ">
                                                <small class="support_letter_text" v-if="forms['type']=='Letter' && forms['entityId'] =='support_letter'">(Support Letter)</small>
                                                <small  class="support_letter_text" v-else>(Cover Letter)</small>
                                            </template>
                                           
                                            </em>
                                            <small>{{
                                            getformated(forms)
                                          }}</small></span
                                        >
                                      </div>
                                      <div class="docs_form_list">
                                        <template v-if="(!checkProperty(forms, 'ptnrOrBnfSignComplted')) && [50, 12].indexOf(currentRole) > -1 && (!checkSubmitToUscisCompleted)">
                                          <button @click.self="handleSignForms(forms)" class="sign_in">
                                                E-Sign
                                            </button>
                                          </template>
                                      </div>
                                      <div class="d-flex align-center">
                                        <template
                                          v-if="
                                            (checkIsloginUserDoce ||
                                              checkIsloginUserDocm ||
                                              [3, 4].indexOf(getUserRoleId) > -1) &&
                                            checkProperty(getPetitionDetails, 'status') !=
                                              false
                                          "
                                        >
                                          <span
                                            style="margin-right: 30px"
                                            :class="{
                                              status_pending: forms.statusId == 1,
                                              status_active: forms.statusId == 2,
                                              status_rejected: forms.statusId == 3,
                                            }"
                                          >
                                            <template
                                              v-if="checkProperty(forms, 'statusId') == 1"
                                              >Pending</template
                                            >
                                            <template
                                              v-if="checkProperty(forms, 'statusId') == 2"
                                              >Approved</template
                                            >
                                            <template
                                              v-if="checkProperty(forms, 'statusId') == 3"
                                              >Rejected</template
                                            >
                                          </span>
                                        </template>
                                        <div class="vertical-menu">
                                          <span class="menu-icon">
                                            <i class="material-icons">more_vert</i>
                                          </span>
                                          <ul>
                                            <!-- !checkSubmitToUscisCompleted && -->
                                            <li
                                              v-if="
                                                [50, 51].indexOf(currentRole) < 0 &&
                                                
                                                checkProperty(
                                                  getPetitionDetails,
                                                  'status'
                                                ) != false
                                              "
                                              @click="$store.commit('selectedForEditDocument', null);selDoc(forms.mainParentId, forms)"
                                            >
                                              Upload
                                            </li>
                                            <li @click="$store.commit('selectedForEditDocument', null); fetchSignedUrl(forms, false, true)">
                                              View
                                            </li>
                                            <!-- !isSubmitUscisCompleted && -->
                                            <li
                                              v-if="
                                              
                                              checkProperty(forms, 'statusId') == 2 &&
                                                [50, 51].indexOf(currentRole) < 0 &&
                                               
                                                checkProperty(
                                                  getPetitionDetails,
                                                  'status'
                                                ) != false
                                              "
                                              @click=" $store.commit('selectedForEditDocument', forms); editDocument(forms)"
                                            >
                                              Edit
                                            </li>
                                            <!-- <li @click="fetchSignedUrl(forms, true)">
                                              Download
                                            </li> -->
                                            <li @click="$store.commit('selectedForEditDocument', null); download_or_view(forms)">
                                              Download
                                            </li>
                                            <template v-if="isEnableApproveRejMenu">
                                            <li
                                              v-if="
                                                forms.statusId == 1 &&
                                                (checkDocM ||
                                                  [3, 4].indexOf(getUserRoleId) > -1)
                                              "
                                              @click="
                                              $store.commit('selectedForEditDocument', null);
                                                openApproveOrRejectDocs(
                                                  'APPROVED_BY_DOC_MANAGER'
                                                )
                                              "
                                            >
                                              Approve
                                            </li>
                                            <li
                                              v-if="
                                                forms.statusId == 1 &&
                                                (checkDocM ||
                                                  [3, 4].indexOf(getUserRoleId) > -1)
                                              "
                                              @click="
                                                openApproveOrRejectDocs(
                                                  'REJECT_BY_DOC_MANAGER'
                                                )
                                              "
                                            >
                                              Reject
                                            </li>
                                          </template>
                                            <li
                                              v-if="
                                                ([3].indexOf(getUserRoleId)>-1 || IsAdminUser) && checkProperty( getPetitionDetails, 'status'  ) != false"
                                              @click="openConformPopUp(forms)"
                                            >
                                              Delete
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </template>
                                </vs-collapse-item>
                              </div> 
                              </template>  
                            </template>
                          </vs-collapse>
                          <template v-if="!checkFormsAndLetters('beneficiary')">
                          <NoDataFound  ref="NoDataFoundReff" :content="getContent()"  heading="No Documents Found." type="documents" :loading:="false" />
                          </template>
                        </div>
                        

                      </vs-card>
                    </div>
                  
                    
                  </template>
                  
                
              </div>
              <!-----Dependent Document checkFormsAndLetters('spouse')--->
              <template v-if=" checkProperty(petition, 'beneficiaryInfo', 'maritalStatus') !=1  && [18].indexOf(checkProperty(petition, 'subTypeDetails', 'id'))<=-1">
                <div v-if="[2,11].indexOf(checkProperty(petition, 'typeDetails', 'id'))<=-1 && checkProperty(petition, 'dependentsInfo', 'spouse') && checkProperty(petition['dependentsInfo'], 'spouse' ,'h4Required')" class="forms_letters forms_letters-v2 " @click="docUserType='Dependent';setdocUserType('Dependent')">
                  <template >
                    <div :label="'Forms'" >
                      <vs-card class="no-card FL-height">
                        <div
                          v-if="uscisFormsAndLettersList.length > 0 && checkSubmitToUscisCompleted"
                          class="forms_accordian forms_accordian-v2 hidedropdown marb10"
                        >
                          
                          <div
                            v-if="
                            ( (([3, 4].indexOf(getUserRoleId) > -1 || checkDocM) && checkUscisActiveList) 
                            ||
                            (!([3, 4].indexOf(getUserRoleId) > -1 || checkDocM) && checkUscisActiveList))
                            "
                          >
                            <vs-list-item class="cards-list-heading">
                              <h2>
                              
                                Spouse Forms and Letters - submitted to USCIS
                              
                              </h2>
                              <div class="d-flex">
                                  <span
                                  v-if="
                                  checkProperty(getPetitionDetails, 'status') != false &&
                                  [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].indexOf(
                                    getUserRoleId
                                  ) > -1 &&
                                  (checkIsActiveUser || IsAdminUser)
                                "
                                  class="download-all mr-3" 
                                  @click="
                                  formLetterType='Form';
                                  updateFormat();
                                  depType ='spouse';depLabel = 'spouse';docUserType ='Dependent';
                                  showDocType=true;
                                  fuploder = false;
                                  parentId = '';
                                  entityIdDetails =null;entityId=''
                                  fileuploadPopup = true;
                                  uploadAfterUSCIS = true;
                                  (formerrors.msg = ''),
                                    (uploadMainDocuments = []),
                                    (uploadFinalMainDocuments = []);
                                    resetForms()
                                "
                                  >
                                    Upload
                                    <img src="@/assets/images/main/upload.svg" />
                                </span>
                            

                              <span v-if="checkFormsAndLetters('spouse')" class="download-all" @click=" depType ='spouse';depLabel = 'spouse';docUserType ='Dependent';openUscisDownloadPopup(true)">
                                Download
                                <img src="@/assets/images/main/download.svg" />
                              </span>
                            </div>
                            </vs-list-item>
                          </div>
                          <vs-collapse accordion class="forms-letters-accordian" v-if="checkFormsAndLetters('spouse')">
                            <template v-for="(forms, index) in uscisFormsAndLettersList">
                            <template v-if="forms['docUserType'] =='Dependent' && forms['depType']=='spouse'">
                              <!-- v-if="(currentRole ==12 && forms.selectedForSigning ) || currentRole !=12 "-->
                              <div  class="no-accordian" @click="changeTab(forms['type'] ,forms ,'Dependent')"
                                v-if="(([3, 4, 9, 10].indexOf(getUserRoleId) > -1) || ( [3, 4, 9, 10].indexOf(getUserRoleId) <= -1 &&  forms.statusId == 2 || forms.statusId == '2'))"
                                :key="index"
                              >
                                <vs-collapse-item
                              
                                  :class="{
                                    closeDropdown: currentRole == 50,
                                    'no-list':
                                      checkProperty(forms, 'reverse_document_versions') &&
                                      forms['reverse_document_versions'].length == 0,
                                  }"
                                  :not-arrow="
                                    !(
                                      checkProperty(forms, 'reverse_document_versions') &&
                                      forms['reverse_document_versions'].length >= 0
                                    )
                                  "
                                >
                                  <div slot="header" class="ss">
                                    <vs-list-item class="documents_accordian">
                                    </vs-list-item>
                                  </div>

                                  <template
                                    v-if="
                                      checkProperty(forms, 'name') ||
                                      (checkProperty(forms, 'reverse_document_versions') &&
                                        [50, 51].indexOf(getUserRoleId) <= -1)
                                    "
                                  >
                                    <div class="list_title">
                                      <div class="documents_accordian_tile">
                                        <docType :item="forms" />
                                        <span
                                          @click="
                                            $store.commit('selectedForEditDocument', forms);
                                            fetchSignedUrl(forms);
                                          "
                                          ><em class="fl_scanned_docs" :title="forms.name">{{ forms.name }}
                                            <small class="support_letter_text"   v-if="false &&  forms['docUserType'] =='Beneficiary'">(Beneficiary)</small>
                                            <small class="support_letter_text"  v-if="false &&  forms['docUserType'] =='Dependent'">(Dependent)</small>
                                            <template v-if="forms['type']=='Letter' && forms['entityId'] ">
                                                <small class="support_letter_text" v-if="forms['type']=='Letter' && forms['entityId'] =='support_letter'">(Support Letter)</small>
                                                <small  class="support_letter_text" v-else>(Cover Letter)</small>
                                            </template>
                                            </em>
                                            <small>{{
                                            getformated(forms)
                                          }}</small></span
                                        >
                                      </div>
                                      <div class="d-flex align-center">
                                        <template
                                          v-if="
                                            (checkIsloginUserDoce ||
                                              checkIsloginUserDocm ||
                                              [3, 4].indexOf(getUserRoleId) > -1) &&
                                            checkProperty(getPetitionDetails, 'status') !=
                                              false
                                          "
                                        >
                                          <span
                                            style="margin-right: 30px"
                                            :class="{
                                              status_pending: forms.statusId == 1,
                                              status_active: forms.statusId == 2,
                                              status_rejected: forms.statusId == 3,
                                            }"
                                          >
                                            <template
                                              v-if="checkProperty(forms, 'statusId') == 1"
                                              >Pending</template
                                            >
                                            <template
                                              v-if="checkProperty(forms, 'statusId') == 2"
                                              >Approved</template
                                            >
                                            <template
                                              v-if="checkProperty(forms, 'statusId') == 3"
                                              >Rejected</template
                                            >
                                          </span>
                                        </template>
                                        <div class="vertical-menu">
                                          <span class="menu-icon">
                                            <i class="material-icons">more_vert</i>
                                          </span>
                                          <ul>
                                            <!-- !checkSubmitToUscisCompleted && -->
                                            <li
                                              v-if="
                                                [50, 51].indexOf(currentRole) < 0 &&
                                                
                                                checkProperty(
                                                  getPetitionDetails,
                                                  'status'
                                                ) != false
                                              "
                                              @click="selDoc(forms.mainParentId, forms, false, 'uploadAfterUSCIS')"
                                            >
                                              Upload
                                            </li>
                                            <li @click="fetchSignedUrl(forms, false, true)">
                                              View
                                            </li>
                                            <!-- !isSubmitUscisCompleted && -->
                                            <li
                                              v-if="
                                              
                                              checkProperty(forms, 'statusId') == 2 &&
                                                [50, 51].indexOf(currentRole) < 0 &&
                                               
                                                checkProperty(
                                                  getPetitionDetails,
                                                  'status'
                                                ) != false
                                              "
                                              @click="editDocument(forms)"
                                            >
                                              Edit
                                            </li>
                                            <!-- <li @click="fetchSignedUrl(forms, true)">
                                              Download
                                            </li> -->
                                            <li @click="download_or_view(forms)">
                                              Download
                                            </li>
                                            <template v-if="isEnableApproveRejMenu">
                                            <li
                                              v-if="
                                                forms.statusId == 1 &&
                                                (checkDocM ||
                                                  [3, 4].indexOf(getUserRoleId) > -1)
                                              "
                                              @click="
                                                openApproveOrRejectDocs(
                                                  'APPROVED_BY_DOC_MANAGER'
                                                )
                                              "
                                            >
                                              Approve
                                            </li>
                                            <li
                                              v-if="
                                                forms.statusId == 1 &&
                                                (checkDocM ||
                                                  [3, 4].indexOf(getUserRoleId) > -1)
                                              "
                                              @click="
                                                openApproveOrRejectDocs(
                                                  'REJECT_BY_DOC_MANAGER'
                                                )
                                              "
                                            >
                                              Reject
                                            </li>
                                          </template>
                                            <li
                                              v-if="
                                                ([3].indexOf(getUserRoleId)>-1 || IsAdminUser) && checkProperty( getPetitionDetails, 'status' ) != false "
                                              @click="openConformPopUp(forms)"
                                            >
                                              Delete
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </template>
                                </vs-collapse-item>
                              </div> 
                              </template>  
                            </template>
                          </vs-collapse>
                          <template v-else>
                            
                            <NoDataFound  ref="NoDataFoundReff" :content="getContent()"  heading="No Documents Found." type="documents" :loading:="false" />
                            </template>
                        </div>
                        <div
                          v-if="formsAndLettersList.length > 0"
                          class="forms_accordian forms_accordian-v2 hidedropdown marb10"
                        >
                          <!--download bar 9,10-->
                          <!-- v-if="
                              [3, 4, 9, 10].indexOf(getUserRoleId) > -1 && !checkActiveList
                            "-->
                          
                          <div
                            v-if="
                            ( (([3, 4].indexOf(getUserRoleId) > -1 || checkDocM) && checkActiveList) 
                            ||
                            (!([3, 4].indexOf(getUserRoleId) > -1 || checkDocM) && checkActiveList))
                            "
                          >
                            <vs-list-item class="cards-list-heading">
                              <h2>
                              
                                Spouse Forms and Letters 
                              
                              </h2>
                              <div class="d-flex">
                                  <span
                                  v-if="
                                  checkProperty(getPetitionDetails, 'status') != false &&
                                  [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].indexOf(
                                    getUserRoleId
                                  ) > -1 &&
                                  (checkIsActiveUser || IsAdminUser)
                                "
                                  class="download-all mr-3" 
                                  @click="
                                  formLetterType='Form';
                                  updateFormat();
                                  depType ='spouse';depLabel = 'spouse';docUserType ='Dependent';
                                  showDocType=true;
                                  fuploder = false;
                                  parentId = '';
                                  entityIdDetails =null;entityId=''
                                  fileuploadPopup = true;
                                  (formerrors.msg = ''),
                                    (uploadMainDocuments = []),
                                    (uploadFinalMainDocuments = []);
                                    resetForms()
                                "
                                  >
                                    Upload
                                    <img src="@/assets/images/main/upload.svg" />
                                </span>
                            

                              <span v-if="checkFormsAndLetters('spouse')" class="download-all" @click=" depType ='spouse';depLabel = 'spouse';docUserType ='Dependent';openDownloadPopup(true)">
                                Download
                                <img src="@/assets/images/main/download.svg" />
                              </span>
                            </div>
                            </vs-list-item>
                          </div>
                          <vs-collapse accordion class="forms-letters-accordian" v-if="checkFormsAndLetters('spouse')">
                            <template v-for="(forms, index) in formsAndLettersList">
                            <template v-if="forms['docUserType'] =='Dependent' && forms['depType']=='spouse'">
                              <!-- v-if="(currentRole ==12 && forms.selectedForSigning ) || currentRole !=12 "-->
                              <div  class="no-accordian" @click="changeTab(forms['type'] ,forms ,'Dependent')"
                                v-if="(([3, 4, 9, 10].indexOf(getUserRoleId) > -1) || ( [3, 4, 9, 10].indexOf(getUserRoleId) <= -1 &&  forms.statusId == 2 || forms.statusId == '2'))"
                                :key="index"
                              >
                                <vs-collapse-item
                              
                                  :class="{
                                    closeDropdown: currentRole == 50,
                                    'no-list':
                                      checkProperty(forms, 'reverse_document_versions') &&
                                      forms['reverse_document_versions'].length == 0,
                                  }"
                                  :not-arrow="
                                    !(
                                      checkProperty(forms, 'reverse_document_versions') &&
                                      forms['reverse_document_versions'].length >= 0
                                    )
                                  "
                                >
                                  <div slot="header" class="ss">
                                    <vs-list-item class="documents_accordian">
                                    </vs-list-item>
                                  </div>

                                  <template
                                    v-if="
                                      checkProperty(forms, 'name') ||
                                      (checkProperty(forms, 'reverse_document_versions') &&
                                        [50, 51].indexOf(getUserRoleId) <= -1)
                                    "
                                  >
                                    <div class="list_title">
                                      <div class="documents_accordian_tile">
                                        <docType :item="forms" />
                                        <span
                                          @click="
                                            $store.commit('selectedForEditDocument', forms);
                                            fetchSignedUrl(forms);
                                          "
                                          ><em class="fl_scanned_docs" :title="forms.name">{{ forms.name }}
                                            <small class="support_letter_text"   v-if="false &&  forms['docUserType'] =='Beneficiary'">(Beneficiary)</small>
                                            <small class="support_letter_text"  v-if="false &&  forms['docUserType'] =='Dependent'">(Dependent)</small>
                                            <template v-if="forms['type']=='Letter' && forms['entityId'] ">
                                                <small class="support_letter_text" v-if="forms['type']=='Letter' && forms['entityId'] =='support_letter'">(Support Letter)</small>
                                                <small  class="support_letter_text" v-else>(Cover Letter)</small>
                                            </template>
                                            </em>
                                            <small>{{
                                            getformated(forms)
                                          }}</small></span
                                        >
                                      </div>
                                      <div class="d-flex align-center">
                                        <template
                                          v-if="
                                            (checkIsloginUserDoce ||
                                              checkIsloginUserDocm ||
                                              [3, 4].indexOf(getUserRoleId) > -1) &&
                                            checkProperty(getPetitionDetails, 'status') !=
                                              false
                                          "
                                        >
                                          <span
                                            style="margin-right: 30px"
                                            :class="{
                                              status_pending: forms.statusId == 1,
                                              status_active: forms.statusId == 2,
                                              status_rejected: forms.statusId == 3,
                                            }"
                                          >
                                            <template
                                              v-if="checkProperty(forms, 'statusId') == 1"
                                              >Pending</template
                                            >
                                            <template
                                              v-if="checkProperty(forms, 'statusId') == 2"
                                              >Approved</template
                                            >
                                            <template
                                              v-if="checkProperty(forms, 'statusId') == 3"
                                              >Rejected</template
                                            >
                                          </span>
                                        </template>
                                        <div class="vertical-menu">
                                          <span class="menu-icon">
                                            <i class="material-icons">more_vert</i>
                                          </span>
                                          <ul>
                                            <!-- !checkSubmitToUscisCompleted && -->
                                            <li
                                              v-if="
                                                [50, 51].indexOf(currentRole) < 0 &&
                                                
                                                checkProperty(
                                                  getPetitionDetails,
                                                  'status'
                                                ) != false
                                              "
                                              @click="selDoc(forms.mainParentId, forms)"
                                            >
                                              Upload
                                            </li>
                                            <li @click="fetchSignedUrl(forms, false, true)">
                                              View
                                            </li>
                                            <!-- <li
                                            v-if="(!checkProperty(forms, 'ptnrOrBnfSignComplted')) && currentRole == 51 &&
                                              checkProperty(
                                                getPetitionDetails,
                                                'status'
                                               ) != false"
                                              @click="handleSignForms(forms)">
                                            Sign
                                           </li> -->
                                            <!-- !isSubmitUscisCompleted && -->
                                            <li
                                              v-if="
                                              
                                              checkProperty(forms, 'statusId') == 2 &&
                                                [50, 51].indexOf(currentRole) < 0 &&
                                               
                                                checkProperty(
                                                  getPetitionDetails,
                                                  'status'
                                                ) != false
                                              "
                                              @click="editDocument(forms)"
                                            >
                                              Edit
                                            </li>
                                            <!-- <li @click="fetchSignedUrl(forms, true)">
                                              Download
                                            </li> -->
                                            <li @click="download_or_view(forms)">
                                              Download
                                            </li>
                                            <template v-if="isEnableApproveRejMenu">
                                            <li
                                              v-if="
                                                forms.statusId == 1 &&
                                                (checkDocM ||
                                                  [3, 4].indexOf(getUserRoleId) > -1)
                                              "
                                              @click="
                                                openApproveOrRejectDocs(
                                                  'APPROVED_BY_DOC_MANAGER'
                                                )
                                              "
                                            >
                                              Approve
                                            </li>
                                            <li
                                              v-if="
                                                forms.statusId == 1 &&
                                                (checkDocM ||
                                                  [3, 4].indexOf(getUserRoleId) > -1)
                                              "
                                              @click="
                                                openApproveOrRejectDocs(
                                                  'REJECT_BY_DOC_MANAGER'
                                                )
                                              "
                                            >
                                              Reject
                                            </li>
                                          </template>
                                            <li
                                              v-if="([3].indexOf(getUserRoleId)>-1 || IsAdminUser) &&  checkProperty( getPetitionDetails, 'status' ) != false "
                                              @click="openConformPopUp(forms)"
                                            >
                                              Delete
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </template>
                                </vs-collapse-item>
                              </div> 
                              </template>  
                            </template>
                          </vs-collapse>
                          <template v-else>
                            
                            <NoDataFound  ref="NoDataFoundReff" :content="getContent()"  heading="No Documents Found." type="documents" :loading:="false" />
                            </template>
                        </div>
                        

                                            
                        

                      </vs-card>
                    </div>
                  
                    
                  </template>
                  
                
                </div>
                <template v-if="checkSubmitToUscisCompleted">
                  <template v-if="Object.entries(childUscisFormsAndLetters).length>0 && checkSubmitToUscisCompleted">
                    <template v-for="( child ,ind) in Object.entries(childUscisFormsAndLetters)">
                      <template v-if="(child && child.length>1) ">
                        <template v-if="(child[1].length>0)">
                          <div  class="forms_letters dd forms_letters-v2" @click="docUserType='Dependent';setdocUserType('Dependent')">
                      
                      <template >
                        <div :label="'Forms'" >
                          <vs-card class="no-card FL-height">
                          
                            <div
                              v-if="uscisFormsAndLettersList.length > 0"
                              class="forms_accordian forms_accordian-v2 hidedropdown marb10"
                            >
                              <div
                                v-if="
                                ( (([3, 4].indexOf(getUserRoleId) > -1 || checkDocM) && checkUscisActiveList) 
                                ||
                                (!([3, 4].indexOf(getUserRoleId) > -1 || checkDocM) && checkUscisActiveList))
                                "
                              >
                                <vs-list-item class="cards-list-heading">
                                  <h2>
                                  <template v-if="Object.entries(childUscisFormsAndLetters).length>1" >{{'USCIS Child '+(ind+1)+' Forms and Letters '}}- submitted to USCIS</template>
                                  <template v-else>Child Forms and Letters - submitted to USCIS</template>
                                  
                                  
                                  </h2>
                                  <div class="d-flex">
                                      <span
                                      v-if="  
                                      checkProperty(getPetitionDetails, 'status') != false &&
                                      [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].indexOf(
                                        getUserRoleId
                                      ) > -1 &&
                                      (checkIsActiveUser || IsAdminUser)
                                    "
                                      class="download-all mr-3" 
                                      @click="
                                      formLetterType='Form';
                                      updateFormat();
                                      depType ='child';depLabel=checkProperty(child[1][0] ,'depLabel');docUserType ='Dependent';
                                      showDocType=true;
                                      fuploder = false;
                                      parentId = '';
                                      entityIdDetails =null;entityId=''
                                      fileuploadPopup = true;
                                      uploadAfterUSCIS = true;
                                      (formerrors.msg = ''),
                                        (uploadMainDocuments = []),
                                        (uploadFinalMainDocuments = []);
                                        resetForms()
                                    "
                                      >
                                        Upload
                                        <img src="@/assets/images/main/upload.svg" />
                                    </span>
                                

                                  <span class="download-all" @click=" depType ='child';depLabel=checkProperty(child[1][0] ,'depLabel');docUserType ='Dependent';openUscisDownloadPopup(true)">
                                    Download
                                    <img src="@/assets/images/main/download.svg" />
                                  </span>
                                </div>
                                </vs-list-item>
                              </div>
                              <vs-collapse accordion class="forms-letters-accordian">
                                <template v-for="(forms, index) in child[1]">
                                <template >
                                
                                  <div  class="no-accordian" @click="changeTab(forms['type'] ,forms ,'Dependent')"
                                    v-if="(([3, 4, 9, 10].indexOf(getUserRoleId) > -1) || ( [3, 4, 9, 10].indexOf(getUserRoleId) <= -1 &&  forms.statusId == 2 || forms.statusId == '2'))"
                                    :key="index"
                                  >
                                    <vs-collapse-item
                                  
                                      :class="{
                                        closeDropdown: currentRole == 50,
                                        'no-list':
                                          checkProperty(forms, 'reverse_document_versions') &&
                                          forms['reverse_document_versions'].length == 0,
                                      }"
                                      :not-arrow="
                                        !(
                                          checkProperty(forms, 'reverse_document_versions') &&
                                          forms['reverse_document_versions'].length >= 0
                                        )
                                      "
                                    >
                                      <div slot="header" class="ss">
                                        <vs-list-item class="documents_accordian">
                                        </vs-list-item>
                                      </div>

                                      <template
                                        v-if="
                                          checkProperty(forms, 'name') ||
                                          (checkProperty(forms, 'reverse_document_versions') &&
                                            [50, 51].indexOf(getUserRoleId) <= -1)
                                        "
                                      >
                                        <div class="list_title">
                                          <div class="documents_accordian_tile">
                                            <docType :item="forms" />
                                            <span
                                              @click="
                                                $store.commit('selectedForEditDocument', forms);
                                                fetchSignedUrl(forms);
                                              "
                                              ><em class="fl_scanned_docs" :title="forms.name">{{ forms.name }}
                                                <small class="support_letter_text"   v-if="false &&  forms['docUserType'] =='Beneficiary'">(Beneficiary)</small>
                                                <small class="support_letter_text"   v-if="false && forms['docUserType'] =='Dependent'">(Dependent)</small>
                                                <template v-if="forms['type']=='Letter' && forms['entityId'] ">
                                                  <small class="support_letter_text" v-if="forms['type']=='Letter' && forms['entityId'] =='support_letter'">(Support Letter)</small>
                                                  <small  class="support_letter_text" v-else>(Cover Letter)</small>
                                              </template>
                                                </em>
                                                <small>{{
                                                getformated(forms)
                                              }}</small></span
                                            >
                                          </div>
                                          <div class="d-flex align-center">
                                            <template
                                              v-if="
                                                (checkIsloginUserDoce ||
                                                  checkIsloginUserDocm ||
                                                  [3, 4].indexOf(getUserRoleId) > -1) &&
                                                checkProperty(getPetitionDetails, 'status') !=
                                                  false
                                              "
                                            >
                                              <span
                                                style="margin-right: 30px"
                                                :class="{
                                                  status_pending: forms.statusId == 1,
                                                  status_active: forms.statusId == 2,
                                                  status_rejected: forms.statusId == 3,
                                                }"
                                              >
                                                <template
                                                  v-if="checkProperty(forms, 'statusId') == 1"
                                                  >Pending</template
                                                >
                                                <template
                                                  v-if="checkProperty(forms, 'statusId') == 2"
                                                  >Approved</template
                                                >
                                                <template
                                                  v-if="checkProperty(forms, 'statusId') == 3"
                                                  >Rejected</template
                                                >
                                              </span>
                                            </template>
                                            <div class="vertical-menu">
                                              <span class="menu-icon">
                                                <i class="material-icons">more_vert</i>
                                              </span>
                                              <ul>
                                                <!-- !checkSubmitToUscisCompleted && -->
                                                <li
                                                  v-if="
                                                    [50, 51].indexOf(currentRole) < 0 &&
                                                    checkProperty(
                                                      getPetitionDetails,
                                                      'status'
                                                    ) != false
                                                  "
                                                  @click="selDoc(forms.mainParentId, forms, false, 'uploadAfterUSCIS')"
                                                >
                                                  Upload
                                                </li>
                                                <li @click="fetchSignedUrl(forms, false, true)">
                                                  View
                                                </li>
                                                <!-- !isSubmitUscisCompleted && -->
                                                <li
                                                  v-if="
                                                  
                                                  checkProperty(forms, 'statusId') == 2 &&
                                                    [50, 51].indexOf(currentRole) < 0 &&
                                                    
                                                    checkProperty(
                                                      getPetitionDetails,
                                                      'status'
                                                    ) != false
                                                  "
                                                  @click="editDocument(forms)"
                                                >
                                                  Edit
                                                </li>
                                                <!-- <li @click="fetchSignedUrl(forms, true)">
                                                  Download
                                                </li> -->
                                                <li @click="download_or_view(forms)">
                                                  Download
                                                </li>
                                                <template v-if="isEnableApproveRejMenu">
                                                <li
                                                  v-if="
                                                    forms.statusId == 1 &&
                                                    (checkDocM ||
                                                      [3, 4].indexOf(getUserRoleId) > -1)
                                                  "
                                                  @click="
                                                    openApproveOrRejectDocs(
                                                      'APPROVED_BY_DOC_MANAGER'
                                                    )
                                                  "
                                                >
                                                  Approve
                                                </li>
                                                <li
                                                  v-if="
                                                    forms.statusId == 1 &&
                                                    (checkDocM ||
                                                      [3, 4].indexOf(getUserRoleId) > -1)
                                                  "
                                                  @click="
                                                    openApproveOrRejectDocs(
                                                      'REJECT_BY_DOC_MANAGER'
                                                    )
                                                  "
                                                >
                                                  Reject
                                                </li>
                                              </template>
                                                <li
                                                  v-if="([3].indexOf(getUserRoleId)>-1 || IsAdminUser) && checkProperty( getPetitionDetails, 'status' ) != false"
                                                  @click="openConformPopUp(forms)"
                                                >
                                                  Delete
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                        </div>
                                      </template>
                                    </vs-collapse-item>
                                  </div> 
                                  </template>  
                                </template>
                              </vs-collapse>
                            </div>
                          

                          </vs-card>
                        </div>
                      
                        
                      </template>
                      
                    
                    </div>
                        </template>

                      
                      </template>

                    </template>
                  

                  </template>
                  <template v-else>
                    <template v-if="showChildForms">
                      <template v-for="( child ,ind) in petition.dependentsInfo.childrens">
                      <div :label="'Forms'" >
                        <vs-card class="no-card FL-height">
                          <div
                            v-if="uscisFormsAndLettersList.length > 0"
                            class="forms_accordian forms_accordian-v2 hidedropdown marb10"
                          >
                            <div
                              v-if="
                              ( (([3, 4].indexOf(getUserRoleId) > -1 || checkDocM) && checkUscisActiveList) 
                              ||
                              (!([3, 4].indexOf(getUserRoleId) > -1 || checkDocM) && checkUscisActiveList))
                              "
                            >
                              <vs-list-item class="cards-list-heading">
                                
                                <h2>
                                  <template  >{{'Child '+(ind+1)+' Forms and Letters'}} - submitted to USCIS</template>
                                
                                </h2>
                                <div class="d-flex">
                                    <span
                                    v-if="
                                    checkProperty(getPetitionDetails, 'status') != false &&
                                    [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].indexOf(
                                      getUserRoleId
                                    ) > -1 &&
                                    (checkIsActiveUser || IsAdminUser)
                                  "
                                    class="download-all mr-3" 
                                    @click="
                                    depType ='child';depLabel ='child_'+ind;docUserType ='Dependent';
                                    showDocType=true;
                                    fuploder = false;
                                    parentId = '';
                                    entityIdDetails =null;entityId=''
                                    fileuploadPopup = true;
                                    uploadAfterUSCIS = true;
                                    (formerrors.msg = ''),
                                      (uploadMainDocuments = []),
                                      (uploadFinalMainDocuments = []);
                                      resetForms()
                                  "
                                    >
                                      Upload
                                      <img src="@/assets/images/main/upload.svg" />
                                  </span>
                              </div>
                              </vs-list-item>
                            </div>
                            <template>
                              <NoDataFound ref="NoDataFoundRef" :checkLocading="false" :loading="false" content="" heading="No Documents Found." type='documents' />
                              </template>
                          </div>
                        </vs-card>
                      </div>
                    </template>
                    </template>
                  </template>
                </template>
                <template v-if="Object.entries(childrenFormsAndLetters).length>0">
                  <template v-for="( child ,ind) in Object.entries(childrenFormsAndLetters)">
                    <template v-if="(child && child.length>1) ">
                      <template v-if="(child[1].length>0)">
                        <div  class="forms_letters dd forms_letters-v2" @click="docUserType='Dependent';setdocUserType('Dependent')">
                    
                    <template >
                      <div :label="'Forms'" >
                        <vs-card class="no-card FL-height">
                        
                          <div
                            v-if="formsAndLettersList.length > 0"
                            class="forms_accordian forms_accordian-v2 hidedropdown marb10"
                          >
                            <!--download bar 9,10-->
                            <!-- v-if="
                                [3, 4, 9, 10].indexOf(getUserRoleId) > -1 && !checkActiveList
                              "-->
                            
                            <div
                              v-if="
                              ( (([3, 4].indexOf(getUserRoleId) > -1 || checkDocM) && checkActiveList) 
                              ||
                              (!([3, 4].indexOf(getUserRoleId) > -1 || checkDocM) && checkActiveList))
                              "
                            >
                              <vs-list-item class="cards-list-heading">
                                <h2>
                                <template v-if="Object.entries(childrenFormsAndLetters).length>1" >{{'Child '+(ind+1)+' Forms and Letters'}}</template>
                                <template v-else>Child Forms and Letters</template>
                                
                                
                                </h2>
                                <div class="d-flex">
                                    <span
                                    v-if="  
                                    checkProperty(getPetitionDetails, 'status') != false &&
                                    [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].indexOf(
                                      getUserRoleId
                                    ) > -1 &&
                                    (checkIsActiveUser || IsAdminUser)
                                  "
                                    class="download-all mr-3" 
                                    @click="
                                    formLetterType='Form';
                                    updateFormat();
                                    depType ='child';depLabel=checkProperty(child[1][0] ,'depLabel');docUserType ='Dependent';
                                    showDocType=true;
                                    fuploder = false;
                                    parentId = '';
                                    entityIdDetails =null;entityId=''
                                    fileuploadPopup = true;
                                    (formerrors.msg = ''),
                                      (uploadMainDocuments = []),
                                      (uploadFinalMainDocuments = []);
                                      resetForms()
                                  "
                                    >
                                      Upload
                                      <img src="@/assets/images/main/upload.svg" />
                                  </span>
                              

                                <span class="download-all" @click=" depType ='child';depLabel=checkProperty(child[1][0] ,'depLabel');docUserType ='Dependent';openDownloadPopup(true)">
                                  Download
                                  <img src="@/assets/images/main/download.svg" />
                                </span>
                              </div>
                              </vs-list-item>
                            </div>
                            <vs-collapse accordion class="forms-letters-accordian">
                              <template v-for="(forms, index) in child[1]">
                              <template >
                              
                                <div  class="no-accordian" @click="changeTab(forms['type'] ,forms ,'Dependent')"
                                  v-if="(([3, 4, 9, 10].indexOf(getUserRoleId) > -1) || ( [3, 4, 9, 10].indexOf(getUserRoleId) <= -1 &&  forms.statusId == 2 || forms.statusId == '2'))"
                                  :key="index"
                                >
                                  <vs-collapse-item
                                
                                    :class="{
                                      closeDropdown: currentRole == 50,
                                      'no-list':
                                        checkProperty(forms, 'reverse_document_versions') &&
                                        forms['reverse_document_versions'].length == 0,
                                    }"
                                    :not-arrow="
                                      !(
                                        checkProperty(forms, 'reverse_document_versions') &&
                                        forms['reverse_document_versions'].length >= 0
                                      )
                                    "
                                  >
                                    <div slot="header" class="ss">
                                      <vs-list-item class="documents_accordian">
                                      </vs-list-item>
                                    </div>

                                    <template
                                      v-if="
                                        checkProperty(forms, 'name') ||
                                        (checkProperty(forms, 'reverse_document_versions') &&
                                          [50, 51].indexOf(getUserRoleId) <= -1)
                                      "
                                    >
                                      <div class="list_title">
                                        <div class="documents_accordian_tile">
                                          <docType :item="forms" />
                                          <span
                                            @click="
                                              $store.commit('selectedForEditDocument', forms);
                                              fetchSignedUrl(forms);
                                            "
                                            ><em class="fl_scanned_docs" :title="forms.name">{{ forms.name }}
                                              <small class="support_letter_text"   v-if="false &&  forms['docUserType'] =='Beneficiary'">(Beneficiary)</small>
                                              <small class="support_letter_text"   v-if="false && forms['docUserType'] =='Dependent'">(Dependent)</small>
                                              <template v-if="forms['type']=='Letter' && forms['entityId'] ">
                                                <small class="support_letter_text" v-if="forms['type']=='Letter' && forms['entityId'] =='support_letter'">(Support Letter)</small>
                                                <small  class="support_letter_text" v-else>(Cover Letter)</small>
                                            </template>
                                              </em>
                                              <small>{{
                                              getformated(forms)
                                            }}</small></span
                                          >
                                        </div>
                                        <div class="d-flex align-center">
                                          <template
                                            v-if="
                                              (checkIsloginUserDoce ||
                                                checkIsloginUserDocm ||
                                                [3, 4].indexOf(getUserRoleId) > -1) &&
                                              checkProperty(getPetitionDetails, 'status') !=
                                                false
                                            "
                                          >
                                            <span
                                              style="margin-right: 30px"
                                              :class="{
                                                status_pending: forms.statusId == 1,
                                                status_active: forms.statusId == 2,
                                                status_rejected: forms.statusId == 3,
                                              }"
                                            >
                                              <template
                                                v-if="checkProperty(forms, 'statusId') == 1"
                                                >Pending</template
                                              >
                                              <template
                                                v-if="checkProperty(forms, 'statusId') == 2"
                                                >Approved</template
                                              >
                                              <template
                                                v-if="checkProperty(forms, 'statusId') == 3"
                                                >Rejected</template
                                              >
                                            </span>
                                          </template>
                                          <div class="vertical-menu">
                                            <span class="menu-icon">
                                              <i class="material-icons">more_vert</i>
                                            </span>
                                            <ul>
                                              <!-- !checkSubmitToUscisCompleted && -->
                                              <li
                                                v-if="
                                                  [50, 51].indexOf(currentRole) < 0 &&
                                                  
                                                  checkProperty(
                                                    getPetitionDetails,
                                                    'status'
                                                  ) != false
                                                "
                                                @click="selDoc(forms.mainParentId, forms)"
                                              >
                                                Upload
                                              </li>
                                              <li @click="fetchSignedUrl(forms, false, true)">
                                                View
                                              </li>
                                              <!-- <li
                                                  v-if="(!checkProperty(forms, 'ptnrOrBnfSignComplted')) && currentRole == 51 &&
                                                    checkProperty(
                                                      getPetitionDetails,
                                                      'status'
                                                    ) != false"
                                                    @click="handleSignForms(forms)">
                                                  Sign
                                                  </li> -->
                                              <!-- !isSubmitUscisCompleted && -->
                                              <li
                                                v-if="
                                                
                                                checkProperty(forms, 'statusId') == 2 &&
                                                  [50, 51].indexOf(currentRole) < 0 &&
                                                  
                                                  checkProperty(
                                                    getPetitionDetails,
                                                    'status'
                                                  ) != false
                                                "
                                                @click="editDocument(forms)"
                                              >
                                                Edit
                                              </li>
                                              <!-- <li @click="fetchSignedUrl(forms, true)">
                                                Download
                                              </li> -->
                                              <li @click="download_or_view(forms)">
                                                Download
                                              </li>
                                              <template v-if="isEnableApproveRejMenu">
                                              <li
                                                v-if="
                                                  forms.statusId == 1 &&
                                                  (checkDocM ||
                                                    [3, 4].indexOf(getUserRoleId) > -1)
                                                "
                                                @click="
                                                  openApproveOrRejectDocs(
                                                    'APPROVED_BY_DOC_MANAGER'
                                                  )
                                                "
                                              >
                                                Approve
                                              </li>
                                              <li
                                                v-if="
                                                  forms.statusId == 1 &&
                                                  (checkDocM ||
                                                    [3, 4].indexOf(getUserRoleId) > -1)
                                                "
                                                @click="
                                                  openApproveOrRejectDocs(
                                                    'REJECT_BY_DOC_MANAGER'
                                                  )
                                                "
                                              >
                                                Reject
                                              </li>
                                            </template>
                                              <li
                                                v-if="([3].indexOf(getUserRoleId)>-1 || IsAdminUser) && checkProperty( getPetitionDetails, 'status'  ) != false "
                                                @click="openConformPopUp(forms)"
                                              >
                                                Delete
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                    </template>
                                  </vs-collapse-item>
                                </div> 
                                </template>  
                              </template>
                            </vs-collapse>
                          </div>
                        

                        </vs-card>
                      </div>
                    
                      
                    </template>
                    
                  
                  </div>
                      </template>

                    
                    </template>

                  </template>
                

                </template>
                <template v-else>
                  <template v-if="showChildForms">
                    <template v-for="( child ,ind) in petition.dependentsInfo.childrens">
                    <div :label="'Forms'" >
                      <vs-card class="no-card FL-height">
                        <div
                          v-if="formsAndLettersList.length > 0"
                          class="forms_accordian forms_accordian-v2 hidedropdown marb10"
                        >
                          <div
                            v-if="
                            ( (([3, 4].indexOf(getUserRoleId) > -1 || checkDocM) && checkActiveList) 
                            ||
                            (!([3, 4].indexOf(getUserRoleId) > -1 || checkDocM) && checkActiveList))
                            "
                          >
                            <vs-list-item class="cards-list-heading">
                              
                              <h2>
                                <template  >{{'Child '+(ind+1)+' Forms and Letters'}}</template>
                              
                              </h2>
                              <div class="d-flex">
                                  <span
                                  v-if="
                                  checkProperty(getPetitionDetails, 'status') != false &&
                                  [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].indexOf(
                                    getUserRoleId
                                  ) > -1 &&
                                  (checkIsActiveUser || IsAdminUser)
                                "
                                  class="download-all mr-3" 
                                  @click="
                                  depType ='child';depLabel ='child_'+ind;docUserType ='Dependent';
                                  showDocType=true;
                                  fuploder = false;
                                  parentId = '';
                                  entityIdDetails =null;entityId=''
                                  fileuploadPopup = true;
                                  (formerrors.msg = ''),
                                    (uploadMainDocuments = []),
                                    (uploadFinalMainDocuments = []);
                                    resetForms()
                                "
                                  >
                                    Upload
                                    <img src="@/assets/images/main/upload.svg" />
                                </span>
                            </div>
                            </vs-list-item>
                          </div>
                          <template>
                            <NoDataFound ref="NoDataFoundRef" :checkLocading="false" :loading="false" content="" heading="No Documents Found." type='documents' />
                            </template>
                        </div>
                      </vs-card>
                    </div>
                  </template>
                  </template>
                </template>
                
              </template>

               <!----PreviousVersions Section---->
               <div
                v-if="previousVersionAfteruscisList.length > 0 && checkUscisRevisionDocuments('') && checkSubmitToUscisCompleted "
                class="forms_accordian forms_accordian-v2" :class="{'show':showUscisPreviousVersions ,'hide':!showUscisPreviousVersions}"
              >

              <h2 class="pervious-versions-title 1" :class="{'show':showUscisPreviousVersions ,'hide':!showUscisPreviousVersions}" @click="toggleUscisPreviousVersions()"
                  
              >
              <span>Previous Versions - submitted to USCIS</span>
              <img src="@/assets/images/icons/black_arrow.svg">
                <!--{{formLetterType+'s'}}-->
              </h2>
              <vs-collapse accordion class="forms-letters-accordian prev-no-accordian" >
                  <template v-for="(forms, index) in previousVersionAfteruscisList">
                    
                    <template class="no-accordian"
                      v-if="
                      
                        checkProperty(
                          forms,
                          'reverse_document_versions',
                          'length'
                        ) > 0
                      "
                    >
                      <vs-collapse-item
                        :class="{
                          closeDropdown: currentRole == 50,
                          'no-list':
                            checkProperty(forms, 'reverse_document_versions') &&
                            forms['reverse_document_versions'].length <= 1,
                        }"
                        :not-arrow="
                          !(
                            checkProperty(forms, 'reverse_document_versions') &&
                            forms['reverse_document_versions'].length >= 0
                          )
                        "
                        :key="index"
                      >
                        <div slot="header" class="ss">
                          <vs-list-item class="documents_accordian">
                          </vs-list-item>
                        </div>

                        <template
                          v-if="checkProperty(forms, 'reverse_document_versions')"
                        >
                          <div class="list_title">
                            <div class="documents_accordian_tile">
                              <docType
                                :item="forms['reverse_document_versions'][0]"
                              />
                              <span
                                @click="
                                  fetchSignedUrl(
                                    forms['reverse_document_versions'][0]
                                  )
                                "
                              >
                              <em class="fl_scanned_docs" :title='checkProperty(forms["reverse_document_versions"][0],"name")'>{{
                                  checkProperty(
                                    forms["reverse_document_versions"][0],
                                    "name"
                                  )
                                }}<small class="support_letter_text" 
                                      v-if=" forms['docUserType'] =='Beneficiary'">(Beneficiary)</small>
                                
                                  <small class="support_letter_text" 
                                      v-if=" forms['docUserType'] =='Dependent'">(Dependent)</small>
                                </em>
                                <small>{{
                                  getformated(
                                    forms["reverse_document_versions"][0]
                                  )
                                }}</small></span
                              >
                            </div>
                            <div class="d-flex align-center">
                            
                              <div class="vertical-menu">
                                <span class="menu-icon">
                                  <i class="material-icons">more_vert</i>
                                </span>
                                <ul>
                                  <!-- !checkSubmitToUscisCompleted && -->
                                  <li
                                    v-if="
                                      [50, 51].indexOf(currentRole) < 0 &&
                                      
                                      checkProperty(
                                        getPetitionDetails,
                                        'status'
                                      ) != false
                                    "
                                    @click="
                                      selectedDocument = forms;
                                      restoreDocument(
                                        forms.mainParentId,
                                        forms['reverse_document_versions'][0]
                                      );
                                    "
                                  >
                                    Restore
                                  </li>
                                  <li
                                    @click="
                                      fetchSignedUrl(
                                        forms['reverse_document_versions'][0],
                                        false,
                                        true
                                      )
                                    "
                                  >
                                    View
                                  </li>
                              
                                </ul>
                              </div>
                            </div>
                          </div>
 
                          <template
                            v-for="(reveforms, inde) in forms[
                              'reverse_document_versions'
                            ]"
                          >
                            <template v-if="inde > 0">
                              <vs-list-item
                                class="documents_accordian"
                                v-if="currentRole != 50"
                                :key="inde"
                              >
                                <div class="documents_accordian_tile">
                                  <docType :item="reveforms" />
                                  <span @click="fetchSignedUrl(reveforms)"
                                    >
                                    <em class="fl_scanned_docs" :title="reveforms.name">{{ reveforms.name }}</em>
                                    <!-- {{ reveforms.name }}<br /> -->
                                    <small>{{
                                      getformated(reveforms)
                                    }}</small></span
                                  >
                                </div>
                                <template
                                  v-if="
                                    (checkIsloginUserDoce ||
                                      checkIsloginUserDocm) &&
                                    checkProperty(getPetitionDetails, 'status') !=
                                      false
                                  "
                                >
                                
                                </template>
                                <div class="vertical-menu">
                                  <span class="menu-icon">
                                    <i class="material-icons">more_vert</i>
                                  </span>
                                  <ul>
                                    <li
                                      v-if="
                                        [50, 51].indexOf(currentRole) < 0 &&
                                        !checkSubmitToUscisCompleted &&
                                        checkProperty(
                                          getPetitionDetails,
                                          'status'
                                        ) != false
                                      "
                                      @click="
                                        selectedDocument = forms;
                                        restoreDocument(
                                          forms.mainParentId,
                                          reveforms
                                        );
                                      "
                                    >
                                      Restore
                                    </li>
                                    <li
                                      @click="
                                        fetchSignedUrl(reveforms, false, true)
                                      "
                                    >
                                      View
                                    </li>
                                    <!--<li @click="fetchSignedUrl(forms,true)">Download</li>-->
                                    <li
                                      v-if="([3].indexOf(getUserRoleId)>-1 || IsAdminUser) && checkProperty( getPetitionDetails, 'status' ) != false "
                                      @click="openConformPopUp(reveforms)"
                                    >
                                      Delete
                                    </li>
                                  </ul>
                                </div>

                                <!-- <span class="view_doc" @click="fetchSignedUrl(reveforms)">View</span>
                                                        <span class="view_doc"   v-if="reveforms['createdBy'] ==currentUser "  @click="openConformPopUp(reveforms)">Delete</span> -->
                              </vs-list-item>
                            </template>
                          </template>
                        </template>
                      </vs-collapse-item>
                    </template>
                  </template>
                </vs-collapse>
              </div>
              <div
                v-if="previousVersionList.length > 0 && checkRevisionDocuments('')"
                class="forms_accordian forms_accordian-v2" :class="{'show':showPreviousVersions ,'hide':!showPreviousVersions}"
              >

              <h2 class="pervious-versions-title 1" :class="{'show':showPreviousVersions ,'hide':!showPreviousVersions}" @click="togglePreviousVersions()"
                  
              >
              <span> Previous Versions</span>
              <img src="@/assets/images/icons/black_arrow.svg">
                <!--{{formLetterType+'s'}}-->
              </h2>
              <vs-collapse accordion class="forms-letters-accordian prev-no-accordian" >
                  <template v-for="(forms, index) in previousVersionList">
                    
                    <template class="no-accordian"
                      v-if="
                      
                        checkProperty(
                          forms,
                          'reverse_document_versions',
                          'length'
                        ) > 0
                      "
                    >
                      <vs-collapse-item
                        :class="{
                          closeDropdown: currentRole == 50,
                          'no-list':
                            checkProperty(forms, 'reverse_document_versions') &&
                            forms['reverse_document_versions'].length <= 1,
                        }"
                        :not-arrow="
                          !(
                            checkProperty(forms, 'reverse_document_versions') &&
                            forms['reverse_document_versions'].length >= 0
                          )
                        "
                        :key="index"
                      >
                        <div slot="header" class="ss">
                          <vs-list-item class="documents_accordian">
                          </vs-list-item>
                        </div>

                        <template
                          v-if="checkProperty(forms, 'reverse_document_versions')"
                        >
                          <div class="list_title">
                            <div class="documents_accordian_tile">
                              <docType
                                :item="forms['reverse_document_versions'][0]"
                              />
                              <span
                                @click="
                                  fetchSignedUrl(
                                    forms['reverse_document_versions'][0]
                                  )
                                "
                              >
                              <em class="fl_scanned_docs" :title='checkProperty(forms["reverse_document_versions"][0],"name")'>{{
                                  checkProperty(
                                    forms["reverse_document_versions"][0],
                                    "name"
                                  )
                                }}<small class="support_letter_text" 
                                      v-if=" forms['docUserType'] =='Beneficiary'">(Beneficiary)</small>
                                
                                  <small class="support_letter_text" 
                                      v-if=" forms['docUserType'] =='Dependent'">(Dependent)</small>
                                </em>
                                <small>{{
                                  getformated(
                                    forms["reverse_document_versions"][0]
                                  )
                                }}</small></span
                              >
                            </div>
                            <div class="d-flex align-center">
                            
                              <div class="vertical-menu">
                                <span class="menu-icon">
                                  <i class="material-icons">more_vert</i>
                                </span>
                                <ul>
                                  <li
                                    v-if="
                                      [50, 51].indexOf(currentRole) < 0 &&
                                      !checkSubmitToUscisCompleted &&
                                      checkProperty(
                                        getPetitionDetails,
                                        'status'
                                      ) != false
                                    "
                                    @click="
                                      selectedDocument = forms;
                                      restoreDocument(
                                        forms.mainParentId,
                                        forms['reverse_document_versions'][0]
                                      );
                                    "
                                  >
                                    Restore
                                  </li>
                                  <li
                                    @click="
                                      fetchSignedUrl(
                                        forms['reverse_document_versions'][0],
                                        false,
                                        true
                                      )
                                    "
                                  >
                                    View
                                  </li>
                              
                                </ul>
                              </div>
                            </div>
                          </div>
 
                          <template
                            v-for="(reveforms, inde) in forms[
                              'reverse_document_versions'
                            ]"
                          >
                            <template v-if="inde > 0">
                              <vs-list-item
                                class="documents_accordian"
                                v-if="currentRole != 50"
                                :key="inde"
                              >
                                <div class="documents_accordian_tile">
                                  <docType :item="reveforms" />
                                  <span @click="fetchSignedUrl(reveforms)"
                                    >
                                    <em class="fl_scanned_docs" :title="reveforms.name">{{ reveforms.name }}</em>
                                    <!-- {{ reveforms.name }}<br /> -->
                                    <small>{{
                                      getformated(reveforms)
                                    }}</small></span
                                  >
                                </div>
                                <template
                                  v-if="
                                    (checkIsloginUserDoce ||
                                      checkIsloginUserDocm) &&
                                    checkProperty(getPetitionDetails, 'status') !=
                                      false
                                  "
                                >
                                
                                </template>
                                <div class="vertical-menu">
                                  <span class="menu-icon">
                                    <i class="material-icons">more_vert</i>
                                  </span>
                                  <ul>
                                    <li
                                      v-if="
                                        [50, 51].indexOf(currentRole) < 0 &&
                                        !checkSubmitToUscisCompleted &&
                                        checkProperty(
                                          getPetitionDetails,
                                          'status'
                                        ) != false
                                      "
                                      @click="
                                        selectedDocument = forms;
                                        restoreDocument(
                                          forms.mainParentId,
                                          reveforms
                                        );
                                      "
                                    >
                                      Restore
                                    </li>
                                    <li
                                      @click="
                                        fetchSignedUrl(reveforms, false, true)
                                      "
                                    >
                                      View
                                    </li>
                                    <!--<li @click="fetchSignedUrl(forms,true)">Download</li>-->
                                    <li
                                      v-if="
                                         ([3].indexOf(getUserRoleId)>-1 || IsAdminUser) &&  checkProperty( getPetitionDetails, 'status' ) != false "
                                      @click="openConformPopUp(reveforms)"
                                    >
                                      Delete
                                    </li>
                                  </ul>
                                </div>

                                <!-- <span class="view_doc" @click="fetchSignedUrl(reveforms)">View</span>
                                                        <span class="view_doc"   v-if="reveforms['createdBy'] ==currentUser "  @click="openConformPopUp(reveforms)">Delete</span> -->
                              </vs-list-item>
                            </template>
                          </template>
                        </template>
                      </vs-collapse-item>
                    </template>
                  </template>
                </vs-collapse>
              </div>
              
            
           </template>
           <template v-else-if=" checkProperty(petition, 'subTypeDetails', 'id') == 15 && formsAndLettersList.length >0">
           
            <div class="forms_letters dd forms_letters-v2" @click="docUserType='Beneficiary'">
              
            
              <div   
                label="Audit Response"
                
              >
                <vs-card class="no-card FL-height">
                  <template
                    v-if="
                      ([3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].indexOf(getUserRoleId) >
                        -1 &&
                        !checkrequestSigninActivityCompleted) ||
                      ([3, 4, 5, 6, 7, 8, 9, 10, 11, 12].indexOf(getUserRoleId) > -1 &&
                        !checkrequestSigninActivityCompleted)
                    "
                  >
                    <div class="pd_upload_actions">
                      <template v-if="(checkProperty(petition,'intStatusDetails','id')==1 ) && (checkActionButton ||  checkUserAccessBtn || IsAdminUser) && checkNoNotifyUserIds">
                     
                      
                      <template
                        v-if="
                          [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].indexOf(getUserRoleId) >
                            -1 &&
                          !checkrequestSigninActivityCompleted &&
                          checkProperty(getPetitionDetails, 'status') != false
                        "
                      >
                        <div class="generate_sec ml-auto">


                          <span
                            class="primary-btn"
                            @click="
                              openGenerateFormsLattersPopup();
                              copyingData();
                            "
                            v-if="
                              [
                                'DOL_SUPERVISORY_AUDIT',
                                'SUBMIT_TO_DOL',
                                'DOL_APPROVED',
                                'DOL_RECEIVED_RFE',
                                'DOL_DENIED',
                                'DOL_WITHDRAWN',
                              ].indexOf(petition.curWorkflowActivity) <= -1
                            "
                          >
                            <figure
                              v-if="generatingFiles || loadingFormLatters"
                              class="loader loader2"
                            >
                              <img src="@/assets/images/main/loader.gif" />
                            </figure>
                            Generate
                          </span>
                        </div>
                      </template>
                    </template>
                    </div>
                  </template>

                  <div
                    v-if="formsAndLettersList.length > 0"
                    class="forms_accordian forms_accordian-v2 hidedropdown marb10"
                  >
                    <vs-list-item class="cards-list-heading">
                      <h2>
                        <template
                          v-if="
                            checkProperty(petition, 'typeDetails', 'id') == 3 &&
                            checkProperty(petition, 'subTypeDetails', 'id') == 15
                          "
                        >
                          Audit Response
                        </template>
                        <template v-else> 
                          Beneficiary Forms and Letters
                        </template>
                      </h2>
                      
                        <div class="d-flex">
                          <template v-if="(checkProperty(petition,'intStatusDetails','id')==1 ) && (checkActionButton ||  checkUserAccessBtn || IsAdminUser) && checkNoNotifyUserIds">
                    
                                <span
                                v-if="
                          [
                            'DOL_SUPERVISORY_AUDIT',
                            'SUBMIT_TO_DOL',
                            'DOL_APPROVED',
                            'DOL_RECEIVED_RFE',
                            'DOL_DENIED',
                            'DOL_WITHDRAWN',
                          ].indexOf(petition.curWorkflowActivity) <= -1 &&
                          checkProperty(getPetitionDetails, 'status') != false &&
                          [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].indexOf(getUserRoleId) >
                            -1 &&
                          !checkrequestSigninActivityCompleted
                        "
                                 class="download-all mr-3" 
                                 @click="
                                 formLetterType='Audit Response';
                                 updateFormat();
                                 showDocType=true;
                          fuploder = false;
                          parentId = '';
                          entityIdDetails =null;entityId='';
                          fileuploadPopup = true;

                          (formerrors.msg = ''),
                            (uploadMainDocuments = []),
                            (uploadFinalMainDocuments = []);
                            resetForms()
                        "
                                 >
                                  Upload
                                  <img src="@/assets/images/main/upload.svg" />
                              </span>
                        
                          </template>


                      <span class="download-all" @click="openDownloadPopup(true)">
                        Download
                        <img src="@/assets/images/main/download.svg" />
                      </span>
                    </div>
                    </vs-list-item>

                    <vs-collapse accordion class="forms-letters-accordian">
                      <template v-for="(forms, index) in formsAndLettersList">
                        <!-- v-if="(currentRole ==12 && forms.selectedForSigning ) || currentRole !=12 "-->
                        <vs-collapse-item
                       
                          :class="{
                            closeDropdown: currentRole == 50,
                            'no-list':
                              checkProperty(forms, 'reverse_document_versions') &&
                              forms['reverse_document_versions'].length == 0,
                          }"
                          :not-arrow="
                            !(
                              checkProperty(forms, 'reverse_document_versions') &&
                              forms['reverse_document_versions'].length >= 0
                            )
                          "
                          :key="index"
                        >
                          <div slot="header" class="ss">
                            <vs-list-item class="documents_accordian"> </vs-list-item>
                          </div>

                          <template
                            v-if="
                              checkProperty(forms, 'name') ||
                              (checkProperty(forms, 'reverse_document_versions') &&
                                [50, 51].indexOf(getUserRoleId) <= -1)
                            "
                          >
                            <div class="list_title" @click="changeTab('Audit Response' ,forms ,'Beneficiary')">
                              <div class="documents_accordian_tile">
                                <docType :item="forms" />
                                <span @click="fetchSignedUrl(forms)"
                                  >
                                  <em class="fl_scanned_docs" :title="forms.name">{{ forms.name }}<small class="support_letter_text" 
                                              v-if="forms['type']=='Audit Response' && forms['docUserType'] =='Beneficiary'">(Beneficiary)</small><small class="support_letter_text" 
                                              v-if="forms['type']=='Audit Response' && forms['docUserType'] =='Dependent'">(Dependent)</small>
                                  </em>
                                  <!-- {{ forms.name }}<br /> -->
                                  <small>{{
                                    getformated(forms)
                                  }}</small></span
                                >
                              </div>
                              <div class="d-flex align-center">
                                <template
                                  v-if="
                                    (checkIsloginUserDoce || checkIsloginUserDocm) &&
                                    checkProperty(getPetitionDetails, 'status') != false
                                  "
                                >
                                  <span
                                    style="margin-right: 30px"
                                    :class="{
                                      status_pending: forms.statusId == 1,
                                      status_active: forms.statusId == 2,
                                      status_rejected: forms.statusId == 3,
                                    }"
                                  >
                                    <template
                                      v-if="checkProperty(forms, 'statusId') == 1"
                                      >Pending</template
                                    >
                                    <template
                                      v-if="checkProperty(forms, 'statusId') == 2"
                                      >Approved</template
                                    >
                                    <template
                                      v-if="checkProperty(forms, 'statusId') == 3"
                                      >Rejected</template
                                    >
                                  </span>
                                </template>
                                <div class="vertical-menu">
                                  <span class="menu-icon">
                                    <i class="material-icons">more_vert</i>
                                  </span>
                                  <ul>
                                    <li
                                      v-if="
                                        [
                                          'DOL_SUPERVISORY_AUDIT',
                                          'SUBMIT_TO_DOL',
                                          'DOL_APPROVED',
                                          'DOL_RECEIVED_RFE',
                                          'DOL_DENIED',
                                          'DOL_WITHDRAWN',
                                        ].indexOf(petition.curWorkflowActivity) <= -1 &&
                                        [50, 51].indexOf(currentRole) < 0 &&
                                        !checkrequestSigninActivityCompleted &&
                                        checkProperty(getPetitionDetails, 'status') !=
                                          false
                                      "
                                      @click="selDoc(forms.mainParentId, forms)"
                                    >
                                      Upload
                                    </li>

                                    <li @click="fetchSignedUrl(forms, false, true)">
                                      View
                                    </li>
                                    <!-- !isSubmitUscisCompleted && -->
                                    <li
                                      v-if="
                                      checkProperty(forms, 'statusId') == 2 &&
                                        [
                                          'DOL_SUPERVISORY_AUDIT',
                                          'SUBMIT_TO_DOL',
                                          'DOL_APPROVED',
                                          'DOL_RECEIVED_RFE',
                                          'DOL_DENIED',
                                          'DOL_WITHDRAWN',
                                        ].indexOf(petition.curWorkflowActivity) <= -1 &&
                                        [50, 51].indexOf(currentRole) < 0 &&
                                        
                                        checkProperty(getPetitionDetails, 'status') !=
                                          false
                                          "
                                          @click="editDocument(forms)"
                                    >
                                      Edit
                                    </li>
                                    <li  @click="downloads3file(forms)">
                                      Download
                                    </li>
                                    <li
                                      v-if="
                                        [
                                          'DOL_SUPERVISORY_AUDIT',
                                          'SUBMIT_TO_DOL',
                                          'DOL_APPROVED',
                                          'DOL_RECEIVED_RFE',
                                          'DOL_DENIED',
                                          'DOL_WITHDRAWN',
                                        ].indexOf(petition.curWorkflowActivity) <= -1 && 
                                        ((forms['createdBy'] == currentUser) || [3].indexOf(getUserRoleId)>-1 || IsAdminUser)  &&
                                        checkProperty(getPetitionDetails, 'status') !=
                                          false
                                      "
                                      @click="openConformPopUp(forms)"
                                    >
                                      Delete
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </template>
                        </vs-collapse-item>
                      </template>
                    </vs-collapse>
                  </div>

                  <!----PreviousVersions Section---->

                  <div
                    v-if="previousVersionList.length > 0 && checkRevisionDocuments('')"
                    class="forms_accordian forms_accordian-v2" :class="{'show':showPreviousVersions ,'hide':!showPreviousVersions}"
                  >
                  <h2 class="pervious-versions-title 2" :class="{'show':showPreviousVersions ,'hide':!showPreviousVersions}"  @click="togglePreviousVersions()"
                        
                  >
                   <span> Previous Versions</span>
                   <img src="@/assets/images/icons/black_arrow.svg">
                     <!--{{formLetterType+'s'}}-->
                  </h2>

                    <vs-collapse accordion class="forms-letters-accordian prev-no-accordian" v-if="showPreviousVersions" >
                      <template v-for="(forms, index) in previousVersionList">
                        <template
                          v-if="
                            checkProperty(
                              forms,
                              'reverse_document_versions',
                              'length'
                            ) > 0
                          "
                        >
                          <vs-collapse-item
                            :class="{
                              closeDropdown: currentRole == 50,
                              'no-list':
                                checkProperty(forms, 'reverse_document_versions') &&
                                forms['reverse_document_versions'].length <= 1,
                            }"
                            :not-arrow="
                              !(
                                checkProperty(forms, 'reverse_document_versions') &&
                                forms['reverse_document_versions'].length >= 0
                              )
                            "
                            :key="index"
                          >
                            <div slot="header" class="ss">
                              <vs-list-item class="documents_accordian"> </vs-list-item>
                            </div>

                            <template
                              v-if="checkProperty(forms, 'reverse_document_versions')"
                            >
                              <div class="list_title">
                                <div class="documents_accordian_tile">
                                  <docType
                                    :item="forms['reverse_document_versions'][0]"
                                  />
                                  <span
                                    @click="
                                      fetchSignedUrl(
                                        forms['reverse_document_versions'][0]
                                      )
                                    "
                                  >
                                  <em class="fl_scanned_docs" :title='checkProperty(forms["reverse_document_versions"][0],"name")'>
                                    {{
                                      checkProperty(
                                        forms["reverse_document_versions"][0],
                                        "name"
                                      )
                                    }}<small class="support_letter_text" 
                                              v-if=" forms['docUserType'] =='Beneficiary'">(Beneficiary)</small><small class="support_letter_text" 
                                              v-if=" forms['docUserType'] =='Dependent'">(Dependent)</small>
                                  </em>
                                    <!-- {{
                                      checkProperty(
                                        forms["reverse_document_versions"][0],
                                        "name"
                                      )
                                    }}<br /> -->
                                    <small>{{
                                      getformated(forms["reverse_document_versions"][0])
                                    }}</small></span
                                  >
                                </div>
                                <div class="d-flex align-center">
                                  <!---
                                                      <template v-if="(checkIsloginUserDoce || checkIsloginUserDocm ) && checkProperty(getPetitionDetails ,'status' )!=false">
                                                          <span  style="margin-right:30px"  :class="{'status_pending':forms.statusId==1,'status_active':forms.statusId==2,'status_rejected':forms.statusId==3}" >
                                                              <template v-if="checkProperty(forms ,'statusId') ==1">Pending</template>
                                                              <template v-if="checkProperty(forms ,'statusId') ==2">Approved</template>
                                                              <template v-if="checkProperty(forms ,'statusId') ==3">Rejected</template>
                                                          </span>
                                                      </template>
                                                      -->
                                  <div class="vertical-menu">
                                    <span class="menu-icon">
                                      <i class="material-icons">more_vert</i>
                                    </span>
                                    <ul>
                                      <li
                                        v-if="
                                          [50, 51].indexOf(currentRole) < 0 &&
                                          !checkrequestSigninActivityCompleted &&
                                          checkProperty(getPetitionDetails, 'status') !=
                                            false
                                        "
                                        @click="
                                          selectedDocument = forms;
                                          restoreDocument(
                                            forms.mainParentId,
                                            forms['reverse_document_versions'][0]
                                          );
                                        "
                                      >
                                        Restore
                                      </li>
                                      <li
                                        @click="
                                          fetchSignedUrl(
                                            forms['reverse_document_versions'][0],
                                            false,
                                            true
                                          )
                                        "
                                      >
                                        View
                                      </li>
                                      <!----
                                                              <li v-if="[50,51].indexOf(currentRole) < 0 && !checkrequestSigninActivityCompleted && checkProperty(getPetitionDetails ,'status' )!=false" @click="editDocument(forms)">Edit </li>
                                                              <li @click="fetchSignedUrl(forms,true)">Download</li> 
                                                              <li v-if="forms['createdBy'] ==currentUser && checkProperty(getPetitionDetails ,'status' )!=false "  @click="openConformPopUp(forms)">Delete</li>
                                                              -->
                                    </ul>
                                  </div>
                                </div>
                              </div>

                              <template
                                v-for="(reveforms, inde) in forms[
                                  'reverse_document_versions'
                                ]"
                              >
                                <template v-if="inde > 0">
                                  <vs-list-item
                                    class="documents_accordian"
                                    v-if="currentRole != 50"
                                    :key="inde"
                                  >
                                    <div class="documents_accordian_tile">
                                      <docType :item="reveforms" />
                                      <span @click="fetchSignedUrl(reveforms)"
                                        >
                                        <em class="fl_scanned_docs" :title="reveforms.name">{{ reveforms.name }}</em>
                                        <!-- {{ reveforms.name }}<br /> -->
                                        <small>{{
                                          getformated(reveforms)
                                        }}</small></span
                                      >
                                    </div>
                                    <template
                                      v-if="
                                        (checkIsloginUserDoce ||
                                          checkIsloginUserDocm) &&
                                        checkProperty(getPetitionDetails, 'status') !=
                                          false
                                      "
                                    >
                                      <!-- <span  style="margin-right:30px"  :class="{'status_pending':reveforms.statusId==1,'status_active':reveforms.statusId==2,'status_rejected':reveforms.statusId==3}" >
                                                          <template v-if="checkProperty(reveforms ,'statusId') ==1">Pending</template>
                                                          <template v-if="checkProperty(reveforms ,'statusId') ==2">Approved</template>
                                                          <template v-if="checkProperty(reveforms ,'statusId') ==3">Rejected</template>
                                                      </span> -->
                                    </template>
                                    <div class="vertical-menu">
                                      <span class="menu-icon">
                                        <i class="material-icons">more_vert</i>
                                      </span>
                                      <ul>
                                        <li
                                          v-if="
                                            [50, 51].indexOf(currentRole) < 0 &&
                                            !checkrequestSigninActivityCompleted &&
                                            checkProperty(
                                              getPetitionDetails,
                                              'status'
                                            ) != false
                                          "
                                          @click="
                                            selectedDocument = forms;
                                            restoreDocument(
                                              forms.mainParentId,
                                              reveforms
                                            );
                                          "
                                        >
                                          Restore
                                        </li>
                                        <li
                                          @click="
                                            fetchSignedUrl(reveforms, false, true)
                                          "
                                        >
                                          View
                                        </li>
                                        <!--<li @click="fetchSignedUrl(forms,true)">Download</li>-->
                                        <li
                                          v-if="
                                            ([3].indexOf(getUserRoleId)>-1 || IsAdminUser || (reveforms['createdBy'] == currentUser)) && 
                                            checkProperty(
                                              getPetitionDetails,
                                              'status'
                                            ) != false
                                          "
                                          @click="openConformPopUp(reveforms)"
                                        >
                                          Delete
                                        </li>
                                      </ul>
                                    </div>

                                    <!-- <span class="view_doc" @click="fetchSignedUrl(reveforms)">View</span>
                                                      <span class="view_doc"   v-if="reveforms['createdBy'] ==currentUser "  @click="openConformPopUp(reveforms)">Delete</span> -->
                                  </vs-list-item>
                                </template>
                              </template>
                            </template>
                          </vs-collapse-item>
                        </template>
                      </template>
                    </vs-collapse>
                  </div>
                  <!--
                              <paginate  v-if="formsAndLettersList.length>0"  v-model="page" :page-count="totalpages" :page-range="3" :margin-pages="2" :click-handler="pageNate"
                              prev-class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
                              next-class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next" :prev-text="'<i></i>'"
                              :next-text="'<i></i>'" :container-class="'pagination vs-pagination--nav'" :page-class="'page-item'"></paginate>
                              -->
                  
                </vs-card>
              </div>
            
          </div>

           </template>
           <template v-if="(formsAndLettersList.length >0 && (  checkProperty(petition, 'subTypeDetails', 'id') != 15 && !checkFormsAndLetters('spouse') && !checkFormsAndLetters('child') && !checkFormsAndLetters('beneficiary') ))">
          
           <NoDataFound
                          ref="NoDataFoundReff"
                          :content="getContent()"
                          heading="No Documents Found."
                          type="documents"
                          :loading:="false"
                        />
            </template>

          </vs-col>
        </vs-row>
      </div>
    </div>

    <vs-popup
      class="Change_petition_wrap"
      title="Download Forms"
      :active.sync="downloadSamplespopup"
    >
      <div class="Change_petition">
        <div class="vx-col w-full marb10">
          <ul class="downloads_list">
            <li v-for="(typ, index) in types" :key="index">
              <p>{{ typ.name }}</p>
              <span>Download</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="actions_footer">
        <button @click="downloadSamplespopup = false" class="btn cancel">Cancel</button>
      </div>
    </vs-popup>
    <!----formLetterType:'Letter', //'Form', --->
    <vs-popup
      class="Change_petition_wrap documents_modal_popup"
      :title="
        checkProperty(petition, 'subTypeDetails', 'id') == 15
          ? 'Upload Audit Response'
          : 'Upload Forms and Letters'
      "
      :active.sync="fileuploadPopup"
    >
      <div class="Change_petition upload_letter_others" >
        <fileUploadNote :fileNote="true" />
        <div class="vx-col w-full">
         
          <!----- // this.formLetterType = "Form"; //this.formLetterType = "Letter";-->
          <template v-if="checkProperty(petition, 'subTypeDetails', 'id') != 15">
          <div class="vx-row form-container pad0"   v-if="showDocType">
            <div class="custom-radio_wrap wf_radio">
              <label class="form_label pb-1 pl-4">Document Type<em >*</em></label>
              
              <ul class="custom-radio mb-1" >
               
                 <li> 
                  <vs-radio @input="formerrors.msg = '';updateFormat()"  name="documentType"  vs-value="Form" v-model="formLetterType" class="w-full" >Forms</vs-radio>
                 </li>
                  <li>
                     <vs-radio @input="formerrors.msg = '';updateFormat()"  name="documentType"   vs-value="Letter"  v-model="formLetterType" class="w-full" >Letters</vs-radio>
                   </li>
             </ul>
            </div>
            <span  class="text-danger text-sm"  v-show="showTypeIdError">Document Type is required</span>
          </div>
          <div class="vx-row form-container pad0"  @click="showTypeIdError=false" v-if="checkProperty(petition, 'subTypeDetails', 'id') == 15 && checkProperty(petitionDetails,'beneficiaryInfo','maritalStatus' ) !=1 &&   checkProperty(petitionDetails['dependentsInfo'] ,'spouse', 'h4Required')==true">
            <div class="custom-radio_wrap wf_radio">
              <label class="form_label pb-1 pl-4">Upload For<em >*</em></label>
              
              <ul class="custom-radio mb-1" >
               
                 <li> 
                  <vs-radio  name="docUserType" @change="changedBeneficiarycheck" vs-value="Beneficiary" v-model="docUserType" class="w-full" >Beneficiary</vs-radio>
                 </li>
                  <li>
                     <vs-radio  name="docUserType" @change="changedBeneficiarycheck"  vs-value="Dependent"  v-model="docUserType" class="w-full" >Dependent</vs-radio>
                   </li>
             </ul>
            </div>
            <span  class="text-danger text-sm"  v-show="showTypeIdError">Document Type is required</span>
          </div>
          <div class="vx-row form-container pad0 mt-3"  v-if="formLetterType=='Letter'">
              <div class="custom-radio_wrap wf_radio" @click="showentityIdError=''">
              <label class="form_label pb-1 pl-4">Letter Type<em >*</em></label>
              <!----entityIds:[{"id":"'cover_letter'" ,"name":"Cover Letter"},{"id":'support_letter' ,"name":'Support Letter'}],
   -->
              <ul class="custom-radio mb-3">
                
                 <li> 
                  <vs-radio   name="entity_id" @input="changedBeneficiarycheck" vs-value="cover_letter" v-model="entityId" class="w-full" >Cover Letter</vs-radio>
                 </li>
                  <li>
                     <vs-radio  name="entity_id" @input="changedBeneficiarycheck" vs-value="support_letter"  v-model="entityId" class="w-full" >Support Letter</vs-radio>
                   </li>
             </ul>
             <span  class="text-danger text-sm ml-3"  v-show="showentityIdError"  >Letter Type is required</span>
            </div>
          </div>

          <div class="vx-row form-container pad0"  v-if="false &&formLetterType=='Letter'" @click="showTypeIdError=false">
            <div class="custom-radio_wrap wf_radio">
              <label class="form_label pb-3 pl-4">Letter Type<em >*</em></label>
              <!----- entityIds:[{"id":"'cover_letter'" ,"name":"Cover Letter"},{"id":'support_letter' ,"name":'Support Letter'}],-->
              <ul class="custom-radio mb-1">
                 <li> 
                  <vs-radio  name="docUserType" @change="changedBeneficiarycheck" vs-value="cover_letter" v-model="entityId" class="w-full" >Cover Letter</vs-radio>
                 </li>
                  <li>
                     <vs-radio  name="docUserType" @change="changedBeneficiarycheck"  vs-value="support_letter"  v-model="entityId" class="w-full" >Support Letter</vs-radio>
                   </li>
             </ul>
            </div>
            <span  class="text-danger text-sm"  v-show="showentityIdError">Letter Type is required</span>
          </div>   
        </template>      
          <div class="vx-row">
            <div class="vx-col w-full">
              <vx-input-group class="form-input-group select-upload-group">
                <div class="uploadsec_wrap">
                  <div class="w-full">
                    <div @click="uploadMainDocuments = []">
                      <file-upload
                        v-model="uploadMainDocuments"
                        :accept="acceptedFiles"
                        class="file-upload-input mb-0"
                        style="height: 50px; padding: 0px"
                        :name="'pdocuments'"
                        :multiple="true"
                        :hideSelected="true"
                        v-validate="'required'"
                        label="Forms and Letters"
                        data-vv-as="Forms and Letters"
                        :emitCategory="'pdocuments'"  @updateData="updateData"
                        :depType="depType"
                        :depLabel="depLabel"
                        :docUserType="docUserType"
                        :formLetterType="formLetterType"
                        :ref="'fileUploadComponent'"
                        :fieldName="'pdocuments'"  :cid="'pdocuments'"
                      >
                      <!--
                        @input="uploadToS3MainDocuments(uploadMainDocuments)" -->
                        <img
                          class="file-icon"
                          src="@/assets/images/main/file-upload.svg"
                        />
                        Upload
                      </file-upload>
                      <span class="file-type mb-0" v-if="formLetterType == 'Form'"
                        >(File Type: PDF, Max file size: 200MB)</span
                      >
                      <span class="file-type mb-0" v-else-if="formLetterType == 'Letter'"
                        >(File Type: DOC, Max file size: 200MB)</span
                      >
                      <span class="file-type mb-0" v-else
                        >(File Type: DOC Max file size: 200MB)</span
                      >
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('pdocuments')"
                        >{{ errors.first("documents" + index) }}</span
                      >
                    </div>

                    <VuePerfectScrollbar class="scrollbardoc">
                      <div
                        class="uploded-files_wrap mt-3"
                        v-if="
                          uploadFinalMainDocuments && uploadFinalMainDocuments.length > 0
                        "
                      >
                        <div
                          class="w-full"
                          v-for="(fil, fileindex) in uploadFinalMainDocuments"
                          :key="fileindex"
                        >
                          <div class="uploded-files">
                            <vx-input-group class="form-input-group">
                              <vs-input
                                v-on:keyup="chengefileName(index, fileindex)"
                                v-validate="'required'"
                                class="w-full"
                                :name="'fName' + fileindex"
                                v-model="fil['name']"
                                data-vv-as="File Name"
                              />
                              <span
                                class="text-danger text-sm"
                                v-show="errors.has('fName' + fileindex)"
                                >{{ errors.first("fName" + fileindex) }}</span
                              >

                              <div
                                class="delete"
                                style="z-index: 999"
                                @click="remove(fil, uploadFinalMainDocuments, fileindex)"
                              >
                                <img src="@/assets/images/main/cross.svg" />
                              </div>
                            </vx-input-group>
                          </div>
                        </div>
                      </div>
                    </VuePerfectScrollbar>
                  </div>
                </div>
              </vx-input-group>
            </div>
          </div>
          
        </div>
      </div>
      <!-----v-if="fuploder"-->
      <div
        class="text-danger text-sm formerrors"
        v-show="formerrors.msg"
        @click="formerrors.msg = ''"
      >
        <vs-alert
          color="warning"
          class="warning-alert reg-warning-alert no-border-radius"
          icon-pack="IntakePortal"
          icon="IP-information-button"
          active="true"
          >{{ formerrors.msg }}</vs-alert
        >
      </div>
      <div class="popup-footer relative">
        <button
          @click="
            fileuploadPopup = false;uploadAfterUSCIS= false;
            cancelpopups();
            fuploder = false;
          "
          class="btn cancel"
        >
          Cancel
        </button>
        <button
          class="btn save"
          :disabled="disable_uploadBtn || uploadFinalMainDocuments.length <= 0"
          @click="updateFormsAndDocuments()"
        >
          <figure v-if="fuploder" class="loader">
            <img src="@/assets/images/main/loader.gif" />
          </figure>
          Upload
        </button>
      </div>
    </vs-popup>

    
    <vs-popup
      class="holamundo main-popup"
      title="Generate Forms and Letters"
      v-if="generatePopup"
      :active.sync="generatePopup"
    >
      <form @submit.prevent>
        <div class="form-container" @click="formerrors.msg = ''">
          <div class="vx-row">
            <div class="vx-col w-full" @click="value = []">
              <file-upload
                v-model="value"
                class="file-upload-input"
                :accept="acceptedFiles"
                :name="'Documents'"
                :multiple="false"
                :emitCategory="'Documents'"  @updateData="updateData"
                :fieldName="'Documents'"  :cid="'Documents'"
              >
       
              <!-- @input="uploadNewFormsandLatters(value)" -->
                <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                Upload
              </file-upload>
              <ul class="uploaded-list">
                <template v-for="(item, index) in newFormsAndLetters">
                  <vs-chip
                    @click="remove(item, newFormsAndLetters, index)"
                    :key="index"
                    closable
                    v-if="
                      item.status !== false &&
                      item.name !== null &&
                      item.url !== null &&
                      item.url !== ''
                    "
                  >
                    {{ item.name }}
                  </vs-chip>
                </template>
              </ul>
            </div>
          </div>

          <div
            class="text-danger text-sm formerrors"
            v-show="formerrors.msg"
            @click="formerrors.msg = ''"
          >
            <vs-alert
              color="warning"
              class="warning-alert reg-warning-alert no-border-radius"
              icon-pack="IntakePortal"
              icon="IP-information-button"
              active="true"
              >{{ formerrors.msg }}</vs-alert
            >
          </div>
        </div>
        <div class="popup-footer relative">
          <vs-button
            color="dark"
            @click="
              generatePopup = false;
              newFormsAndLetters = [];
            "
            class="btn cancel"
            type="filled"
            >Cancel</vs-button
          >
          <figure v-if="generatingFiles" class="loader loader2">
            <img src="@/assets/images/main/loader.gif" />
          </figure>
          <vs-button
            color="success"
            class="btn save"
            @click="openGenerateFormsLattersPopup()"
            type="filled"
            >Generate
          </vs-button>
        </div>
      </form>
    </vs-popup>

    <vs-popup
      class="holamundo main-popup"
      :title="'Delete ' + formLetterType"
      :active.sync="approveConformpopUp"
    >
      <div class="form-container">
        <div class="vx-row">
          <div class="vx-col w-full">
            <p>Do you want to Delete?</p>
          </div>
        </div>
      </div>
      <div
        class="text-danger text-sm formerrors"
        v-show="formerrors.msg"
        @click="formerrors.msg = ''"
      >
        <vs-alert
          color="warning"
          class="warning-alert reg-warning-alert no-border-radius"
          icon-pack="IntakePortal"
          icon="IP-information-button"
          active="true"
          >{{ formerrors.msg }}</vs-alert
        >
      </div>
      <div class="popup-footer relative">
        <vs-button
          color="dark"
          class="btn cancel"
          type="filled"
          @click="approveConformpopUp = false"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="btn save"
          type="filled"
          @click="deleteDocument()"
          >Delete</vs-button
        >
      </div>
    </vs-popup>

    <modal
      name="download_files_model"
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="600px"
      height="auto"
    >
      <!-- formsAndLettersList  <span class="im_overlay" @click="$modal.hide('petition-workflow-configuration'); configPopup=false;"></span> -->
      <div class="v-modal">
        <div class="popup-header">
          <h2 class="popup-title">Download Files</h2>
          <span @click="hideModel('download_files_model', false)">
            <em class="material-icons">close</em>
          </span>
        </div>
        <div class="form-container">
          <div v-if="formsAndLettersList.length > 0" class="forms_accordian popup_no_accordian">
            <vs-collapse accordion>
              <template v-for="(forms, index) in formsAndLettersList">
                <template v-if="(forms.depType == depType && forms.depLabel ==depLabel && forms.docUserType == docUserType && checkProperty( petition ,'subTypeDetails' ,'id') !=15) || checkProperty( petition ,'subTypeDetails' ,'id') ==15 ">
                <vs-collapse-item
                  v-if="forms.statusId != 1"
                  :open="openItem"
                  :class="{
                    closeDropdown: currentRole == 50,
                    'no-list':
                      checkProperty(forms, 'reverse_document_versions') &&
                      forms['reverse_document_versions'].length == 0,
                  }"
                  :not-arrow="
                    !(
                      checkProperty(forms, 'reverse_document_versions') &&
                      forms['reverse_document_versions'].length >= 0
                    )
                  "
                  :key="index"
                >
                  <div slot="header" class="ss 0">
                    <vs-list-item :title="forms.name" :subtitle="getformated(forms)" class="pt-0 pb-0">
                      <docType :item="forms" />

                      <ul class="download_checkbox">
                        <li>
                          <vs-checkbox
                            :disabled="[50, 51].indexOf(getUserRoleId) > -1"
                            :name="'selectedForSigning_' + index + '_'"
                            v-model="forms.selectedForDownload"
                            class=""
                          ></vs-checkbox>
                        </li>
                      </ul>
                    </vs-list-item>
                  </div>
                </vs-collapse-item>
                </template>
              </template>
            </vs-collapse>
          </div>
          <div
            class="text-danger text-sm formerrors"
            v-show="formerrors.msg"
            @click="formerrors.msg = ''"
          >
            <vs-alert
              color="warning"
              class="warning-alert reg-warning-alert no-border-radius"
              icon-pack="IntakePortal"
              icon="IP-information-button"
              active="true"
              >{{ formerrors.msg }}</vs-alert
            >
          </div>
        </div>
        <div class="popup-footer relative">
          <button
            :disabled="downloading"
            @click="
              downloadFiles = false;
              openDownloadPopup(false);
              formerrors.msg = '';
            "
            class="btn cancel"
          >
            Cancel
          </button>
          <button
            :disabled="downloading"
            class="btn save w-auto pl-3 pr-3"
            @click="downloadFormslatters(true)"
          >
            <figure v-if="downloading" class="loader">
              <img src="@/assets/images/main/loader.gif" />
            </figure>
            Download Zip File
          </button>
          <button
            :disabled="downloading"
            class="btn save w-auto pl-3 pr-3"
            @click="downloadFormslatters(false)"
          >
            <figure v-if="downloading" class="loader">
              <img src="@/assets/images/main/loader.gif" />
            </figure>
            Download Pdf File
          </button>
        </div>
      </div>
    </modal>
    <modal
      name="download_uscis_files_model"
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="600px"
      height="auto"
    >
      <!-- formsAndLettersList  <span class="im_overlay" @click="$modal.hide('petition-workflow-configuration'); configPopup=false;"></span> -->
      <div class="v-modal">
        <div class="popup-header">
          <h2 class="popup-title">Download Files</h2>
          <span @click="hideModel('download_uscis_files_model', false)">
            <em class="material-icons">close</em>
          </span>
        </div>
        <div class="form-container">
          <div v-if="uscisFormsAndLettersList.length > 0" class="forms_accordian popup_no_accordian">
            <vs-collapse accordion>
              <template v-for="(forms, index) in uscisFormsAndLettersList">
                <template v-if="(forms.depType == depType && forms.depLabel ==depLabel && forms.docUserType == docUserType && checkProperty( petition ,'subTypeDetails' ,'id') !=15) || checkProperty( petition ,'subTypeDetails' ,'id') ==15 ">
                <vs-collapse-item
                  v-if="forms.statusId != 1"
                  :open="openItem"
                  :class="{
                    closeDropdown: currentRole == 50,
                    'no-list':
                      checkProperty(forms, 'reverse_document_versions') &&
                      forms['reverse_document_versions'].length == 0,
                  }"
                  :not-arrow="
                    !(
                      checkProperty(forms, 'reverse_document_versions') &&
                      forms['reverse_document_versions'].length >= 0
                    )
                  "
                  :key="index"
                >
                  <div slot="header" class="ss 0">
                    <vs-list-item :title="forms.name" :subtitle="getformated(forms)" class="pt-0 pb-0">
                      <docType :item="forms" />

                      <ul class="download_checkbox">
                        <li>
                          <vs-checkbox
                            :disabled="[50, 51].indexOf(getUserRoleId) > -1"
                            :name="'selectedForSigning_' + index + '_'"
                            v-model="forms.selectedForDownload"
                            class=""
                          ></vs-checkbox>
                        </li>
                      </ul>
                    </vs-list-item>
                  </div>
                </vs-collapse-item>
                </template>
              </template>
            </vs-collapse>
          </div>
          <div
            class="text-danger text-sm formerrors"
            v-show="formerrors.msg"
            @click="formerrors.msg = ''"
          >
            <vs-alert
              color="warning"
              class="warning-alert reg-warning-alert no-border-radius"
              icon-pack="IntakePortal"
              icon="IP-information-button"
              active="true"
              >{{ formerrors.msg }}</vs-alert
            >
          </div>
        </div>
        <div class="popup-footer relative">
          <button
            :disabled="downloading"
            @click="
              downloadFiles = false;
              openUscisDownloadPopup(false);
              formerrors.msg = '';
            "
            class="btn cancel"
          >
            Cancel
          </button>
          <button
            :disabled="downloading"
            class="btn save w-auto pl-3 pr-3"
            @click="downloadFormslatters(true,'uscisForms')"
          >
            <figure v-if="downloading" class="loader">
              <img src="@/assets/images/main/loader.gif" />
            </figure>
            Download Zip File
          </button>
          <button
            :disabled="downloading"
            class="btn save w-auto pl-3 pr-3"
            @click="downloadFormslatters(false,'uscisForms')"
          >
            <figure v-if="downloading" class="loader">
              <img src="@/assets/images/main/loader.gif" />
            </figure>
            Download Pdf File
          </button>
        </div>
      </div>
    </modal>
    <modal
      name="download_all_files_model"
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="600px"
      height="auto"
    >
      <div class="v-modal download_list_modal">
        <div class="popup-header">
          <h2 class="popup-title">Download All Files</h2>
          <span @click="hideModel('download_all_files_model', false)">
            <em class="material-icons">close</em> 
          </span>
        </div> 
        <div class="form-container">
          <div v-if="checkProperty(uscisbeneficiaryDownloadDoc, 'documents') && checkProperty(uscisbeneficiaryDownloadDoc, 'documents', 'length') > 0 && checkSubmitToUscisCompleted" class="forms_accordian popup_no_accordian">
            <div>
              <vs-list-item class="cards-list-heading ">
                <div class="row" >
                  <vs-checkbox v-model="uscisbeneficiaryDownloadDoc.selectedAll" @click="selct_all_docs('beneficiary' ,true, '', 'uploadAfterUSCIS')" class="m-0">Beneficiary Forms and Letters- submitted to USCIS</vs-checkbox>
                </div>
                <!-- <h2>Beneficiary Forms and Letters </h2> -->
              </vs-list-item>
            </div>
            <vs-collapse accordion>
              <template v-for="(forms, index) in uscisbeneficiaryDownloadDoc['documents']">
                <vs-collapse-item
                  v-if="forms.statusId != 1"
                  :open="openItem"
                  :class="{
                    closeDropdown: currentRole == 50,
                    'no-list':
                      checkProperty(forms, 'reverse_document_versions') &&
                      forms['reverse_document_versions'].length == 0,
                  }"
                  :not-arrow="
                    !(
                      checkProperty(forms, 'reverse_document_versions') &&
                      forms['reverse_document_versions'].length >= 0
                    )
                  "
                  :key="index"
                >
                  <div slot="header" class="ss">
                    <vs-list-item :title="forms.name" :subtitle="getformated(forms)">
                      <docType :item="forms" />

                      <ul class="download_checkbox">
                        <li>
                          <vs-checkbox
                            @click="selct_all_docs('beneficiary' ,false, '', 'uploadAfterUSCIS')"
                            :disabled="[50, 51].indexOf(getUserRoleId) > -1"
                            :name="'selectedForSigning_' + index + '_'"
                            v-model="forms.selectedForDownload"
                            class=""
                          ></vs-checkbox>
                        </li>
                      </ul>
                    </vs-list-item>
                  </div>
                </vs-collapse-item>
              </template>
            </vs-collapse>
          </div>
          <div v-if="checkProperty(beneficiaryDownloadDoc, 'documents') && checkProperty(beneficiaryDownloadDoc, 'documents', 'length') > 0" class="forms_accordian popup_no_accordian">
            <div>
              <vs-list-item class="cards-list-heading ">
                <div class="row" >
                  <vs-checkbox v-model="beneficiaryDownloadDoc.selectedAll" @click="selct_all_docs('beneficiary' ,true)" class="m-0">Beneficiary Forms and Letters</vs-checkbox>
                </div>
                <!-- <h2>Beneficiary Forms and Letters </h2> -->
              </vs-list-item>
            </div>
            <vs-collapse accordion>
              <template v-for="(forms, index) in beneficiaryDownloadDoc['documents']">
                <vs-collapse-item
                  v-if="forms.statusId != 1"
                  :open="openItem"
                  :class="{
                    closeDropdown: currentRole == 50,
                    'no-list':
                      checkProperty(forms, 'reverse_document_versions') &&
                      forms['reverse_document_versions'].length == 0,
                  }"
                  :not-arrow="
                    !(
                      checkProperty(forms, 'reverse_document_versions') &&
                      forms['reverse_document_versions'].length >= 0
                    )
                  "
                  :key="index"
                >
                  <div slot="header" class="ss">
                    <vs-list-item :title="forms.name" :subtitle="getformated(forms)">
                      <docType :item="forms" />

                      <ul class="download_checkbox">
                        <li>
                          <vs-checkbox
                            @click="selct_all_docs('beneficiary' ,false)"
                            :disabled="[50, 51].indexOf(getUserRoleId) > -1"
                            :name="'selectedForSigning_' + index + '_'"
                            v-model="forms.selectedForDownload"
                            class=""
                          ></vs-checkbox>
                        </li>
                      </ul>
                    </vs-list-item>
                  </div>
                </vs-collapse-item>
              </template>
            </vs-collapse>
          </div>
          <div v-if="checkProperty(uscisspouseDownloadDoc, 'documents') && checkProperty(uscisspouseDownloadDoc, 'documents', 'length') > 0 && checkSubmitToUscisCompleted" class="forms_accordian popup_no_accordian">
            <div>
              <vs-list-item class="cards-list-heading">
                <div class="row" >
                  <vs-checkbox v-model="uscisspouseDownloadDoc.selectedAll" @click="selct_all_docs('spouse' ,true, '', 'uploadAfterUSCIS')" class="m-0">Spouse Forms and Letters - submitted to USCIS</vs-checkbox>
                </div> 
              </vs-list-item>
            </div>
            <vs-collapse accordion>
              <template v-for="(forms, index) in uscisspouseDownloadDoc['documents']">
                <vs-collapse-item
                  v-if="forms.statusId != 1"
                  :open="openItem"
                  :class="{
                    closeDropdown: currentRole == 50,
                    'no-list':
                      checkProperty(forms, 'reverse_document_versions') &&
                      forms['reverse_document_versions'].length == 0,
                  }"
                  :not-arrow="
                    !(
                      checkProperty(forms, 'reverse_document_versions') &&
                      forms['reverse_document_versions'].length >= 0
                    )
                  "
                  :key="index"
                >
                  <div slot="header" class="ss">
                    <vs-list-item :title="forms.name" :subtitle="getformated(forms)">
                      <docType :item="forms" />

                      <ul class="download_checkbox">
                        <li>
                          <vs-checkbox
                            @click="selct_all_docs('spouse' ,false, '', 'uploadAfterUSCIS')"
                            :disabled="[50, 51].indexOf(getUserRoleId) > -1"
                            :name="'selectedForSigning_' + index + '_'"
                            v-model="forms.selectedForDownload"
                            class=""
                          ></vs-checkbox>
                        </li>
                      </ul>
                    </vs-list-item>
                  </div>
                </vs-collapse-item>
              </template>
            </vs-collapse>
          </div>
          <div v-if="checkProperty(spouseDownloadDoc, 'documents') && checkProperty(spouseDownloadDoc, 'documents', 'length') > 0" class="forms_accordian popup_no_accordian">
            <div>
              <vs-list-item class="cards-list-heading">
                <div class="row" >
                  <vs-checkbox v-model="spouseDownloadDoc.selectedAll" @click="selct_all_docs('spouse' ,true)" class="m-0">Spouse Forms and Letters</vs-checkbox>
                </div> 
              </vs-list-item>
            </div>
            <vs-collapse accordion>
              <template v-for="(forms, index) in spouseDownloadDoc['documents']">
                <vs-collapse-item
                  v-if="forms.statusId != 1"
                  :open="openItem"
                  :class="{
                    closeDropdown: currentRole == 50,
                    'no-list':
                      checkProperty(forms, 'reverse_document_versions') &&
                      forms['reverse_document_versions'].length == 0,
                  }"
                  :not-arrow="
                    !(
                      checkProperty(forms, 'reverse_document_versions') &&
                      forms['reverse_document_versions'].length >= 0
                    )
                  "
                  :key="index"
                >
                  <div slot="header" class="ss">
                    <vs-list-item :title="forms.name" :subtitle="getformated(forms)">
                      <docType :item="forms" />

                      <ul class="download_checkbox">
                        <li>
                          <vs-checkbox
                            @click="selct_all_docs('spouse' ,false)"
                            :disabled="[50, 51].indexOf(getUserRoleId) > -1"
                            :name="'selectedForSigning_' + index + '_'"
                            v-model="forms.selectedForDownload"
                            class=""
                          ></vs-checkbox>
                        </li>
                      </ul>
                    </vs-list-item>
                  </div>
                </vs-collapse-item>
              </template>
            </vs-collapse>
          </div>
          <template v-if="checkProperty(uscischildrenDownloadDoc, 'length')>0 && checkSubmitToUscisCompleted">
            <template v-for="(child, ind) in uscischildrenDownloadDoc">
              <div v-if="checkProperty(child, 'documents') && checkProperty(child, 'documents', 'length') > 0" class="forms_accordian popup_no_accordian">
                <div>
                  <vs-list-item class="cards-list-heading">
                    <div class="row" >
                      <vs-checkbox v-model="child.selectedAll" @click="selct_all_docs('child' ,true, child['docUserType'], 'uploadAfterUSCIS')" class="m-0">{{'Child '+(ind+1)+' Forms and Letters'}} - submitted to USCIS </vs-checkbox>
                    </div> 
                  </vs-list-item>
                </div>
                <vs-collapse accordion>
                  <template v-for="(forms, index) in child['documents']">
                    <vs-collapse-item
                      v-if="forms.statusId != 1"
                      :open="openItem"
                      :class="{
                        closeDropdown: currentRole == 50,
                        'no-list':
                          checkProperty(forms, 'reverse_document_versions') &&
                          forms['reverse_document_versions'].length == 0,
                      }"
                      :not-arrow="
                        !(
                          checkProperty(forms, 'reverse_document_versions') &&
                          forms['reverse_document_versions'].length >= 0
                        )
                      "
                      :key="index"
                    >
                      <div slot="header" class="ss">
                        <vs-list-item :title="forms.name" :subtitle="getformated(forms)">
                          <docType :item="forms" />

                          <ul class="download_checkbox">
                            <li>
                              <vs-checkbox
                                @click="selct_all_docs('child' ,false, child['docUserType'], 'uploadAfterUSCIS')"
                                :disabled="[50, 51].indexOf(getUserRoleId) > -1"
                                :name="'selectedForSigning_' + index + '_'"
                                v-model="forms.selectedForDownload"
                                class=""
                              ></vs-checkbox>
                            </li>
                          </ul>
                        </vs-list-item>
                      </div>
                    </vs-collapse-item>
                  </template>
                </vs-collapse>
              </div>
            </template>
          </template>
          <template v-if="checkProperty(childrenDownloadDoc, 'length')>0">
            <template v-for="(child, ind) in childrenDownloadDoc">
              <div v-if="checkProperty(child, 'documents') && checkProperty(child, 'documents', 'length') > 0" class="forms_accordian popup_no_accordian">
                <div>
                  <vs-list-item class="cards-list-heading">
                    <div class="row" >
                      <vs-checkbox v-model="child.selectedAll" @click="selct_all_docs('child' ,true, child['docUserType'])" class="m-0">{{'Child '+(ind+1)+' Forms and Letters'}} </vs-checkbox>
                    </div> 
                  </vs-list-item>
                </div>
                <vs-collapse accordion>
                  <template v-for="(forms, index) in child['documents']">
                    <vs-collapse-item
                      v-if="forms.statusId != 1"
                      :open="openItem"
                      :class="{
                        closeDropdown: currentRole == 50,
                        'no-list':
                          checkProperty(forms, 'reverse_document_versions') &&
                          forms['reverse_document_versions'].length == 0,
                      }"
                      :not-arrow="
                        !(
                          checkProperty(forms, 'reverse_document_versions') &&
                          forms['reverse_document_versions'].length >= 0
                        )
                      "
                      :key="index"
                    >
                      <div slot="header" class="ss">
                        <vs-list-item :title="forms.name" :subtitle="getformated(forms)">
                          <docType :item="forms" />

                          <ul class="download_checkbox">
                            <li>
                              <vs-checkbox
                                @click="selct_all_docs('child' ,false, child['docUserType'])"
                                :disabled="[50, 51].indexOf(getUserRoleId) > -1"
                                :name="'selectedForSigning_' + index + '_'"
                                v-model="forms.selectedForDownload"
                                class=""
                              ></vs-checkbox>
                            </li>
                          </ul>
                        </vs-list-item>
                      </div>
                    </vs-collapse-item>
                  </template>
                </vs-collapse>
              </div>
            </template>
          </template>
          <div
            class="text-danger text-sm formerrors"
            v-show="formerrors.msg"
            @click="formerrors.msg = ''"
          >
            <vs-alert
              color="warning"
              class="warning-alert reg-warning-alert no-border-radius"
              icon-pack="IntakePortal"
              icon="IP-information-button"
              active="true"
              >{{ formerrors.msg }}</vs-alert
            >
          </div>
        </div>
        <div class="popup-footer relative">
          <button
            :disabled="downloading"
            @click="
              downloadFiles = false;
              openDownloadAllPopup(false);
              formerrors.msg = '';
            "
            class="btn cancel"
          >
            Cancel
          </button>
          <button
            :disabled="downloading"
            class="btn save w-auto pl-3 pr-3"
            @click="downloadallFormslatters(true)"
          >
            <figure v-if="downloading" class="loader">
              <img src="@/assets/images/main/loader.gif" />
            </figure>
            Download Zip File
          </button>
          <button
            :disabled="downloading"
            class="btn save w-auto pl-3 pr-3"
            @click="downloadallFormslatters(false)"
          >
            <figure v-if="downloading" class="loader">
              <img src="@/assets/images/main/loader.gif" />
            </figure>
            Download Pdf File
          </button>
        </div>
      </div>
    </modal>

    <modal
      name="pdfEditorPopup"
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="1000px"
      height="auto"
    >
      <div class="v-modal">
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">Edit PDF</h2>
          <span @click="$modal.hide('pdfEditorPopup')">
            <em class="material-icons">close</em>
          </span>
        </div>

        <!---pdfUrl-->
        <template>
          <!-- <pdf v-for="page in numPdfPages"  :key="page" :src="pdfUrl"   ref="myPdfComponent" ></pdf>-->
        </template>
      </div>
    </modal>

    <modal
      name="generateFormsLattersPopup"
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="500px"
      height="auto"
    >
      <div class="v-modal generate-forms-Latters">
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">Generate Forms and Letters</h2>
          <span @click="$modal.hide('generateFormsLattersPopup')">
            <em class="material-icons">close</em>
          </span>
        </div>
        <div class="form-container pb-0" @click="formerrors.msg = ''">
          <div class="row mt-0">
            <div class="vx-col w-full">
              <div class="form_group">
                <label class="form_label">Service Center<em>*</em></label>
                <div class="con-select" style="width: 100%">
                  <multiselect
                    data-vv-as="Service Center"
                    v-model="selectedOffice"
                    :allow-empty="false"
                    @input="changedOffice(false)"
                    :options="officeList"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Service Center"
                    label="name"
                    track-by="name"
                    :preselect-first="false"
                    name="service_center"
                    v-validate="'required'"
                  >
                    <template slot="selection" slot-scope="{ values, isOpen }">
                      <span
                        class="multiselect__single"
                        v-if="values.length &amp;&amp; !isOpen"
                        >{{ values.length }} options selected</span
                      >
                    </template>
                  </multiselect>

                  <span class="text-danger text-sm" v-if="errors.has('service_center')">{{
                    errors.first("service_center")
                  }}</span>
                </div>
              </div>
            </div>
          </div>

          <div>
            <!------beneficiary Documents-->
            <template
              v-if="checkProperty(masterFormsAndLatters, 'beneficiary', 'length') > 0"
            >
              <div class="spouse-documents mb-6">
                <span class="beneficiary-documents">Beneficiary Documents</span>
                <template
                  v-for="(documentItem, index) in masterFormsAndLatters['beneficiary']"
                >
                  <div class="row" :key="index">
                    <!----'isSelectedNewVersion':false ,"isSelectedCurrentVersion" availableNewVersion masterFormsAndLatters --->
                    <!--  effectiveDate == {{ checkProperty(documentItem,'effectiveDate') }}   priorFormsInformation==  {{documentItem.priorFormsInformation}}
                -->
                    <template v-if="checkProperty(documentItem, 'availableNewVersion')">
                      <div class="availableNewVersion">
                        <div class="documents_accordian_tile d-flex align-center">
                          <vs-checkbox
                            :name="'beneficiary_currentversion' + index"
                            @input="
                              selectDocument(documentItem, 'isSelectedCurrentVersion')
                            "
                            v-model="documentItem.isSelectedCurrentVersion"
                            class=""
                          >
                            <span
                              :availableNewVersion="
                                checkProperty(documentItem, 'availableNewVersion')
                              "
                              >{{ checkProperty(documentItem, "documentRef", "name")
                              }}<small
                                >{{ checkProperty(documentItem, "documentRef", "type") }}
                              </small></span
                            >
                          </vs-checkbox>
                          <h6 class="form-edited" v-if="documentItem.isedited">Edited</h6>
                        </div>
                        <div class="newVersionDocument">
                          <div class="documents_accordian_tile d-flex align-center">
                            <vs-checkbox
                              :name="'beneficiary_newversion' + index"
                              @input="
                                selectDocument(documentItem, 'isSelectedNewVersion')
                              "
                              v-model="documentItem.isSelectedNewVersion"
                              class=""
                            >
                            <span> New edition <template v-if="checkProperty(documentItem, 'edition')">({{ checkProperty(documentItem, 'edition') }})</template> is available
                            </span>
                            </vs-checkbox>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="documents_accordian_tile d-flex align-center">
                        <vs-checkbox
                          :name="'selectedForgenerate_' + index"
                          v-model="documentItem.isSelectedCurrentVersion"
                          class=""
                        >
                          <span
                            :availableNewVersion="
                              checkProperty(documentItem, 'availableNewVersion')
                            "
                            >{{ documentItem.name
                            }}<small
                              >{{ checkProperty(documentItem, "type") }}
                            </small></span
                          >
                        </vs-checkbox>
                        <h6 v-if="documentItem.isedited" class="form-edited">Edited</h6>
                      </div>
                    </template>
                  </div>
                </template>
              </div>
            </template>
            <!------Spouse Documents-->
            <template v-if="checkProperty(masterFormsAndLatters, 'spouse', 'length') > 0">
              <div class="spouse-documents mb-6">
                <span>Spouse Documents</span>
                <template
                  v-for="(documentItem, index) in masterFormsAndLatters['spouse']"
                >
                  <div class="row" :key="index">
                    <template v-if="checkProperty(documentItem, 'availableNewVersion')">
                      <div class="availableNewVersion">
                        <div class="documents_accordian_tile d-flex align-center">
                          <vs-checkbox
                            :name="'spouse_currentversion' + index"
                            @input="
                              selectDocument(documentItem, 'isSelectedCurrentVersion')
                            "
                            v-model="documentItem.isSelectedCurrentVersion"
                            class=""
                          >
                            <span
                              :availableNewVersion="
                                checkProperty(documentItem, 'availableNewVersion')
                              "
                              >{{ documentItem.name
                              }}<small
                                >{{ checkProperty(documentItem, "type") }}
                              </small></span
                            >
                          </vs-checkbox>
                          <h6 class="form-edited" v-if="documentItem.isedited">Edited</h6>
                        </div>
                        <div class="newVersionDocument">
                          <div class="documents_accordian_tile d-flex align-center">
                            <vs-checkbox
                              :name="'spouse_newversion' + index"
                              @input="
                                selectDocument(documentItem, 'isSelectedNewVersion')
                              "
                              v-model="documentItem.isSelectedNewVersion"
                              class=""
                            >
                            <span> New edition <template v-if="checkProperty(documentItem, 'edition')">({{ checkProperty(documentItem, 'edition') }})</template> is available
                                            </span>
                            </vs-checkbox>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="documents_accordian_tile d-flex align-center">
                        <vs-checkbox
                          :name="'spouse_' + index"
                          v-model="documentItem.isSelectedCurrentVersion"
                          class=""
                        >
                          <span
                            :availableNewVersion="
                              checkProperty(documentItem, 'availableNewVersion')
                            "
                            >{{ documentItem.name
                            }}<small
                              >{{ checkProperty(documentItem, "type") }}
                            </small></span
                          >
                        </vs-checkbox>
                        <h6 class="form-edited" v-if="documentItem.isedited">Edited</h6>
                      </div>
                    </template>
                  </div>
                </template>
              </div>
            </template>

            <template
              v-if="
                checkProperty(Object.entries(masterFormsAndLatters['child']), 'length') >
                0
              "
            >
              <div class="spouse-documents mb-6">
                <template
                  v-for="(val, key) in Object.entries(masterFormsAndLatters['child'])"
                >
                  <div :key="'child_' + key" v-if="checkProperty(val, 'length') >= 2">
                    <template v-if="checkProperty(val[1], 'length') > 0">
                      <span>Child {{ val[1][0]["userName"] }} </span>
                      <template v-for="(documentItem, index) in val[1]">
                        <div class="row" :key="index">
                          <template
                            v-if="checkProperty(documentItem, 'availableNewVersion')"
                          >
                            <div class="availableNewVersion">
                              <div class="documents_accordian_tile d-flex align-center">
                                <vs-checkbox
                                  :name="'spouse_currentversion' + index"
                                  @input="
                                    selectDocument(
                                      documentItem,
                                      'isSelectedCurrentVersion'
                                    )
                                  "
                                  v-model="documentItem.isSelectedCurrentVersion"
                                  class=""
                                >
                                  <span
                                    :availableNewVersion="
                                      checkProperty(documentItem, 'availableNewVersion')
                                    "
                                    >{{ documentItem.name
                                    }}<small>{{
                                      checkProperty(documentItem, "type")
                                    }}</small></span
                                  >
                                </vs-checkbox>
                                <h6 class="form-edited" v-if="documentItem.isedited">
                                  Edited
                                </h6>
                              </div>
                              <div class="newVersionDocument">
                                <div class="documents_accordian_tile d-flex align-center">
                                  <vs-checkbox
                                    :name="'spouse_newversion' + index"
                                    @input="
                                      selectDocument(documentItem, 'isSelectedNewVersion')
                                    "
                                    v-model="documentItem.isSelectedNewVersion"
                                    class=""
                                  >
                                  <span> New edition <template v-if="checkProperty(documentItem, 'edition')">({{ checkProperty(documentItem, 'edition') }})</template> is available
                                            </span>
                                  </vs-checkbox>
                                </div>
                              </div>
                            </div>
                            <span class="devider"></span>
                          </template>
                          <template v-else>
                            <div class="documents_accordian_tile d-flex align-center">
                              <vs-checkbox
                                :name="'spouse_' + index"
                                v-model="documentItem.isSelectedCurrentVersion"
                                class=""
                              >
                                <span
                                  :availableNewVersion="
                                    checkProperty(documentItem, 'availableNewVersion')
                                  "
                                  >{{ documentItem.name
                                  }}<small
                                    >{{ checkProperty(documentItem, "type") }}
                                  </small></span
                                >
                              </vs-checkbox>
                              <h6 class="form-edited" v-if="documentItem.isedited">
                                Edited
                              </h6>
                            </div>
                          </template>
                        </div>
                      </template>
                    </template>
                  </div>
                </template>
              </div>
            </template>
          </div>
        </div>
        <div
          class="text-danger text-sm formerrors"
          v-show="formerrors.msg"
          @click="formerrors.msg = ''"
        >
          <vs-alert
            color="warning"
            class="warning-alert reg-warning-alert no-border-radius"
            icon-pack="IntakePortal"
            icon="IP-information-button"
            active="true"
            >{{ formerrors.msg }}</vs-alert
          >
        </div>

        <div class="popup-footer relative">
          <button
            @click="
              $modal.hide('generateFormsLattersPopup');
              formerrors.msg = '';
            "
            class="btn cancel"
          >
            Cancel
          </button>
          <button class="btn save" @click="generateFormsAndLatters()">
            <figure v-if="generatingFiles" class="loader">
              <img src="@/assets/images/main/loader.gif" />
            </figure>
            Generate
          </button>
        </div>
      </div>
    </modal>

    <vs-popup
      style="z-index:999999; !important"
      class="holamundo main-popup"
      title="Regenerate Forms and Letters"
      :active.sync="regeneratingFormAndLetter"
    >
      <div class="form-container">
        <div class="vx-row">
          <div class="vx-col w-full">
            <p>
              Please note that changes made will be lost if the Forms/Letters are
              regenerated again
            </p>
            <p>Are you sure to proceed?</p>
          </div>
        </div>

        <div v-show="formerrors.msg">
          <vs-alert
            color="warning"
            class="warning-alert reg-warning-alert no-border-radius"
            icon-pack="IntakePortal"
            icon="IP-information-button"
            active="true"
            >{{ formerrors.msg }}</vs-alert
          >
        </div>
      </div>
      <div class="popup-footer relative">
        <figure v-if="generatingFiles" class="loader">
          <img src="@/assets/images/main/loader.gif" />
        </figure>
        <vs-button
          color="dark"
          class="cancel"
          type="filled"
          @click="regeneratingFormAndLetter = false"
          >Cancel
        </vs-button>
        <vs-button
          color="success"
          :disabled="formSubmited"
          class="save w-auto"
          type="filled"
          @click="generateFormsAndLatters()"
          >Yes</vs-button
        >
      </div>
    </vs-popup>
    <!--Approve or reject documents-->
    <vs-popup
      class="holamundo main-popup"
      :title="approveOrRejectDocsTitle"
      :active.sync="approveOrRejectDocs"
    >
      <form data-vv-scope="approveOrRejectDocsForm">
        <div class="form-container">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="form_group">
                <label class="form_label">Comments</label>
                <!-- <vs-textarea
                  data-vv-as="Comments"
                  v-validate="'required'"
                  v-model="comments"
                  name="comments"
                  class="w-full"
                /> -->
                <ckeditor   data-vv-as="Comments"
                  v-validate="'required'"
                  v-model="comments"
                  name="comments"
                  class="w-full" :editor="editor" :config="editorConfig"></ckeditor>


                <span
                  class="text-danger text-sm"
                  v-show="errors.has('approveOrRejectDocsForm.comments')"
                  >{{ errors.first("approveOrRejectDocsForm.comments") }}</span
                >
              </div>
            </div>
          </div>
          <div class="text-danger text-sm formerrors" v-show="formErrors">
            <vs-alert
              color="warning"
              class="warning-alert reg-warning-alert no-border-radius"
              icon-pack="IntakePortal"
              icon="IP-information-button"
              active="true"
              >{{ formErrors }}</vs-alert
            >
          </div>
        </div>
        <div class="popup-footer">
          <!-- <span class="loader"><img src="@/assets/images/main/loader.gif" /></span> -->
          <vs-button
            color="dark"
            @click="approveOrRejectDocs = false"
            class="btn cancel"
            type="filled"
            >Cancel
          </vs-button>

          <vs-button
            v-if="selectedAction == 'REJECT_BY_DOC_MANAGER'"
            color="success"
            @click="approveOrRejectDocsAction('REJECT_BY_DOC_MANAGER')"
            class="save"
            type="filled"
            >Reject</vs-button
          >
          <vs-button
            v-if="selectedAction == 'APPROVED_BY_DOC_MANAGER'"
            color="success"
            @click="approveOrRejectDocsAction('APPROVED_BY_DOC_MANAGER')"
            class="save"
            type="filled"
            >Approve</vs-button
          >
        </div>
      </form>
    </vs-popup>

    <div
      class="workflow_view_wrap generate_formsandletters"
      :class="{ listopen: generateFormsLattersPopup }"
    >
      <div class="workflow_overlay"></div>
      <div class="workflow_view_cnt questionary_cnt">
        <div class="workflow_view_title pr-0 common_title">
          <label
            v-if="
              this.checkProperty(this.petition, 'typeDetails', 'id') == 3 &&
              this.checkProperty(this.petition, 'subTypeDetails', 'id') == 15
            "
            >Generate Audit Response</label
          >
          <label v-else> Generate Forms and Letters</label>
          <span class="close" @click="generateFormsLattersPopup = false;checkReloadPetition()">
            <x-icon size="1.5x" class="custom-class"></x-icon
          ></span>
        </div>
        <div class="audit-response">
          <div class="doc_modal">
         
            <VuePerfectScrollbar class="scrollbardoc pt-4">
              <vs-row vs-w="12">
                <div class="form-container pad30 pt-0 pb-0" @click="formerrors.msg = ''">
                 
                  <div class="vx-col w-full" v-if="showCourier">
                    <div class="form_group custom-radio_wrap mb-4">
                      <label for class="form_label">Courier<em>*</em></label>
                        <ul class="custom-radio" vs-type="flex" vs-align="center">
                         
                          
                        <li v-for="(courier , index) in courierListTemp">
                       
                            
                        <vs-radio name="courier"  :vs-value="courier.id"  v-model="selectedCourier"  class="w-full">
                          <span :id="'courier_'+courier.code">
                            {{ courier.name }}
                          </span>
                        </vs-radio > 

                        
                        </li>
                               
                            
                        </ul>
                   </div>
               </div>

                  <div
                    class="row mt-0"
                    v-if="
                      (!loadingFormLatters &&
                        ((checkProperty(masterFormsAndLatters, 'beneficiary') &&( (checkProperty(masterFormsAndLatters, 'beneficiary' , 'coverLetters') 
                      && checkProperty(masterFormsAndLatters['beneficiary']['coverLetters'], 'documents', 'length')>0) ||(checkProperty(masterFormsAndLatters, 'beneficiary' , 'supportLetters') 
                      && checkProperty(masterFormsAndLatters['beneficiary']['supportLetters'], 'documents', 'length')>0) || (checkProperty(masterFormsAndLatters, 'beneficiary' , 'forms') 
                      && checkProperty(masterFormsAndLatters['beneficiary']['forms'], 'documents', 'length')>0) ) ))) ||
                      checkProperty(masterFormsAndLatters, 'spouse', 'length') > 0 ||
                      checkProperty(
                        Object.entries(masterFormsAndLatters['child']),
                        'length'
                      ) > 0 ||
                      checkProperty(masterFormsAndLatters, 'audit_response', 'length') > 0
                    "
                  >
                    <div class="vx-col w-auto inline-block">
                      <div class="form_group">
                       
                        <div class="con-select service_center" style="width: 100%; margin-bottom: 10px !important;">
                          <label class="form_label">Service Center <em>*</em></label>
                          <multiselect
                            data-vv-as="Service Center"
                            v-model="selectedOffice"
                            :allow-empty="false"
                            @input="changedOffice(false)"
                            :options="officeList"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="false"
                            :preserve-search="true"
                            placeholder="Service Center"
                            label="name"
                            track-by="name"
                            :preselect-first="false"
                            name="serviceCenter"
                            v-validate="'required'"
                          >
                            <template slot="selection" slot-scope="{ values, isOpen }">
                              <span
                                class="multiselect__single"
                                v-if="values.length &amp;&amp; !isOpen"
                                >{{ values.length }} options selected</span
                              >
                            </template>
                          </multiselect>

                          <span
                            class="text-danger text-sm"
                            v-if="errors.has('serviceCenter')"
                            >{{ errors.first("serviceCenter") }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-0 mb-0" v-if="courierAddress !=''">
                  <vs-alert  color="warning"  class="warning-alert top-warning-alert service_center_info" icon-pack="IntakePortal" icon="IP-information-button"
                    active="true"  v-html="courierAddress" >{{courierAddress }}</vs-alert>
                </div>

                  <div
                    v-if="
                      (!loadingFormLatters && (checkProperty(masterFormsAndLatters, 'beneficiary') &&( (checkProperty(masterFormsAndLatters, 'beneficiary' , 'coverLetters') 
                      && checkProperty(masterFormsAndLatters['beneficiary']['coverLetters'], 'documents', 'length')>0) ||(checkProperty(masterFormsAndLatters, 'beneficiary' , 'supportLetters') 
                      && checkProperty(masterFormsAndLatters['beneficiary']['supportLetters'], 'documents', 'length')>0) || (checkProperty(masterFormsAndLatters, 'beneficiary' , 'forms') 
                      && checkProperty(masterFormsAndLatters['beneficiary']['forms'], 'documents', 'length')>0) ) )) ||
                      checkProperty(masterFormsAndLatters, 'spouse', 'length') > 0 ||
                      checkProperty(Object.entries(masterFormsAndLatters['child']), 'length') > 0 || checkProperty(masterFormsAndLatters, 'audit_response', 'length') > 0
                    ">
                  <div class="row mt-6 mb-0" >
                    
                    <vs-checkbox v-model="selectAll" @click="selct_all(true)" class="m-0">
                      <template v-if="selectAll">Unselect All</template>
                      <template v-else>Select All</template>
                      
                    </vs-checkbox>
                  </div>
                    <!------AUDIT RESPONSE -->
                    <template
                      v-if="
                        checkProperty(masterFormsAndLatters, 'audit_response', 'length') >
                        0
                      "
                    >
                      <div class="spouse-documents mb-6">
                        <span class="beneficiary-documents">
                          <template>Audit Response Documents</template>
                           <fileUploadNote :fileNote="true" />
                        </span>
                        <template
                          v-for="(documentItem, index) in masterFormsAndLatters[
                            'audit_response'
                          ]"
                        >
                          <div class="row" :key="index">
                            <!----'isSelectedNewVersion':false ,"isSelectedCurrentVersion" availableNewVersion masterFormsAndLatters --->
                            <!--  effectiveDate == {{ checkProperty(documentItem,'effectiveDate') }}   priorFormsInformation==  {{documentItem.priorFormsInformation}}
            -->
                            <template
                              v-if="checkProperty(documentItem, 'availableNewVersion')"
                            >
                              <div class="availableNewVersion">
                                <div class="documents_accordian_tile d-flex align-center">
                                  <vs-checkbox
                                  @click="selct_all(false)"
                                    :name="'beneficiary_currentversion' + index"
                                    
                                    @input="
                                      selectDocument(
                                        documentItem,
                                        'isSelectedCurrentVersion'
                                      )
                                    "
                                    v-model="documentItem.isSelectedCurrentVersion"
                                    class=""
                                  >
                                    <span
                                    
                                      :availableNewVersion="
                                        checkProperty(documentItem, 'availableNewVersion')
                                      "
                                      >{{
                                        checkProperty(
                                          documentItem,
                                          "documentRef",
                                          "name"
                                        )
                                      }}<small
                                        >{{
                                          checkProperty(
                                            documentItem,
                                            "documentRef",
                                            "type"
                                          )
                                        }}
                                      </small></span
                                    >
                                  </vs-checkbox>
                                  <h6 class="form-edited" v-if="documentItem.isedited">
                                    Edited
                                  </h6>
                                </div>
                                <div class="newVersionDocument">
                                  <div
                                    class="documents_accordian_tile d-flex align-center"
                                  >
                                    <vs-checkbox
                                      :name="'beneficiary_newversion' + index"
                                      @input="
                                        selectDocument(
                                          documentItem,
                                          'isSelectedNewVersion'
                                        )
                                      "
                                      v-model="documentItem.isSelectedNewVersion"
                                      class=""
                                    >
                                    <span> New edition <template v-if="checkProperty(documentItem, 'edition')">({{ checkProperty(documentItem, 'edition') }})</template> is available
                                            </span>
                                    </vs-checkbox>
                                  </div>
                                </div>
                              </div>
                            </template>
                            <template v-else>
                              <div class="documents_accordian_tile d-flex align-center">
                                <vs-checkbox
                                  @click="selct_all(false)"
                                  :name="'selectedForgenerate_' + index"
                                  v-model="documentItem.isSelectedCurrentVersion"
                                  class=""
                                >
                                  <span
                                  
                                    :availableNewVersion="
                                      checkProperty(documentItem, 'availableNewVersion')
                                    "
                                    >{{ documentItem.name
                                    }}<small
                                      >{{ checkProperty(documentItem, "type") }}
                                    </small></span
                                  >
                                </vs-checkbox>
                                <h6 v-if="documentItem.isedited" class="form-edited">
                                  Edited
                                </h6>
                              </div>
                            </template>
                          </div>
                        </template>

                        <template
                          v-if="
                            checkProperty(petitionDetails, 'recruitmentInfo') &&
                            checkProperty(petitionDetails['recruitmentInfo'], 'documents')
                          "
                        >
                          <template
                            v-for="(itemmm, indexx) in Object.entries(
                              petitionDetails['recruitmentInfo']['documents']
                            )"
                          >
                            <div class="vx-col w-full upload-docs">
                              <div class="form_group">
                                <label class="form_label">{{
                                  checkDocsLabel({ field: itemmm[0], category: "label" })
                                }}</label>
                                <file-upload
                                  :ref="itemmm[0] + indexx"
                                  :hideSelected="true"
                                  v-model="fvalue"
                                  class="file-upload-input file-upload-input-cs"
                                  :name="itemmm[0] + indexx"
                                  :multiple="true"
                                  :accept="allDocEntity"
                                  :emitCategory="itemmm[0]"  @updateData="updateData"
                                  :emitSubCategory="'recruitmentInfo'"
                                  :fieldName="'recruitmentInfo'+indexx"  :cid="'recruitmentInfo'+indexx"
                                >
                                <!-- if(category == 'Documents'){
                                  this.petitionDetails.recruitmentInfo.documents[category] = docs
      } -->
                                <!-- @input="uploadAdv(fvalue, itemmm[0])" -->
                                  <img
                                    class="file-icon"
                                    src="@/assets/images/main/file-upload.svg"
                                  />
                                  Upload
                                  <span
                                    class="loader"
                                    v-if="
                                      checkDocsLabel({
                                        field: itemmm[0],
                                        category: 'loading',
                                      })
                                    "
                                    ><img src="@/assets/images/main/loader.gif"
                                  /></span>
                                </file-upload>

                                <ul class="uploaded-list">
                                  <template
                                    v-for="(item, index) in petitionDetails[
                                      'recruitmentInfo'
                                    ]['documents'][itemmm[0]]"
                                  >
                                    <vs-chip
                                      :key="index"
                                      @click="
                                        remove(
                                          item,
                                          petitionDetails['recruitmentInfo']['documents'][
                                            itemmm[0]
                                          ],
                                          index
                                        )
                                      "
                                      closable
                                    >
                                      {{ item.name }}
                                    </vs-chip>
                                  </template>
                                </ul>
                              </div>
                            </div>
                          </template>
                        </template>
                      </div>
                    </template>
                    <!------beneficiary Documents-->
                    <template
                      v-if="checkProperty(masterFormsAndLatters, 'beneficiary') &&( (checkProperty(masterFormsAndLatters, 'beneficiary' , 'coverLetters') 
                      && checkProperty(masterFormsAndLatters['beneficiary']['coverLetters'], 'documents', 'length')>0) ||(checkProperty(masterFormsAndLatters, 'beneficiary' , 'supportLetters') 
                      && checkProperty(masterFormsAndLatters['beneficiary']['supportLetters'], 'documents', 'length')>0) || (checkProperty(masterFormsAndLatters, 'beneficiary' , 'forms') 
                      && checkProperty(masterFormsAndLatters['beneficiary']['forms'], 'documents', 'length')>0))"> 
                      <div class="spouse-documents mb-6 mt-2">
                        <span class="beneficiary-documents">
                          <template v-if="checkProperty(masterFormsAndLatters['beneficiary'], 'coverLetters') && checkProperty(masterFormsAndLatters['beneficiary'], 'coverLetters', 'documents')
                          && checkProperty(masterFormsAndLatters['beneficiary']['coverLetters']['documents'][0], 'userName') ">
                            {{masterFormsAndLatters['beneficiary']['coverLetters']['documents'][0]["userName"] }} (Beneficiary) </template>
                            <template v-else-if="checkProperty(masterFormsAndLatters['beneficiary'], 'supportLetters') && checkProperty(masterFormsAndLatters['beneficiary'], 'supportLetters', 'documents')
                          && checkProperty(masterFormsAndLatters['beneficiary']['supportLetters']['documents'][0], 'userName') ">
                            {{masterFormsAndLatters['beneficiary']['supportLetters']['documents'][0]["userName"] }} (Beneficiary) </template>
                            <template v-else-if="checkProperty(masterFormsAndLatters['beneficiary'], 'forms') && checkProperty(masterFormsAndLatters['beneficiary'], 'forms', 'documents')
                          && checkProperty(masterFormsAndLatters['beneficiary']['forms']['documents'][0], 'userName') ">
                            {{masterFormsAndLatters['beneficiary']['forms']['documents'][0]["userName"] }} (Beneficiary) </template>
                          <template v-else>Beneficiary Documents </template>
                        </span>
                        <template v-if="checkProperty(masterFormsAndLatters, 'beneficiary' , 'coverLetters') && checkProperty(masterFormsAndLatters['beneficiary']['coverLetters'], 'documents')
                            && checkProperty(masterFormsAndLatters['beneficiary']['coverLetters'], 'documents', 'length') == 1">
                            <template v-for="(documentItem, index) in masterFormsAndLatters['beneficiary']['coverLetters']['documents']"  >
                              <div class="row" :key="index">
                                <template  v-if="checkProperty(documentItem, 'availableNewVersion')" >
                                  <div class="availableNewVersion">
                                    <div class="documents_accordian_tile d-flex align-center">
                                      <vs-checkbox
                                        @click="selct_all(false)"
                                        :name="'beneficiary_currentversion' + index"
                                        @input="  selectDocument(  documentItem, 'isSelectedCurrentVersion' ); "
                                        v-model="documentItem.isSelectedCurrentVersion"
                                        class="" >
                                        <span :availableNewVersion="
                                            checkProperty(documentItem, 'availableNewVersion') " >  {{ checkProperty( documentItem, "documentRef", "name" ) }}
                                            <small >{{  checkProperty(  documentItem, "documentRef",  "type" ) }} </small></span>
                                      </vs-checkbox>
                                      <h6 class="form-edited" v-if="documentItem.isedited">
                                        Edited
                                      </h6>
                                    </div>
                                    <div class="newVersionDocument">
                                      <div class="documents_accordian_tile d-flex align-center" >
                                        <vs-checkbox :name="'beneficiary_newversion' + index"
                                          @input="  selectDocument( documentItem, 'isSelectedNewVersion'  ) "
                                          v-model="documentItem.isSelectedNewVersion"
                                          class=""   >
                                          <span> New edition <template v-if="checkProperty(documentItem, 'edition')">({{ checkProperty(documentItem, 'edition') }})</template> is available
                                            </span>
                                        </vs-checkbox>
                                      </div>
                                    </div>
                                  </div>
                                </template>
                                <template v-else>
                                  <div class="documents_accordian_tile d-flex align-center"  >
                                    <vs-checkbox
                                      @click="selct_all(false)"
                                      :name="'selectedForgenerate_' + index"
                                      v-model="documentItem.isSelectedCurrentVersion"
                                      class="" >
                                      <span :availableNewVersion=" checkProperty(documentItem, 'availableNewVersion') " >{{ documentItem.name  }}
                                        <small >{{ checkProperty(documentItem, "type") }} </small></span  >
                                    </vs-checkbox>
                                    <h6 v-if="documentItem.isedited" class="form-edited">
                                      Edited
                                    </h6>
                                  </div>
                                </template>
                              </div>
                            </template>
                        </template>
                        <template v-if="checkProperty(masterFormsAndLatters, 'beneficiary' , 'supportLetters') && checkProperty(masterFormsAndLatters['beneficiary']['supportLetters'], 'documents')
                            && checkProperty(masterFormsAndLatters['beneficiary']['supportLetters'], 'documents', 'length') == 1">
                            <template v-for="(documentItem, index) in masterFormsAndLatters['beneficiary']['supportLetters']['documents']"  >
                              <div class="row" :key="index">
                                <template  v-if="checkProperty(documentItem, 'availableNewVersion')" >
                                  <div class="availableNewVersion">
                                    <div class="documents_accordian_tile d-flex align-center">
                                      <vs-checkbox
                                        @click="selct_all(false)"
                                        :name="'beneficiary_currentversion' + index"
                                        @input="  selectDocument(  documentItem, 'isSelectedCurrentVersion' ); "
                                        v-model="documentItem.isSelectedCurrentVersion"
                                        class="" >
                                        <span :availableNewVersion="
                                            checkProperty(documentItem, 'availableNewVersion') " >  {{ checkProperty( documentItem, "documentRef", "name" ) }}
                                            <small >{{  checkProperty(  documentItem, "documentRef",  "type" ) }} </small></span>
                                      </vs-checkbox>
                                      <h6 class="form-edited" v-if="documentItem.isedited">
                                        Edited
                                      </h6>
                                    </div>
                                    <div class="newVersionDocument">
                                      <div class="documents_accordian_tile d-flex align-center" >
                                        <vs-checkbox :name="'beneficiary_newversion' + index"
                                          @input="  selectDocument( documentItem, 'isSelectedNewVersion'  ) "
                                          v-model="documentItem.isSelectedNewVersion"
                                          class=""   >
                                          <span> New edition <template v-if="checkProperty(documentItem, 'edition')">({{ checkProperty(documentItem, 'edition') }})</template> is available
                                            </span>
                                        </vs-checkbox>
                                      </div>
                                    </div>
                                  </div>
                                </template>
                                <template v-else>
                                  <div class="documents_accordian_tile d-flex align-center"  >
                                    <vs-checkbox
                                      @click="selct_all(false)"
                                      :name="'selectedForgenerate_' + index"
                                      v-model="documentItem.isSelectedCurrentVersion"
                                      class="" >
                                      <span :availableNewVersion=" checkProperty(documentItem, 'availableNewVersion') " >{{ documentItem.name  }}
                                        <small >{{ checkProperty(documentItem, "type") }} </small></span  >
                                    </vs-checkbox>
                                    <h6 v-if="documentItem.isedited" class="form-edited">
                                      Edited
                                    </h6>
                                  </div>
                                </template>
                              </div>
                            </template>
                        </template>
                        <template v-if="checkProperty(masterFormsAndLatters, 'beneficiary' , 'forms') && checkProperty(masterFormsAndLatters['beneficiary']['forms'], 'documents')
                            && checkProperty(masterFormsAndLatters['beneficiary']['forms'], 'documents', 'length')>0">
                            <template v-for="(documentItem, index) in masterFormsAndLatters['beneficiary']['forms']['documents']"  >
                              <div class="row" :key="index">
                                <template  v-if="checkProperty(documentItem, 'availableNewVersion')" >
                                  <div class="availableNewVersion">
                                    <div class="documents_accordian_tile d-flex align-center">
                                      <vs-checkbox
                                        @click="selct_all(false)"
                                        :name="'beneficiary_currentversion' + index"
                                        @input="  selectDocument(  documentItem, 'isSelectedCurrentVersion' ); "
                                        v-model="documentItem.isSelectedCurrentVersion"
                                        class="" >
                                        <span :availableNewVersion="
                                            checkProperty(documentItem, 'availableNewVersion') " >  {{ checkProperty( documentItem, "documentRef", "name" ) }}
                                            <small >{{  checkProperty(  documentItem, "documentRef",  "type" ) }} </small></span>
                                      </vs-checkbox>
                                      <h6 class="form-edited" v-if="documentItem.isedited">
                                        Edited
                                      </h6>
                                    </div>
                                    <div class="newVersionDocument">
                                      <div class="documents_accordian_tile d-flex align-center" >
                                        <vs-checkbox :name="'beneficiary_newversion' + index"
                                          @input="  selectDocument( documentItem, 'isSelectedNewVersion'  ) "
                                          v-model="documentItem.isSelectedNewVersion"
                                          class=""   >
                                          <span> New edition <template v-if="checkProperty(documentItem, 'edition')">({{ checkProperty(documentItem, 'edition') }})</template> is available
                                            </span>
                                        </vs-checkbox>
                                      </div>
                                    </div>
                                  </div>
                                </template>
                                <template v-else>
                                  <div class="documents_accordian_tile d-flex align-center"  >
                                    <vs-checkbox
                                      @click="selct_all(false)"
                                      :name="'selectedForgenerate_' + index"
                                      v-model="documentItem.isSelectedCurrentVersion"
                                      class="" >
                                      <span :availableNewVersion=" checkProperty(documentItem, 'availableNewVersion') " >{{ documentItem.name  }}
                                        <small >{{ checkProperty(documentItem, "type") }} </small></span  >
                                    </vs-checkbox>
                                    <h6 v-if="documentItem.isedited" class="form-edited">
                                      Edited
                                    </h6>
                                  </div>
                                </template>
                              </div>
                            </template>
                        </template>
                        <template v-if="checkProperty(masterFormsAndLatters, 'beneficiary' , 'coverLetters') && checkProperty(masterFormsAndLatters['beneficiary']['coverLetters'], 'documents')
                            && checkProperty(masterFormsAndLatters['beneficiary']['coverLetters'], 'documents', 'length')>1">
                          <div class="accordian_sec_new" >
                            <div class="accordian_item" :class="{open : masterFormsAndLatters['beneficiary']['coverLetters']['toggleHeader']}" >
                              <div class="accordian_header" @click="masterFormsAndLatters['beneficiary']['coverLetters']['toggleHeader'] = !masterFormsAndLatters['beneficiary']['coverLetters']['toggleHeader']">
                                {{masterFormsAndLatters['beneficiary']['coverLetters']['HeaderLabel']}}
                                <!-- <img src="@/assets/images/icons/black_arrow.svg" /> -->
                              </div>
                              <div class="accordian_body">
                                <template v-for="(documentItem, index) in masterFormsAndLatters['beneficiary']['coverLetters']['documents']">
                                  <template v-if="checkProperty(documentItem, 'availableNewVersion')" >
                                    <div class="availableNewVersion">
                                      <div class="documents_accordian_tile d-flex align-center">
                                        <vs-checkbox
                                          @click="selct_all(false)"
                                          :name="'beneficiary_currentversion' + index"
                                          @input=" selectDocument( documentItem, 'isSelectedCurrentVersion' );"
                                          v-model="documentItem.isSelectedCurrentVersion"
                                          class="" >
                                          <span :availableNewVersion=" checkProperty(documentItem, 'availableNewVersion') " >  
                                            {{  checkProperty(  documentItem,  "documentRef",  "name" )  }}
                                            <small >{{  checkProperty( documentItem, "documentRef",  "type"  ) }} </small></span >
                                        </vs-checkbox>
                                        <h6 class="form-edited" v-if="documentItem.isedited"> Edited  </h6>
                                      </div>
                                      <div class="newVersionDocument">
                                        <div  class="documents_accordian_tile d-flex align-center" >
                                          <vs-checkbox :name="'beneficiary_newversion' + index"
                                            @input="  selectDocument(  documentItem, 'isSelectedNewVersion' )  "
                                            v-model="documentItem.isSelectedNewVersion"
                                            class="" >
                                            <span> New edition <template v-if="checkProperty(documentItem, 'edition')">({{ checkProperty(documentItem, 'edition') }})</template> is available
                                            </span>
                                          </vs-checkbox>
                                        </div>
                                      </div>
                                    </div>
                                  </template>
                                <template v-else>
                                  <div class="documents_accordian_tile d-flex align-center"  >
                                    <vs-checkbox
                                      @click="selct_all(false)"
                                      :name="'selectedForgenerate_' + index"
                                      v-model="documentItem.isSelectedCurrentVersion"
                                      class=""  >
                                      <span  :availableNewVersion="checkProperty(documentItem, 'availableNewVersion')">{{ documentItem.name}}
                                      <small >{{checkProperty(documentItem, "type") }} </small></span>
                                    </vs-checkbox>
                                    <h6 v-if="documentItem.isedited" class="form-edited"> Edited </h6>
                                  </div>
                                </template>
                                </template>
                              </div>
                            </div>
                          </div>
                        </template>
                        <template v-if="checkProperty(masterFormsAndLatters, 'beneficiary' , 'supportLetters') && checkProperty(masterFormsAndLatters['beneficiary']['supportLetters'], 'documents')
                            && checkProperty(masterFormsAndLatters['beneficiary']['supportLetters'], 'documents', 'length')>1">
                          <div class="accordian_sec_new" >
                              <div class="accordian_item" :class="{open : masterFormsAndLatters['beneficiary']['supportLetters']['toggleHeader']}" >
                                <div class="accordian_header" @click="masterFormsAndLatters['beneficiary']['supportLetters']['toggleHeader'] = !masterFormsAndLatters['beneficiary']['supportLetters']['toggleHeader']">
                                  {{masterFormsAndLatters['beneficiary']['supportLetters']['HeaderLabel']}}
                                  <!-- <img src="@/assets/images/icons/black_arrow.svg" /> -->
                                </div>
                                <div class="accordian_body">
                                  <template v-for="(documentItem, index) in masterFormsAndLatters['beneficiary']['supportLetters']['documents']">
                                    <template v-if="checkProperty(documentItem, 'availableNewVersion')" >
                                      <div class="availableNewVersion">
                                        <div class="documents_accordian_tile d-flex align-center">
                                          <vs-checkbox
                                            @click="selct_all(false)"
                                            :name="'beneficiary_currentversion' + index"
                                            @input=" selectDocument( documentItem, 'isSelectedCurrentVersion' );"
                                            v-model="documentItem.isSelectedCurrentVersion"
                                            class="" >
                                            <span :availableNewVersion=" checkProperty(documentItem, 'availableNewVersion') " >  
                                              {{  checkProperty(  documentItem,  "documentRef",  "name" )  }}
                                              <small >{{  checkProperty( documentItem, "documentRef",  "type"  ) }} </small></span >
                                          </vs-checkbox>
                                          <h6 class="form-edited" v-if="documentItem.isedited"> Edited  </h6>
                                        </div>
                                        <div class="newVersionDocument">
                                          <div  class="documents_accordian_tile d-flex align-center" >
                                            <vs-checkbox :name="'beneficiary_newversion' + index"
                                              @input="  selectDocument(  documentItem, 'isSelectedNewVersion' )  "
                                              v-model="documentItem.isSelectedNewVersion"
                                              class="" >
                                              <span> New edition <template v-if="checkProperty(documentItem, 'edition')">({{ checkProperty(documentItem, 'edition') }})</template> is available
                                              </span>
                                            </vs-checkbox>
                                          </div>
                                        </div>
                                      </div>
                                    </template>
                                  <template v-else>
                                    <div class="documents_accordian_tile d-flex align-center"  >
                                      <vs-checkbox
                                        @click="selct_all(false)"
                                        :name="'selectedForgenerate_' + index"
                                        v-model="documentItem.isSelectedCurrentVersion"
                                        class=""  >
                                        <span  :availableNewVersion="checkProperty(documentItem, 'availableNewVersion')">{{ documentItem.name}}
                                        <small >{{checkProperty(documentItem, "type") }} </small></span>
                                      </vs-checkbox>
                                      <h6 v-if="documentItem.isedited" class="form-edited"> Edited </h6>
                                    </div>
                                  </template>
                                  </template>
                                </div>
                              </div>
                          </div>
                        </template>
                        <template v-if="checkProperty(masterFormsAndLatters, 'beneficiary' , 'forms') && checkProperty(masterFormsAndLatters['beneficiary']['forms'], 'documents')
                            && checkProperty(masterFormsAndLatters['beneficiary']['forms'], 'documents', 'length')>1 && false ">
                          <div class="accordian_sec_new" >
                            <div class="accordian_item" :class="{open : masterFormsAndLatters['beneficiary']['forms']['toggleHeader']}" >
                              <div class="accordian_header" @click="masterFormsAndLatters['beneficiary']['forms']['toggleHeader'] = !masterFormsAndLatters['beneficiary']['forms']['toggleHeader']">
                                {{masterFormsAndLatters['beneficiary']['forms']['HeaderLabel']}}
                                <!-- <img src="@/assets/images/icons/black_arrow.svg" /> -->
                              </div>
                              <div class="accordian_body">
                                <template v-for="(documentItem, index) in masterFormsAndLatters['beneficiary']['forms']['documents']">
                                  <template v-if="checkProperty(documentItem, 'availableNewVersion')" >
                                    <div class="availableNewVersion">
                                      <div class="documents_accordian_tile d-flex align-center">
                                        <vs-checkbox
                                          @click="selct_all(false)"
                                          :name="'beneficiary_currentversion' + index"
                                          @input=" selectDocument( documentItem, 'isSelectedCurrentVersion' );"
                                          v-model="documentItem.isSelectedCurrentVersion"
                                          class="" >
                                          <span :availableNewVersion=" checkProperty(documentItem, 'availableNewVersion') " >  
                                            {{  checkProperty(  documentItem,  "documentRef",  "name" )  }}
                                            <small >{{  checkProperty( documentItem, "documentRef",  "type"  ) }} </small></span >
                                        </vs-checkbox>
                                        <h6 class="form-edited" v-if="documentItem.isedited"> Edited  </h6>
                                      </div>
                                      <div class="newVersionDocument">
                                        <div  class="documents_accordian_tile d-flex align-center" >
                                          <vs-checkbox :name="'beneficiary_newversion' + index"
                                            @input="  selectDocument(  documentItem, 'isSelectedNewVersion' )  "
                                            v-model="documentItem.isSelectedNewVersion"
                                            class="" >
                                            <span> New edition <template v-if="checkProperty(documentItem, 'edition')">({{ checkProperty(documentItem, 'edition') }})</template> is available
                                            </span>
                                          </vs-checkbox>
                                        </div>
                                      </div>
                                    </div>
                                  </template>
                                <template v-else>
                                  <div class="documents_accordian_tile d-flex align-center"  >
                                    <vs-checkbox
                                      @click="selct_all(false)"
                                      :name="'selectedForgenerate_' + index"
                                      v-model="documentItem.isSelectedCurrentVersion"
                                      class=""  >
                                      <span  :availableNewVersion="checkProperty(documentItem, 'availableNewVersion')">{{ documentItem.name}}
                                      <small >{{checkProperty(documentItem, "type") }} </small></span>
                                    </vs-checkbox>
                                    <h6 v-if="documentItem.isedited" class="form-edited"> Edited </h6>
                                  </div>
                                </template>
                                </template>
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>
                    </template>
                    <!------Spouse Documents-->
                    <template
                      v-if="checkProperty(masterFormsAndLatters, 'spouse', 'length') > 0"
                    >
                      <div class="spouse-documents mb-6">
                        <span>
                          <template
                            v-if="
                              checkProperty(
                                masterFormsAndLatters['spouse'][0],
                                'userName'
                              )
                            "
                            >{{ masterFormsAndLatters["spouse"][0]["userName"] }} (Spouse)
                          </template>
                          <template v-else>Spouse Documents</template>
                        </span>
                        <template
                          v-for="(documentItem, index) in masterFormsAndLatters['spouse']"
                        >
                          <div class="row" :key="index">
                            <template
                              v-if="checkProperty(documentItem, 'availableNewVersion')"
                            >
                              <div class="availableNewVersion">
                                <div class="documents_accordian_tile d-flex align-center">
                                  <vs-checkbox
                                  @click="selct_all(false)"
                                    :name="'spouse_currentversion' + index"
                                    @input="
                                      selectDocument(
                                        documentItem,
                                        'isSelectedCurrentVersion'
                                      )
                                    "
                                    v-model="documentItem.isSelectedCurrentVersion"
                                    class=""
                                  >
                                    <span
                                    
                                      :availableNewVersion="
                                        checkProperty(documentItem, 'availableNewVersion')
                                      "
                                      >{{ documentItem.name
                                      }}<small
                                        >{{ checkProperty(documentItem, "type") }}
                                      </small></span
                                    >
                                  </vs-checkbox>
                                  <h6 class="form-edited" v-if="documentItem.isedited">
                                    Edited
                                  </h6>
                                </div>
                                <div class="newVersionDocument">
                                  <div
                                    class="documents_accordian_tile d-flex align-center"
                                  >
                                    <vs-checkbox
                                    
                                      :name="'spouse_newversion' + index"
                                      @input="
                                        selectDocument(
                                          documentItem,
                                          'isSelectedNewVersion'
                                        )
                                      "
                                      v-model="documentItem.isSelectedNewVersion"
                                      class=""
                                    >
                                    <span> New edition <template v-if="checkProperty(documentItem, 'edition')">({{ checkProperty(documentItem, 'edition') }})</template> is available
                                    </span>
                                    </vs-checkbox>
                                  </div>
                                </div>
                              </div>
                            </template>
                            <template v-else>
                              <div class="documents_accordian_tile d-flex align-center">
                                <vs-checkbox
                                @click="selct_all(false)"
                                  :name="'spouse_' + index"
                                  v-model="documentItem.isSelectedCurrentVersion"
                                  class=""
                                >
                                  <span 
                                    :availableNewVersion="
                                      checkProperty(documentItem, 'availableNewVersion')
                                    "
                                    >{{ documentItem.name
                                    }}<small 
                                      >{{ checkProperty(documentItem, "type") }}
                                    </small></span
                                  >
                                </vs-checkbox>
                                <h6 class="form-edited" v-if="documentItem.isedited">
                                  Edited
                                </h6>
                              </div>
                            </template>
                          </div>
                        </template>
                      </div>
                    </template>

                    <template
                      v-if="
                        checkProperty(
                          Object.entries(masterFormsAndLatters['child']),
                          'length'
                        ) > 0
                      "
                    >
                      <div class="spouse-documents mb-6">
                        <template
                          v-for="(val, key) in Object.entries(
                            masterFormsAndLatters['child']
                          )"
                        >
                          <div
                            :key="'child_' + key"
                            v-if="checkProperty(val, 'length') >= 2"
                          >
                            <template v-if="checkProperty(val[1], 'length') > 0">
                              <span> {{ val[1][0]["userName"] }} (Child) </span>
                              <template v-for="(documentItem, index) in val[1]">
                                <div class="row" :key="index">
                                  <template
                                    v-if="
                                      checkProperty(documentItem, 'availableNewVersion')
                                    "
                                  >
                                    <div class="availableNewVersion">
                                      <div
                                        class="documents_accordian_tile d-flex align-center"
                                      >
                                        <vs-checkbox
                                        @click="selct_all(false)"
                                          :name="'spouse_currentversion' + index"
                                          @input="
                                            selectDocument(
                                              documentItem,
                                              'isSelectedCurrentVersion'
                                            )
                                          "
                                          v-model="documentItem.isSelectedCurrentVersion"
                                          class=""
                                        >
                                          <span
                                          
                                            :availableNewVersion="
                                              checkProperty(
                                                documentItem,
                                                'availableNewVersion'
                                              )
                                            "
                                            >{{ documentItem.name
                                            }}<small>{{
                                              checkProperty(documentItem, "type")
                                            }}</small></span
                                          >
                                        </vs-checkbox>
                                        <h6
                                          class="form-edited"
                                          v-if="documentItem.isedited"
                                        >
                                          Edited
                                        </h6>
                                      </div>
                                      <div class="newVersionDocument">
                                        <div
                                          class="documents_accordian_tile d-flex align-center"
                                        >
                                          <vs-checkbox
                                            :name="'spouse_newversion' + index"
                                            @input="
                                              selectDocument(
                                                documentItem,
                                                'isSelectedNewVersion'
                                              )
                                            "
                                            v-model="documentItem.isSelectedNewVersion"
                                            class=""
                                          >
                                          <span> New edition <template v-if="checkProperty(documentItem, 'edition')">({{ checkProperty(documentItem, 'edition') }})</template> is available
                                          </span>
                                          </vs-checkbox>
                                        </div>
                                      </div>
                                    </div>
                                    <span class="devider"></span>
                                  </template>
                                  <template v-else>
                                    <div
                                      class="documents_accordian_tile d-flex align-center"
                                    >
                                      <vs-checkbox
                                      @click="selct_all(false)"
                                        :name="'spouse_' + index"
                                        v-model="documentItem.isSelectedCurrentVersion"
                                        class=""
                                      >
                                        <span  
                                          :availableNewVersion="
                                            checkProperty(
                                              documentItem,
                                              'availableNewVersion'
                                            )
                                          "
                                          >{{ documentItem.name
                                          }}<small
                                            >{{ checkProperty(documentItem, "type") }}
                                          </small></span
                                        >
                                      </vs-checkbox>
                                      <h6
                                        class="form-edited"
                                        v-if="documentItem.isedited"
                                      >
                                        Edited
                                      </h6>
                                    </div>
                                  </template>
                                </div>
                              </template>
                            </template>
                          </div>
                        </template>
                      </div>
                    </template>
                  </div>
                  <div v-else>
                    <template v-if="loadingFormLatters">
                      <span class="loader" v-if="loadingFormLatters"
                        ><img src="@/assets/images/main/loader.gif"
                      /></span>
                    </template>
                    <template v-else>
                      <NoDataFound
                        ref="NoDataFoundRef"
                        :checkLocading="false"
                        content=""
                        heading="No Documents Found."
                        type="documents"
                      />
                    </template>
                  </div>
                </div>
              </vs-row>
            </VuePerfectScrollbar>
            <div
              class="text-danger text-sm formerrors"
              v-show="formerrors.msg"
              @click="formerrors.msg = ''"
            >
              <vs-alert
                color="warning"
                class="warning-alert reg-warning-alert no-border-radius"
                icon-pack="IntakePortal"
                icon="IP-information-button"
                active="true"
                >{{ formerrors.msg }}</vs-alert
              >
            </div>
          </div>
          <div class="popup-footer relative">
            
            <button
              @click="generateFormsLattersPopup = false;checkReloadPetition()"
              class="cancel"
              type="filled"
              color="dark"
            >
              Cancel
            </button>
            <vs-button
             
              color="success"
              @click="generateFormsAndLatters()"
              class="marl15 save"
              type="filled"
              >Generate</vs-button
            >
          </div>
        </div>
        <div></div>
        <figure v-if="generatingFiles" class="loader">
          <img src="@/assets/images/main/loader.gif" />
        </figure>
      </div>
    </div>

    
    <vs-popup
      class="Change_petition_wrap documents_modal_popup"
      v-if="reversion_fileuploadPopup"
      :title="
        checkProperty(petition, 'subTypeDetails', 'id') == 15
          ? 'Upload Audit Response'
          : 'Upload Revision ' + formLetterType + 's'
      "
      :active.sync="reversion_fileuploadPopup"
    >
    
      <div class="Change_petition upload_letter_others">
        <fileUploadNote :fileNote="true" />
        <div class="vx-col w-full">
          <div class="vx-row form-container pad0"   @click="showTypeIdError=false" v-if="checkProperty(petition, 'subTypeDetails', 'id') == 15 && checkProperty(petitionDetails,'beneficiaryInfo','maritalStatus' ) !=1 && checkProperty(petitionDetails['dependentsInfo'] ,'spouse', 'h4Required')==true">
            <div class="custom-radio_wrap wf_radio">
              <label class="form_label pb-1 pl-4">Upload For<em >*</em></label>
              <ul class="custom-radio mb-1">
                 <li> 
                  <vs-radio   name="docusertype" @input="changedBeneficiarycheck" vs-value="Beneficiary" v-model="docUserType" class="w-full" >Beneficiary</vs-radio>
                 </li>
                  <li>
                     <vs-radio  name="docusertype" @input="changedBeneficiarycheck" vs-value="Dependent"  v-model="docUserType" class="w-full" >Dependent</vs-radio>
                   </li>
             </ul>
            </div>
            <span  class="text-danger text-sm ml-3"  v-show="showTypeIdError">Document Type is required</span>
          </div>
          <div class="vx-row form-container pad0 mt-3"  v-if="formLetterType=='Letter'  && false">
              <div class="custom-radio_wrap wf_radio">
              <label class="form_label pb-1 pl-4">Letter Type<em >*</em></label>
              <!----entityIds:[{"id":"'cover_letter'" ,"name":"Cover Letter"},{"id":'support_letter' ,"name":'Support Letter'}],
   -->
   
              <ul class="custom-radio mb-3">
                 <li> 
                  <vs-radio   name="entityId" @input="changedBeneficiarycheck" vs-value="cover_letter" v-model="entityId" class="w-full" >Cover Letter</vs-radio>
                 </li>
                  <li>
                     <vs-radio  name="entityId" @input="changedBeneficiarycheck" vs-value="support_letter"  v-model="entityId" class="w-full" >Support Letter</vs-radio>
                   </li>
             </ul>
             <span  class="text-danger text-sm ml-3"  v-show="showentityIdError"  >Letter Type is required</span>
            </div>
          </div>
          
         <div class="vx-row">
          <div class="vx-col w-full">
            <div v-for="(docData, index) in documentData" :key="index">
            <div class="vx-row">
              <div class="vx-col w-full">
                <vx-input-group class="form-input-group select-upload-group">
                  <div class="uploadsec_wrap">
                    <div class="w-full">
                      <file-upload
                        :accept="acceptedFiles"
                        v-model="version_documentUploaded"
                        class="file-upload-input mb-0"
                        style="height: 50px"
                        :name="'version_documents' + index"
                        :multiple="false"
                        v-validate="'required'"
                        label="Forms and Letters"
                        data-vv-as="Forms and Letters"
                        :emitCategory="'documentData'"  @updateData="updateData"
                        :formLetterType="formLetterType"
                        :fieldName="'documentData'"  :cid="'documentData'"
                        
                      >
                      <!-- :emitSubCategory="'documentData'" @input="doUpload(selectedDoc, version_documentUploaded)" -->
                        <img
                          class="file-icon"
                          src="@/assets/images/main/file-upload.svg"
                        />

                        Upload
                      </file-upload>

                      <span v-if="formLetterType == 'Form'" class="file-type"
                        >(File Type: PDF, Max file size: 200MB)</span
                      >
                      <span v-else class="file-type mb-0"
                        >(File Type: DOC, Max file size: 200MB)</span
                      >

                      <VuePerfectScrollbar class="scrollbardoc">
                        <div
                          class="uploded-files_wrap"
                          v-if="version_documentUploaded.length > 0"
                        >
                          <div
                            class="w-full"
                            v-for="(fil, fileindex) in version_documentUploaded"
                            :key="fileindex" 
                          >
                           <template v-if="checkProperty(fil, 'path') || checkProperty(fil, 'url')">
                            <div class="uploded-files">
                              <vx-input-group class="form-input-group">
                                <vs-input
                                  v-on:keyup="reversion_fileNameChenged(fileindex)"
                                  required
                                  class="w-full"
                                  :name="'fName' + index"
                                  v-model="version_documentUploaded[fileindex]['name']"
                                  data-vv-as="File Name"
                                />
                                <span
                                  class="text-danger text-sm"
                                  v-show="!version_documentUploaded[fileindex]['name']"
                                  >Please Enter file name</span
                                >
                                <span
                                  class="text-danger text-sm"
                                  v-show="errors.has('fName' + index)"
                                  >{{ errors.first("fName" + index) }}</span
                                >

                                <div
                                  class="delete"
                                  style="z-index: 999"
                                  @click="remove_reversion_file()"
                                >
                                  <img src="@/assets/images/main/cross.svg" />
                                </div>
                              </vx-input-group>
                            </div>
                           </template>
                          </div>
                        </div>
                      </VuePerfectScrollbar>
                    </div>
                  </div>
                </vx-input-group>
              </div>
            </div>
          </div>
          </div>
         </div>
        

         
        </div>
      </div>
      <div
        class="text-danger text-sm formerrors"
        v-show="formerrors.msg"
        @click="formerrors.msg = ''"
      >
        <vs-alert
          color="warning"
          class="warning-alert reg-warning-alert no-border-radius"
          icon-pack="IntakePortal"
          icon="IP-information-button"
          active="true"
          >{{ formerrors.msg }}</vs-alert
        >
      </div>

      <div class="popup-footer relative">
        <button
          @click="
            reversion_fileuploadPopup = false;
            formerrors.msg = '';
            selectedDocument = null;versionUploadAfterUSCIS= false;
          "
          class="btn cancel"
        >
          Cancel
        </button>
        <!-- v-bind:disble="disable_reversion_uploadBtn" -->
        <button
          class="btn save"
          v-bind:disabled="disable_reversion_uploadBtn"
          @click="updateDocument_Version()"
        >
          <figure v-if="fuploder" class="loader loader2">
            <img src="@/assets/images/main/loader.gif" />
          </figure>
          Upload
        </button>
      </div>
    </vs-popup>

    <template>
      <div class="workflow_view_wrap sidebar_sec" :class="{ listopen: showDetailsPopup }">
        <div class="workflow_overlay"></div>
        <div class="workflow_view_cnt" style="width:900px">
          <div class="sidebar_head">
            <span class="close" @click="showDetailsPopup = false"><x-icon size="1.5x" class="custom-class"></x-icon></span>
            <h2 class="popup-title" >I-140 Additional Questionnaire</h2>
          </div> 
          <div class="sidebar_cnt"> 
            <form  @submit.prevent data-vv-scope="newI140Form">
                <div class="form-container">
                  <div class="vx-row" >
                    <div class="vx-col w-full">
                      <h6 class="title-header mb-2">This petition is being filed for<span class="info"> (Select only one option)</span></h6>
                      <ul class="custom-radio mb-1" >
              
                        <li> 
                          <vs-radio  :name="'petitionFieldFor'"  :vs-value="'a'" v-model="i140AdditionalInfo.petitionBeingFieldFor" class="w-full" >
                            An alien of extraordinary ability. 
                          </vs-radio>
                        </li>
                        <li>
                          <vs-radio  :name="'petitionFieldFor'"   :vs-value="'b'"  v-model="i140AdditionalInfo.petitionBeingFieldFor" class="w-full" >
                            An outstanding professor or researcher.
                          </vs-radio>
                        </li>
                        <li>
                          <vs-radio  name="petitionFieldFor"   vs-value="c"  v-model="i140AdditionalInfo.petitionBeingFieldFor" class="w-full" >
                            A multinational executive or manager. 
                          </vs-radio>
                        </li>
                        <li>
                          <vs-radio  name="petitionFieldFor"   vs-value="d"  v-model="i140AdditionalInfo.petitionBeingFieldFor" class="w-full" >
                            A member of the professions holding an advanced degree
                            or an alien of exceptional ability (who is NOT seeking a National Interest Waiver (NIW)). 
                          </vs-radio>
                        </li>
                        <li>
                          <vs-radio  name="petitionFieldFor"   vs-value="e"  v-model="i140AdditionalInfo.petitionBeingFieldFor" class="w-full" >
                            A professional (at a minimum, possessing a bachelor's degree or a foreign degree equivalent to a U.S. bachelor's degree). 
                          </vs-radio>
                        </li>
                        <li>
                          <vs-radio  name="petitionFieldFor"   vs-value="f"  v-model="i140AdditionalInfo.petitionBeingFieldFor" class="w-full" >
                            A skilled worker (requiring at least two years of specialized training or experience).
                          </vs-radio>
                        </li>
                        <li>
                          <vs-radio  name="petitionFieldFor"   vs-value="g"  v-model="i140AdditionalInfo.petitionBeingFieldFor" class="w-full" >
                            Any other worker (requiring less than two years of training or experience).
                          </vs-radio>
                        </li>
                        <li>
                          <vs-radio  name="petitionFieldFor"   vs-value="h"  v-model="i140AdditionalInfo.petitionBeingFieldFor" class="w-full" >
                            An alien applying for an NIW (who IS a member of the professions holding an advanced degree or an alien of exceptional ability).
                          </vs-radio>
                        </li>
                      </ul>
                      <input type="hidden" :name="'petitionFieldFr'" v-validate="'required'"  data-vv-as="petition is being filed for"  v-model="i140AdditionalInfo.petitionBeingFieldFor">
                      <span class="text-danger text-sm" v-show="errors.has('newI140Form.petitionFieldFr')">*Petition type is required</span>
                    </div>
                    <div class="vx-col w-full mt-6 mb-4">
                      <h6 class="title-header mb-2">This petition is being filed<span class="info"> (Select only one option)</span></h6>
                      <ul class="radio_to_check" >
                        <li> 
                          <vs-radio  name="petitionBeing"  vs-value="aa" v-model="i140AdditionalInfo.petitionBeingField" class="w-auto" >
                            To amend a previously filed petition. Previous Petition Receipt Number 
                          </vs-radio>
                        </li>
                        <li>
                          <vs-radio  name="petitionBeing"   vs-value="bb"  v-model="i140AdditionalInfo.petitionBeingField" class="w-auto" >
                            For the Schedule A, Group I or II designation. 
                          </vs-radio>
                        </li>
                      </ul>
                      <template v-if="i140AdditionalInfo.petitionBeingField == 'aa'">
                        <immiInput :display="true"  cid="prevPetiReceiptNumber" :formscope="'newI140Form'" v-model="i140AdditionalInfo.prevPetiReceiptNumber" 
                        :fieldName="'prevPetiReceiptNumber'"  :required="false" :maxCharacters="13"  label="Previous Petition Receipt Number" placeHolder="Previous Petition Receipt Number" />
                      </template>
                      <!-- <input type="hidden" :name="'petitionBeiField'" v-validate="'required'"  data-vv-as="petition is being filed for"  v-model="i140AdditionalInfo.petitionBeingField">
                      <span class="text-danger text-sm" v-show="errors.has('newI140Form.petitionBeiField')">*Petition type is required</span> -->
                    </div>
                    <div class="vx-col w-full">
                      <redioButtons :defaultError="true" :wrapclass="'md:w-full'" :required="true"   :cid="'anyOtherPetiOrApplications'"
                      :formscope="'newI140Form'"  v-model="i140AdditionalInfo.anyOtherPetiOrApplications"
                      fieldName="Field"  label="Are you filing any other petitions or applications with this Form I-140?"
                      placeHolder="" />
                      <template v-if="checkProperty(i140AdditionalInfo,'anyOtherPetiOrApplications') == 'Yes'">
                        <div class="form_group">
                          <label class="form_label">Select all applicable boxes</label>
                        <div class="con-select w-full">
                          
                        <multiselect v-model="i140AdditionalInfo.petiOrApplicAllApplicableBoxes" :options="filingFormsList" :multiple="true"
                        :hideSelected="false" :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                        :select-label="'Select all applicable boxes'" placeholder="Select all applicable boxes" label="name" track-by="id" 
                        :preselect-first="false" :searchable="true"  >
                        <template slot="selection" slot-scope="{ values, isOpen }">
                          <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }} applicable box(s)
                            selected</span>
                          <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                        </template>
                      </multiselect>
                      </div>
                      </div>
                      </template>
                      <template v-if="checkAdditionalInfo && checkProperty(i140AdditionalInfo,'anyOtherPetiOrApplications') == 'Yes'">
                        <immiInput :wrapclass="'md:w-full'" :display="true"  cid="petiOrApplicAllApplicableBoxOther" :formscope="'newI140Form'" v-model="i140AdditionalInfo.petiOrApplicAllApplicableBoxOther" 
                        :fieldName="'petiOrApplicAllApplicableBoxOther'"  :required="true"  label="Provide an explanation in Part 11. Additional Information." placeHolder="Provide an explanation in Part 11. Additional Information." />
                      </template>
                      <redioButtons :defaultError="true" :wrapclass="'md:w-full'" :required="true"   :cid="'removalProceedings'"
                      :formscope="'newI140Form'"  v-model="i140AdditionalInfo.removalProceedings"
                      fieldName="removalProceedings"  label="Is the person for whom you are filing in removal proceedings?"
                      placeHolder="" />
                      <redioButtons :defaultError="true" :wrapclass="'md:w-full'" :required="true"   :cid="'immiVisaPetitionOrPerson'"
                      :formscope="'newI140Form'"  v-model="i140AdditionalInfo.immiVisaPetitionOrPerson"
                      fieldName="immiVisaPetitionOrPerson"  label="Has any immigrant visa petition ever been filed by or on behalf of this person?"
                      placeHolder="" />
                      <redioButtons :defaultError="true" :wrapclass="'md:w-full'" :required="true"   :cid="'supportOfAnotherFormi140'"
                      :formscope="'newI140Form'"  v-model="i140AdditionalInfo.supportOfAnotherFormi140"
                      fieldName="supportOfAnotherFormi140"  label="Are you filing this petition without an original labor certification because the original
                      labor certification was previously submitted in support of another Form I-140? "
                      placeHolder="" />
                      <redioButtons :defaultError="true" :wrapclass="'md:w-full'" :required="true"   :cid="'departmentOfLabor'"
                      :formscope="'newI140Form'"  v-model="i140AdditionalInfo.departmentOfLabor"
                      fieldName="departmentOfLabor"  label="If you are filing this petition without an original labor certification, are you requesting that U.S.
                      Citizenship and Immigration Services (USCIS) request a duplicate labor certification from the Department of Labor (DOL)?"
                      placeHolder="" />
                      <!-- <redioButtons :defaultError="true" :wrapclass="'md:w-full'" :required="true"   :cid="'updatePreEmployDetails'"
                      :formscope="'newI140Form'"  v-model="updatePreEmployDetails" helpText="If selects 'No', Need to update previous employment details in the questionnaire"
                      fieldName="updatePreEmployDetails"  label="Is beneficiary previous employment is matching with PERM job details?"
                      placeHolder="" /> -->
                      <div class="form_group custom-radio_wrap filing_fee_type d-block">
                        <label class="mb-2 d-block" style="font-size: 14px;">To fill Letters, consider beneficiary employment details from *</label>
                        <ul class="custom-radio" vs-type="flex" vs-align="center">
                          <li style="margin-bottom: -15px;"> 
                            <vs-radio    name="manual_entry"  vs-value="perm" v-model="i140AdditionalInfo.considerBnfEmpInfoForLetters" class="w-full"
                              ><span ref="manual_entry">PERM</span>
                            </vs-radio> 
                          </li>
                          <li style="margin-bottom: -15px;">
                            <vs-radio   ref="pre_defined"  name="manual_entry"  vs-value="questionnaire"   v-model="i140AdditionalInfo.considerBnfEmpInfoForLetters" class="w-full"
                            > <span ref="pre_defined">Questionnaire</span></vs-radio > 
                          </li>
                        </ul>
                        <input type="hidden" :name="'considerBnfEmpInfoForLettes'" v-validate="'required'"  data-vv-as="petition is being filed for"  v-model="i140AdditionalInfo.considerBnfEmpInfoForLetters">
                      <span class="text-danger text-sm mt-3" v-show="errors.has('newI140Form.considerBnfEmpInfoForLettes')">*Field is required</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div @click="formerrors.msg=''" class="text-danger text-sm formerrors" v-if="formerrors.msg!=''">
                  <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal" icon="IP-information-button"
                  active="true">{{ formerrors.msg }}</vs-alert>
                </div>
                <div class="popup-footer relative">
                <span class="loader" v-if="loadingI140"><img src="@/assets/images/main/loader.gif"></span>
                  <vs-button color="dark" class="cancel" type="filled" @click="showDetailsPopup = false;updateReload=false">Cancel</vs-button>
                  <template v-if="updatePreEmployDetails == 'No'">
                    <vs-button color="success" 
                    @click="redirectQuestionnaire()" class="save" type="filled">Update Employment Details</vs-button>
                  </template>
                  <template v-else>
                    <vs-button color="success" v-if="checkProperty(petition, 'i140AdditionalInfo') && checkProperty(petition, 'i140AdditionalInfo','petitionBeingFieldFor')"
                      :disabled="loadingI140" @click="submiti140Form(false);updateReload=false"  class="save" type="filled">Generate</vs-button>
                    <vs-button color="success" :disabled="loadingI140" @click="submiti140Form(true)"  class="save" type="filled">
                      <template v-if="checkProperty(petition, 'i140AdditionalInfo') && checkProperty(petition, 'i140AdditionalInfo','petitionBeingFieldFor')">
                      Update and Generate
                      </template>
                      <template v-else>Submit</template>
                    </vs-button>
                </template>
                </div>
            </form>
          </div>


            <!-- <invoiceDetail :ref="'invoiveDetailsPopup'" @reloadDetails="reloadDetails" v-if="invoiceDetails" @download_or_view="download_or_view" :invoiceData="invoiceDetails" /> -->
          <div> 
          </div>
        </div>
      </div>
    </template>
    <div class="workflow_view_wrap sidebar_sec" :class="{ listopen: showAdditionalQuestionnaire }">
      <div class="workflow_overlay"></div>
      <div class="workflow_view_cnt" style="width:990px">
        <div class="sidebar_head">
          <span class="close" @click="showAdditionalQuestionnaire = false"><x-icon size="1.5x" class="custom-class"></x-icon></span>
          <h2 class="popup-title" >Additional Questionnaire</h2>
        </div> 
        <div class="sidebar_cnt relative">
          <form data-vv-scope="additionalform">
            <div class="additionalform_head">
              <div class="row mt-0" >
                <div class="vx-col w-auto inline-block">
                  <div class="form_group">
                    <div class="con-select service_center w-auto mb-3">
                      <label class="form_label">Select Applicant<em>*</em></label>
                      <multiselect
                        data-vv-as="Select Applicant"
                        v-model="selectedApplicant"
                        :allow-empty="false"
                        :options="applicantList"
                        @input="changeAddInfo"
                        :multiple="false"
                        :close-on-select="true"
                        :clear-on-select="false"
                        :preserve-search="true"
                        placeholder="Select Applicant"
                        label="name"
                        track-by="name"
                        :preselect-first="false"
                        name="applicant"
                        v-validate="'required'"
                      >
                        <template slot="selection" slot-scope="{ values, isOpen }">
                          <span
                            class="multiselect__single"
                            v-if="values.length &amp;&amp; !isOpen"
                            >{{ values.length }} options selected</span
                          >
                        </template>
                      </multiselect>
                      <span
                        class="text-danger text-sm"
                        v-if="errors.has('serviceCenter')"
                        >{{ errors.first("serviceCenter") }}</span>
                    </div>
                  </div>
                </div>
              </div> 
              <vs-checkbox v-if="checkProperty(selectedApplicant, 'id') == 'beneficairy' && checkDependentsExists" v-model="considerForDependents" :name="'considerForDependents'"  
                @change="considerForAll">Consider for all Dependents
              </vs-checkbox>

              <vs-checkbox v-if="checkYesToAll" v-model="yesToAll" :name="'yesToAll'"  
                @change="changeYesAll()">Yes to All
              </vs-checkbox>

              <vs-checkbox v-if="checkNoToAll" v-model="noToAll" :name="'noToAll'"  
                @change="changeNoAll">No to All
              </vs-checkbox>
            </div>
            <i485AdditionalInformation v-model="i485AdditionalInfo" :tplsection="'beneficiaryInfo'" :formscope="'additionalform'" :fieldsArray="questionnaireDetails" />
            <div @click="formerrors.msg=''" class="text-danger text-sm formerrors" v-if="formerrors.msg!=''">
              <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal" icon="IP-information-button"
              active="true">{{ formerrors.msg }}</vs-alert>
            </div>
            
            <div class="popup-footer relative">
              <span class="loader" v-if="loadingI485"><img src="@/assets/images/main/loader.gif"></span>
              <vs-button color="dark" class="cancel" type="filled" @click="showAdditionalQuestionnaire = false">Cancel</vs-button>
              <vs-button color="success" 
              @click="updateAdditionalInfo(false)" class="save" type="filled">Generate</vs-button>
              <vs-button color="success" 
              @click="updateAdditionalInfo(true)" class="save" type="filled"> Update and Generate</vs-button>
            </div>
          </form>
          <div class="form-loader loader" v-if="changingLoader">
            <img src="@/assets/images/main/loader.gif">
          </div>
        </div>
      </div>
    </div>



    <template v-if="false">
     <modal
      name="showI140PopUp"
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="750px"
      height="auto"
    >
    <div class="v-modal applicable_boxes_modal-v2 checkbox_to_radio_change" >
      <div class="popup-header fromDetailsPage">
        <h2 class="popup-title" >I-140 Additional Questionnaire</h2>
        <span @click="showPopup=false;$modal.hide('showI140PopUp');updateReload=false"> 
          <em class="material-icons">close</em>
        </span>
      </div>        
      <form  @submit.prevent data-vv-scope="newI140Form" class="trackingform">
          <div class="form-container pb-0 i140_additional_quest">
            <div class="vx-row" >
              <div class="vx-col w-full">
                <h6 class="title-header mb-2">This petition is being filed for<span class="info"> (Select only one option)</span></h6>
                <ul class="custom-radio mb-1" >
         
                  <li> 
                    <vs-radio  :name="'petitionFieldFor'"  :vs-value="'a'" v-model="i140AdditionalInfo.petitionBeingFieldFor" class="w-full" >
                      An alien of extraordinary ability. 
                    </vs-radio>
                  </li>
                  <li>
                    <vs-radio  :name="'petitionFieldFor'"   :vs-value="'b'"  v-model="i140AdditionalInfo.petitionBeingFieldFor" class="w-full" >
                      An outstanding professor or researcher.
                    </vs-radio>
                  </li>
                  <li>
                    <vs-radio  name="petitionFieldFor"   vs-value="c"  v-model="i140AdditionalInfo.petitionBeingFieldFor" class="w-full" >
                      A multinational executive or manager. 
                    </vs-radio>
                  </li>
                  <li>
                    <vs-radio  name="petitionFieldFor"   vs-value="d"  v-model="i140AdditionalInfo.petitionBeingFieldFor" class="w-full" >
                      A member of the professions holding an advanced degree
                       or an alien of exceptional ability (who is NOT seeking a National Interest Waiver (NIW)). 
                    </vs-radio>
                  </li>
                  <li>
                    <vs-radio  name="petitionFieldFor"   vs-value="e"  v-model="i140AdditionalInfo.petitionBeingFieldFor" class="w-full" >
                      A professional (at a minimum, possessing a bachelor's degree or a foreign degree equivalent to a U.S. bachelor's degree). 
                    </vs-radio>
                  </li>
                  <li>
                    <vs-radio  name="petitionFieldFor"   vs-value="f"  v-model="i140AdditionalInfo.petitionBeingFieldFor" class="w-full" >
                      A skilled worker (requiring at least two years of specialized training or experience).
                    </vs-radio>
                  </li>
                  <li>
                    <vs-radio  name="petitionFieldFor"   vs-value="g"  v-model="i140AdditionalInfo.petitionBeingFieldFor" class="w-full" >
                      Any other worker (requiring less than two years of training or experience).
                    </vs-radio>
                  </li>
                  <li>
                    <vs-radio  name="petitionFieldFor"   vs-value="h"  v-model="i140AdditionalInfo.petitionBeingFieldFor" class="w-full" >
                      An alien applying for an NIW (who IS a member of the professions holding an advanced degree or an alien of exceptional ability).
                    </vs-radio>
                  </li>
                </ul>
                <input type="hidden" :name="'petitionFieldFr'" v-validate="'required'"  data-vv-as="petition is being filed for"  v-model="i140AdditionalInfo.petitionBeingFieldFor">
                <span class="text-danger text-sm" v-show="errors.has('newI140Form.petitionFieldFr')">*Petition type is required</span>
              </div>
              <div class="vx-col w-full mt-6 mb-4">
                <h6 class="title-header mb-2">This petition is being filed<span class="info"> (Select only one option)</span></h6>
                <ul class="radio_to_check" >
                  <li class="w-50"> 
                    <vs-radio  name="petitionBeing"  vs-value="aa" v-model="i140AdditionalInfo.petitionBeingField" class="w-full" >
                      To amend a previously filed petition. Previous Petition Receipt Number 
                    </vs-radio>
                  </li>
                  <li class="w-50">
                    <vs-radio  name="petitionBeing"   vs-value="bb"  v-model="i140AdditionalInfo.petitionBeingField" class="w-full" >
                      For the Schedule A, Group I or II designation. 
                    </vs-radio>
                  </li>
                </ul>
                <template v-if="i140AdditionalInfo.petitionBeingField == 'aa'">
                  <immiInput :display="true"  cid="prevPetiReceiptNumber" :formscope="'newI140Form'" v-model="i140AdditionalInfo.prevPetiReceiptNumber" 
                  :fieldName="'prevPetiReceiptNumber'"  :required="false" :maxCharacters="13"  label="Previous Petition Receipt Number" placeHolder="Previous Petition Receipt Number" />
                </template>
                <!-- <input type="hidden" :name="'petitionBeiField'" v-validate="'required'"  data-vv-as="petition is being filed for"  v-model="i140AdditionalInfo.petitionBeingField">
                <span class="text-danger text-sm" v-show="errors.has('newI140Form.petitionBeiField')">*Petition type is required</span> -->
              </div>
              <div class="vx-col w-full">
                <redioButtons :defaultError="true" :wrapclass="'md:w-full'" :required="true"   :cid="'anyOtherPetiOrApplications'"
                :formscope="'newI140Form'"  v-model="i140AdditionalInfo.anyOtherPetiOrApplications"
                fieldName="Field"  label="Are you filing any other petitions or applications with this Form I-140?"
                placeHolder="" />
                <template v-if="checkProperty(i140AdditionalInfo,'anyOtherPetiOrApplications') == 'Yes'">
                  <div class="form_group">
                    <label class="form_label">Select all applicable boxes</label>
                  <div class="con-select w-full">
                    
                  <multiselect v-model="i140AdditionalInfo.petiOrApplicAllApplicableBoxes" :options="filingFormsList" :multiple="true"
                  :hideSelected="false" :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                  :select-label="'Select all applicable boxes'" placeholder="Select all applicable boxes" label="name" track-by="id" 
                  :preselect-first="false" :searchable="true"  >
                  <template slot="selection" slot-scope="{ values, isOpen }">
                    <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }} applicable box(s)
                      selected</span>
                    <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                  </template>
                </multiselect>
                </div>
                </div>
                </template>
                <template v-if="checkAdditionalInfo && checkProperty(i140AdditionalInfo,'anyOtherPetiOrApplications') == 'Yes'">
                  <immiInput :wrapclass="'md:w-full'" :display="true"  cid="petiOrApplicAllApplicableBoxOther" :formscope="'newI140Form'" v-model="i140AdditionalInfo.petiOrApplicAllApplicableBoxOther" 
                  :fieldName="'petiOrApplicAllApplicableBoxOther'"  :required="true"  label="Provide an explanation in Part 11. Additional Information." placeHolder="Provide an explanation in Part 11. Additional Information." />
                </template>
                <redioButtons :defaultError="true" :wrapclass="'md:w-full'" :required="true"   :cid="'removalProceedings'"
                :formscope="'newI140Form'"  v-model="i140AdditionalInfo.removalProceedings"
                fieldName="removalProceedings"  label="Is the person for whom you are filing in removal proceedings?"
                placeHolder="" />
                <redioButtons :defaultError="true" :wrapclass="'md:w-full'" :required="true"   :cid="'immiVisaPetitionOrPerson'"
                :formscope="'newI140Form'"  v-model="i140AdditionalInfo.immiVisaPetitionOrPerson"
                fieldName="immiVisaPetitionOrPerson"  label="Has any immigrant visa petition ever been filed by or on behalf of this person?"
                placeHolder="" />
                <redioButtons :defaultError="true" :wrapclass="'md:w-full'" :required="true"   :cid="'supportOfAnotherFormi140'"
                :formscope="'newI140Form'"  v-model="i140AdditionalInfo.supportOfAnotherFormi140"
                fieldName="supportOfAnotherFormi140"  label="Are you filing this petition without an original labor certification because the original
                 labor certification was previously submitted in support of another Form I-140? "
                placeHolder="" />
                <redioButtons :defaultError="true" :wrapclass="'md:w-full'" :required="true"   :cid="'departmentOfLabor'"
                :formscope="'newI140Form'"  v-model="i140AdditionalInfo.departmentOfLabor"
                fieldName="departmentOfLabor"  label="If you are filing this petition without an original labor certification, are you requesting that U.S.
                 Citizenship and Immigration Services (USCIS) request a duplicate labor certification from the Department of Labor (DOL)?"
                placeHolder="" />
                <!-- <redioButtons :defaultError="true" :wrapclass="'md:w-full'" :required="true"   :cid="'updatePreEmployDetails'"
                :formscope="'newI140Form'"  v-model="updatePreEmployDetails" helpText="If selects 'No', Need to update previous employment details in the questionnaire"
                fieldName="updatePreEmployDetails"  label="Is beneficiary previous employment is matching with PERM job details?"
                placeHolder="" /> -->
                <div class="form_group custom-radio_wrap filing_fee_type d-block">
                  <label class="mb-2 d-block" style="font-size: 14px;">To fill Letters, consider beneficiary employment details from *</label>
                  <ul class="custom-radio" vs-type="flex" vs-align="center">
                    <li style="margin-bottom: -15px;"> 
                      <vs-radio    name="manual_entry"  vs-value="perm" v-model="i140AdditionalInfo.considerBnfEmpInfoForLetters" class="w-full"
                        ><span ref="manual_entry">PERM</span>
                      </vs-radio> 
                    </li>
                    <li style="margin-bottom: -15px;">
                      <vs-radio   ref="pre_defined"  name="manual_entry"  vs-value="questionnaire"   v-model="i140AdditionalInfo.considerBnfEmpInfoForLetters" class="w-full"
                      > <span ref="pre_defined">Questionnaire</span></vs-radio > 
                    </li>
                  </ul>
                  <input type="hidden" :name="'considerBnfEmpInfoForLettes'" v-validate="'required'"  data-vv-as="petition is being filed for"  v-model="i140AdditionalInfo.considerBnfEmpInfoForLetters">
                <span class="text-danger text-sm" v-show="errors.has('newI140Form.considerBnfEmpInfoForLettes')">*Field is required</span>
                </div>
              </div>
            </div>
          </div>
          <div @click="formerrors.msg=''" class="text-danger text-sm formerrors" v-if="formerrors.msg!=''">
            <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal" icon="IP-information-button"
             active="true">{{ formerrors.msg }}</vs-alert>
          </div>
          <div class="popup-footer relative">
          <span class="loader" v-if="loadingI140"><img src="@/assets/images/main/loader.gif"></span>
            <vs-button color="dark" class="cancel" type="filled" @click="$modal.hide('showI140PopUp');updateReload=false">Cancel</vs-button>
            <template v-if="updatePreEmployDetails == 'No'">
              <vs-button color="success" 
              @click="redirectQuestionnaire()" class="save" type="filled">Update Employment Details</vs-button>
            </template>
            <template v-else>
              <vs-button color="success" v-if="checkProperty(petition, 'i140AdditionalInfo') && checkProperty(petition, 'i140AdditionalInfo','petitionBeingFieldFor')"
                :disabled="loadingI140" @click="submiti140Form(false);updateReload=false"  class="save" type="filled">Generate</vs-button>
              <vs-button color="success" :disabled="loadingI140" @click="submiti140Form(true)"  class="save" type="filled">
                <template v-if="checkProperty(petition, 'i140AdditionalInfo') && checkProperty(petition, 'i140AdditionalInfo','petitionBeingFieldFor')">
                Update and Generate
                </template>
                <template v-else>Submit</template>
              </vs-button>
          </template>
          </div>
      </form>
      </div>
    </modal>  
  </template>
  </div>
</template>

<script>
 import i485AdditionalInformation from "@/views/forms/i485AdditionalInformation.vue";
import selectField from "@/views/forms/fields/simpleselect.vue";
 import immiInput from "@/views/forms/fields/simpleinput.vue";
import redioButtons from "@/views/forms/fields/redioButtons.vue";
import JQuery from "jquery";
import immiuploader from "@/views/forms/fields/fileupload.vue";
const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});
import fileUploadNote from "@/views/common/fileUploadNote.vue";
import casedocumentslist from "@/views/common/casedocuments.vue";
//import FileUpload from "vue-upload-component/src";
import moment from "moment";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Paginate from "vuejs-paginate";
import NoDataFound from "@/views/common/noData.vue";
import docType from "@/views/common/docType.vue";
import { XIcon } from "vue-feather-icons";
import Vue from 'vue';
Vue.use( CKEditor );
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import * as _ from "lodash";
import FileUpload from "@/views/FileUpload.vue";
export default {
  provide() {
    return {
      parentValidator: this.$validator,
    };
  },
  props: {
    // currentCaseDetails: {
    // type: Array,
    // default: new Array(),
    //},
    // workFlowDetails: {
    //   type: Object,
    //   default: null,
    // },
    lcaDetails: {
      type: Object,
      default: null,
    },
    configDetails: null,
    currentRole: null,
    currentUser: null,
    petition: {
      type: Object,
      default: null,
    },
    questionnaireDetails:{
      type: Array,
      default: [],
    }

  },
  components: {
    i485AdditionalInformation,
    immiInput,
    fileUploadNote,
    redioButtons,
    selectField,
    casedocumentslist,
    immiuploader,
    NoDataFound,
    Paginate,
    FileUpload,
    VuePerfectScrollbar,
    docType,
    XIcon,
  },
  methods: {
    getWorkflowDetails(workflowId) {
      this.workFlowDetails = null
        let payLoad = {
          path: "/workflow/details",
          data: { workflowId: workflowId },
        };
        this.$store
          .dispatch("commonAction", payLoad)
          .then((res) => {
            this.workFlowDetails = res;
            if (_.has(this.workFlowDetails, "config")) {
              let adminsactiVityList = _.find(this.workFlowDetails.config, {
              code: "MANAGER_LIST",
            });
            if (adminsactiVityList && adminsactiVityList.editors) {
            this.adminsList = _.map(adminsactiVityList.editors, "roleId");
            }
            
            }
          })
          .catch((error) => {
            this.workFlowDetails = null;
            
          });
      
    },
    changeAddInfo(){
      this.noToAll = false;
			this.yesToAll = false;
      // this.changingLoader = true;
      if(this.checkProperty(this.selectedApplicant, 'id') == 'beneficairy'){ 
        if(_.has(this.petition['beneficiaryInfo'],'i485AdditionalInfo') && this.checkProperty(this.petition['beneficiaryInfo'], 'i485AdditionalInfo')
        && _.has(this.petition['beneficiaryInfo'],'i485AdditionalInfoFilled') && this.checkProperty(this.petition,'beneficiaryInfo', 'i485AdditionalInfoFilled') === true){
          this.i485AdditionalInfo = _.cloneDeep(this.petition['beneficiaryInfo']['i485AdditionalInfo'])
        }else{
          this.resetKeys()
        }
      }
      if(this.checkProperty(this.selectedApplicant, 'id') == 'spouse'){ 
        this.considerForDependents = false;
        if(this.checkProperty(this.petition['dependentsInfo'], 'spouse') && _.has(this.petition['dependentsInfo']['spouse'],'i485AdditionalInfo') && this.checkProperty(this.petition['dependentsInfo'], 'spouse', 'i485AdditionalInfo')
        && _.has(this.petition['dependentsInfo']['spouse'],'i485AdditionalInfoFilled') && this.checkProperty(this.petition['dependentsInfo'],'spouse', 'i485AdditionalInfoFilled') === true){
          this.i485AdditionalInfo = _.cloneDeep(this.petition['dependentsInfo']['spouse']['i485AdditionalInfo'])
        }else{
          this.resetKeys()
        }
      }
      if(this.checkProperty(this.selectedApplicant, 'id') == 'children' && this.checkProperty(this.petition,'dependentsInfo','childrens') && this.checkProperty(this.petition['dependentsInfo'],'childrens','length')>0){
        this.considerForDependents = false;
        _.forEach(this.petition['dependentsInfo']['childrens'], (cItem)=>{
          if(cItem['_id'] == this.checkProperty(this.selectedApplicant, 'childId')){
            if(_.has(cItem, 'i485AdditionalInfo') && this.checkProperty(cItem, 'i485AdditionalInfo')
            && _.has(cItem,'i485AdditionalInfoFilled') && this.checkProperty(cItem, 'i485AdditionalInfoFilled') === true){
              this.i485AdditionalInfo = _.cloneDeep(cItem['i485AdditionalInfo'])
            }else{
              this.resetKeys()
            }
          }
        })
      }
      // this.changingLoader = false;
    },
    updateAdditionalInfo(updateCall = true){
      this.$validator.validateAll('additionalform').then((result) => {
        if(updateCall){
          if(result){
            let self = this;
            let payLoad = {
              petitionId:this.checkProperty(this.petition, '_id'),
              i485AditionalInfo:[]
            };
            if(this.checkProperty(this.selectedApplicant, 'id') == 'beneficairy' && this.considerForDependents){
              let list = [];
              let obj = {
                category:'',
                i485AdditionalInfo:null
              };
              _.forEach(this.applicantList, (appItem)=>{
                obj['category'] = appItem['id'];
                if(appItem['id'] == 'children'){
                  obj['childId'] = appItem['childId'];
                }
                obj['i485AdditionalInfo'] = this.i485AdditionalInfo;
                list.push(obj);
                obj = {category:'',i485AdditionalInfo:null};
              });
              payLoad['i485AditionalInfo'] = list;
            }else{
              let list = [];
              let obj = {
                category:this.checkProperty(this.selectedApplicant, 'id'),
                i485AdditionalInfo:this.i485AdditionalInfo
              };
              if(this.checkProperty(this.selectedApplicant, 'id') == 'children'){
                obj['childId'] = this.checkProperty(this.selectedApplicant, 'childId');
              };
              list.push(obj);
              payLoad['i485AditionalInfo'] = list;
            };
            this.formerrors.msg = '';
            this.updateReload = false;
            this.$store.dispatch('commonAction', {data:payLoad, path:'/petition/update-gc-additional-info'}).then((response)=>{
              this.updateReload = true;
              this.showToster({message:response.message,isError:false });
              self.showAdditionalQuestionnaire = false;
              self.getMasetFormsAndLatters(true);
            }).catch((err)=>{
              this.formerrors.msg = err;
              this.updateReload = false;
            })
          }
        }else{
          this.updateReload = true;
          this.showAdditionalQuestionnaire = false;
          this.getMasetFormsAndLatters(true);
        }
      })
    },
    openGenerateForms(){},
    considerForAll(){},
    changeYesAll(){
     let self = this;
     self.changingLoader = true;
      let catKeys =Object.entries(this.i485AdditionalInfo);
      // setTimeout(()=>{
        if(self.yesToAll){
          self.noToAll = false;
          _.forEach(catKeys, (item)=>{
            if(item && item[0] && self.ignore485Keys.indexOf(item[0])<=-1){
              self.i485AdditionalInfo[item[0]] = true
            }
          })
        }else{
          _.forEach(catKeys, (item)=>{
            if(item && item[0] && self.ignore485Keys.indexOf(item[0])<=-1){
              self.i485AdditionalInfo[item[0]] = null
            }
          })
          
        }
        // self.i485AdditionalInfo = _.cloneDeep(self.i485AdditionalInfo)
      // })
      setTimeout(()=>{
        self.changingLoader = false;
      }, 3000)
      
    },
    changeNoAll(){
      let self = this;
      self.changingLoader = true;
      let catKeys =Object.entries(this.i485AdditionalInfo);
      if(this.noToAll){
        this.yesToAll = false;
        _.forEach(catKeys, (item)=>{
          if(item && item[0] && this.ignore485Keys.indexOf(item[0])<=-1){
            this.i485AdditionalInfo[item[0]] = false
          }else if(item && item[0] && this.ignore485Keys.indexOf(item[0])>-1){
            this.i485AdditionalInfo[item[0]] = null
          }
        })
      }else{
        _.forEach(catKeys, (item)=>{
          if(item && item[0] && this.ignore485Keys.indexOf(item[0])<=-1){
            this.i485AdditionalInfo[item[0]] = null
          }else if(item && item[0] && this.ignore485Keys.indexOf(item[0])>-1){
            this.i485AdditionalInfo[item[0]] = null
          }
        })
      }
      setTimeout(()=>{
        self.changingLoader = false;
      }, 3000)
    },
    generateApplicantList(){
      let list = [];
      let obj = {name:'',id:'',type:'',childId:''};
      if(this.checkProperty(this.petition,'beneficiaryInfo') && this.checkProperty(this.petition['beneficiaryInfo'],'name')){
        obj['name'] = this.checkProperty(this.petition['beneficiaryInfo'],'name') +' (Beneficiary)';
        obj['id'] = 'beneficairy';
        obj['type'] = 'Beneficiary';
        list.push(obj);
        obj = {name:'',id:'',type:'',childId:''};
      }
      if(this.checkProperty(this.petition['dependentsInfo'],'spouse') && this.checkProperty(this.petition['dependentsInfo'],'spouse','name')){
        obj['name'] = this.checkProperty(this.petition['dependentsInfo'],'spouse','name') +' (Spouse)';
        obj['id'] = 'spouse';
        obj['type'] = 'Spouse';
        list.push(obj);
        obj = {name:'',id:'',type:'',childId:''};
      }
      if(this.checkProperty(this.petition,'dependentsInfo','childrens') && this.checkProperty(this.petition['dependentsInfo'],'childrens','length')>0 ){
        _.forEach(this.petition['dependentsInfo']['childrens'], (chidItem)=>{
          if(this.checkProperty(chidItem, 'name') && this.checkProperty(chidItem, 'h4Required')){ 
            obj['name'] = this.checkProperty(chidItem, 'name') +' (Child)';
            obj['id'] = 'children';
            obj['type'] = 'Child';
            obj['childId'] = this.checkProperty(chidItem, '_id');
            let findObj = _.find(list, {childId:chidItem['_id']});
            if(!findObj){
              list.push(obj);
            }
            obj = {name:'',id:'',type:'',childId:''};
          }
        })
      }
      // console.log(JSON.stringify(list))
      if(list && list.length>0){
        this.applicantList = list
      }
    },
    resetKeys(){
      let obj ={
      everDeniedAdmissionInUS: null, // 14.Have you EVER been denied admission to the United States?
      isVisaDenieedTOUS: null, /// 15.HAVE YOU EVER BEEN DENIED A VISA TO THE UNITED STATES?
      everWorkedInUSWithoutAuth: null, // 16. Have you EVER worked in the United States without authorization?
      everViolatedTandCofYourNonImmStatus: null, // 17. Have you EVER violated the terms or conditions of your nonimmigrant status?
      everBeenInRemovalExcl: null, // 18. Are you presently or have you EVER been in removal, exclusion, rescission, or deportation proceedings?
      everBeenIssuedOrderExclRemoval: null, // 19. Have you EVER been issued a final order of exclusion, deportation, or removal?
      everHadPriorOrderExclDeport: null, // 20. Have you EVER had a prior final order of exclusion, deportation, or removal reinstated?
      
      everHeldPermResidentStatus: null, //21.Have you EVER held lawful permanent resident status which was later rescinded?
      everGrantedVolDepartimmgOfficer: null,//22.Have you EVER been granted voluntary departure by an immigration officer or an immigration judge but failed todepart within the allotted time?
      everAppliedReliefOrExclDeport: null,//23.Have you EVER applied for any kind of relief or protection from removal, exclusion, or deportation?
      everJNonImmmExchangeVistor: null,//24.a. Have you EVER been a J nonimmigrant exchange visitor who was subject to the two-year foreign residencerequirement?
      //if 24.a yes
      everCompailedForeignResi: null, //24.b Have you complied with the foreign residence requirement?
      everGrantedWavierRecomndLtr: null, //24.c Have you been granted a waiver or has Department of State issued a favorable waiver recommendation letter for you? 
      
      //Criminal Acts and Violations
      everArrested: null, //25. Have you EVER been arrested, cited, charged, or detained for any reason by any law enforcement official(including but not limited to any U.S. immigrationofficial or any official of the U.S. armed forces or U.S.Coast Guard)?
      everCommittedCrime: null, //26.Have you EVER committed a crime of any kind (even if you were not arrested, cited, charged with, or tried for thatcrime)? 
      everPledGuilty: null, //27.Have you EVER pled guilty to or been convicted of a crime or offense (even if the violation was subsequently expunged or sealed by a court, or if you were granted apardon, amnesty, a rehabilitation decree, or other act ofclemency)?
      everPunishedByJudge: null, //28.Have you EVER been ordered punished by a judge or had conditions imposed on you that restrained your liberty(such as a prison sentence, suspended sentence, housearrst, parole, alternative sentencing, drug or alcoholtreatment, rehabilitative programs or classes, probation, orcommunity service)?
      everAccusedCrimProc: null, //29.Have you EVER been a defendant or the accused in acriminal proceeding (including pre-trial diversion,deferred prosecution, deferred adjudication, or any withheld adjudication)? 
      everViolated: null, //30.Have you EVER violated (or attempted or conspired toviolate) any controlled substance law or regulation of astate, the United States, or a foreign country?
      everConvictedTwoOrMoreOffens: null,//31.Have you EVER been convicted of two or more offenses(other than purely political offenses) for which thecombined sentences to confinement were five years ormore?
      everIlleglTraf: null, //32.Have you EVER illicitly (illegally) trafficked or benefitedfrom the trafficking of any controlled substances, such aschemicals, illegal drugs, or narcotics?
      everKnowinglyIlleglTraf: null, //33.Have you EVER knowingly aided, abetted, assisted,conspired, or colluded in the illicit trafficking of anyillegal narcotic or other controlled substances?
      everSpouseSondaughterIlleglTraf: null,//34. Are you the spouse, son, or daughter of a foreign nationalwho illicitly trafficked or aided (or otherwise abetted,assisted, conspired, or colluded) in the illicit trafficking ofa controlled substance, such as chemicals, illegal drugs, ornarcotics and you obtained, within the last five years, anyfinancial or other benefit from the illegal activity of yourspouse or parent, although you knew or reasonably shouldhave known that the financial or other benefit resultedfrom the illicit activity of your spouse or parent?
      everEngageProst: null,//35.Have you EVER engaged in prostitution or are you coming to the United States to engage in prostitution?
      everdirOrIndirectProst: null, //36.Have you EVER directly or indirectly procured (or attempted to procure) or imported  prostitutes or persons for the purpose of prostitution?
      everReceiveMoneyFronProst: null, //37.Have you EVER received any proceeds or money fromprostitution?
      everIntentIllegalGamblUS: null, //38.Do you intend to engage in illegal gambling or any other form of commercialized vice, such as prostitution,bootlegging, or the sale of child pornography, while in the United States?
      everImmunityCriminalOffensedInUS: null, //39.Have you EVER exercised immunity (diplomatic or otherwise) to avoid being prosecuted for a criminaloffense in the United States?
      everViolateReliFreedomAsForeignGovOffi: null,//40. Have you EVER, while serving as a foreign governmentofficial, been responsible for or directly carried outviolations of religious freedoms?
      everForceFraudCommercialSexActs: null,//41.Have you EVER induced by force, fraud, or coercion (orotherwise been involved in) the trafficking of persons forcommercial sex acts?
      everTraffPersonIntoInvolSlavery: null, //42.Have you EVER trafficked a person into involuntary servitude, peonage, debt bondage, or slavery? Trafficking includes recruiting, harboring, transporting, providing, or obtaining a person for labor or services through the use offorce, fraud, or coercion.
      everKnowWithTraffPersonCommSexAct: null, //43.Have you EVER knowingly aided, abetted, assisted, conspired, or colluded with others in trafficking persons for commercial sex acts or involuntary servitude, peonage, debt bondage, or slavery?
      everSpouseSonDughterEngTraffAnyFinBef: null,//44.Are you the spouse, son or daughter of a foreign national who engaged in the trafficking of persons and have received or obtained, within the last five years, any financial or other benefits from the illicit activity of your spouse or your parent, although you knew or reasonably should have known that this benefit resulted from the illicit activity of your spouse or parent?
      everEngMoneyLaundering: null,//45.Have you EVER engaged in money laundering or have you EVER knowingly aided, assisted, conspired, or colluded with others in money laundering or do you seek to enter the United States to engage in such activity?
      
      //Security and Related
      everViolateEvidenceLawRelatedInUS: null,//46.a. Engage in any activity that violates or evades any law relating to espionage (including spying) or sabotage in theUnited States?
      everViolateExpGoodsSensInfoTechInUS: null,//46.b. Engage in any activity in the United States that violates or evades any law prohibiting the export from the United States of goods, technology, or sensitive information? 
      everOverthrowingUSGovtByForceViolence: null,//46.c. Engage in any activity whose purpose includes opposing,controlling, or overthrowing the U.S. Government byforce, violence, or other unlawful means while in theUnited States?
      everActivityDangerScurityOfUs: null,//46.d.Engage in any activity that could endanger the welfare,safety, or security of the United States? 
      everEngUnlawfulActivity: null,//46.e.Engage in any other unlawful activity?
      everEngActSeriousForeignPolicyforUs: null,//47.Are you engaged in or, upon your entry into the United States, do you intend to engage in any activity that could have potentially serious adverse foreign policy consequences for the United States?
      everCommitedKidnapHjkEtc: null,//48.a. Committed, threatened to commit, attempted to commit,conspired to commit, incited, endorsed, advocated,planned, or prepared any of the following: hijacking,sabotage, kidnapping, political assassination, or use of aweapon or explosive to harm another individual or causesubstantial damage to property? 
      everCommMemberGrpOrgKidnapHjkEtc: null, //48.b. Participated in, or been a member of, a group ororganization that did any of the activities described in Item Number 48.a.? 
      everAskMoneyRecruGrpKidnapHijackEtc: null, //48.c.Recruited members or asked for money or things of value for a group or organization that did any of the activitiesdescribed in Item Number 48.a.?
      everProvideMoneyForAssiKidnapHjkEtc: null, //48.d.Provided money, a thing of value, services or labor, orany other assistance or support for any of the activitiesdescribed in Item Number 48.a.? 
      everProvideMoneyForAssiIndiGrpKidnapHjkEtc: null,//48.e. Provided money, a thing of value, services or labor, or any other assistance or support for an individual, group,or organization who did any of the activities described inItem Number 48.a.?
      everTraiParaOrMilataryWepons: null,//49.Have you EVER received any type of military,paramilitary, or weapons training? 
      everEngKidnapHjkEtc: null,//50.Do you intend to engage in any of the activities listed in any part of Item Numbers 48.a. - 49.?
      //if answered yes items b/w 46.a to 50
      //Additional info
      everSpoOrChiEngKidnapHjkEtc: null,//51.a. Committed, threatened to commit, attempted to commit,conspired to commit, incited, endorsed, advocated,planned, or prepared any of the following: hijacking,sabotage, kidnapping, political assassination, or use of a weapon or explosive to harm another individual or cause substantial damage to property? 
      everHSpoOrChiPartMemberKidnapHjkEtc: null, //51.b. Participated in, or been a member or a representative of agroup or organization that did any of the activities described in Item Number 51.a.? 
      everSpoOrChiRecrutKidnapHjkEtc: null, //51.c. Recruited members, or asked for money or things of value,for a group or organization that did any of the activities described in Item Number 51.a.? 
      everSpoOrChiAskMoneyAssiKidnapHjkEtc: null,//51.d. Provided money, a thing of value, services or labor, or any other assistance or support for any of the activities described in Item Number 51.a.? 
      everSpoOrChiForAssiIndiGrpKidnapHjkEtc: null,//51.e. Provided money, a thing of value, services or labor, or any other assistance or support to an individual, group, or ganization who did any of the activities described in Item Number 51.a.? 
      everSpoOrChiTraiParaOrMilataryWeponKidnapHjkEtc: null,//51.f. Received any type of military, paramilitary, or weapons training from a group or organization that did any of the activities described in Item Number 51.a.? 
      //if answered yes items of 51
      //Additional info
      everSellProvideTransWepon: null,//52. Have you EVER assisted or participated in selling,providing, or transporting weapons to any person who,to your knowledge, used them against another person?
      everWorkedPrisionAndDetained: null,//53. Have you EVER worked, volunteered, or otherwiseserved in any prison, jail, prison camp, detention facility,labor camp, or any other situation that involved detainingpersons?
      everUsingWeponPartGrpOrgThreatPerson: null,//54.Have you EVER been a member of, assisted, or participated in any group, unit, or organization of anykind in which you or other persons used any type ofweapon against any person or threatened to do so?
      everServedParaOrMilataryEtc: null,//55.Have you EVER served in, been a member of, assisted,or participated in any military unit, paramilitary unit,police unit, self-defense unit, vigilante unit, rebel group,guerilla group, militia, insurgent organization, or anyother armed group?
      everMemberCommPartyInUS: null,//56.Have you EVER been a member of, or in any way affiliated with, the Communist Party or any othertotalitarian party (in the United States or abroad)?
      ever080545To230393AssoNaziGerGov: null,//57.During the period from March 23, 1933 to May 8, 1945,did you ever order, incite, assist, or otherwise participatein the persecution of any person because of race, religion,national origin, or political opinion, in association witheither the Nazi government of Germany or anyorganization or government associated or allied with theNazi government of Germany?
      everInvolveTorture: null,//58.a. Acts involving torture or genocide?
      everKillAnyPerson: null,//58.b.Killing any person?
      everSeverInjuAnyPerson: null,//58.c.Intentionally and severely injuring any person?
      everEngAnySexualContent: null,//58.d. Engaging in any kind of sexual contact or relations with any person who did not consent or was unable to consent, or was being forced or threatened?
      everLimitReligBnf: null,//58.e. Limiting or denying any person's ability to exercise religious beliefs?
      everUsedBelow15yrsPerson: null,//59.Have you EVER recruited, enlisted, conscripted, or usedany person under 15 years of age to serve in or help anarmed force or group?
      everHelpUnder15yrsPerson: null,//60. Have you EVER used any person under 15 years of age to take part in hostilities, or to help or provide services to people in combat?
      //if answered yes items b/w 52 to 60
      //Public Assistance
      everRcvPublicAssiInUS: null,//61.Have you received public assistance in the United Statesfrom any source, including the U.S. Government or anystate, county, city, or municipality (other than emergencymedical treatment)?
      everFutureRcvPublicAssiInUs: null,//62.Are you likely to receive public assistance in the future inthe United States from any source, including the U.S.Government or any state, county, city, or municipality(other than emergency medical treatment)?
      //Illegal Entries and Other Immigration Violations
      everAttenRmvProcFiledAfter010497: null,//63.a. Have you EVER failed or refused to attend or to remain in attendance at any removal proceeding filed against youon or after April 1, 1997?
      everRmvProcFiledReason: null,//63.b. If your answer to Item Number 63.a. is "Yes," do youbelieve you had reasonable cause?
      rmvProcFiledResonWriteStmt: '',//63.c.If your answer to Item Number 63.b. is "Yes," attach a written statement explaining why you had reasonable cause.
      everSubmitFraudDocUSGov: null,//64.Have you EVER submitted fraudulent or counterfeit documentation to any U.S. Government official to obtainor attempt to obtain any immigration benefit, including avisa or entry into the United States?
      everLiedMisrepreInfoEnterUS: null,//65.Have you EVER lied about, concealed, or misrepresented any information on an application or petition to obtain avisa, other documentation required for entry into theUnited States, admission to the United States, or any otherkind of immigration benefit?
      everClaimFlaslyUSCitizen: null,//66.Have you EVER falsely claimed to be a U.S. citizen (inwriting or any other way)?
      everStowawayOnVessel: null,//67.Have you EVER been a stowaway on a vessel or aircraft arriving in the United States?
      everTrytoEnterUsIllegaly: null,//68. Have you EVER knowingly encouraged, induced, assisted,abetted, or aided any foreign national to enter or to try toenter the United States illegally (alien smuggling)?
      everFinalOrderCivilPenalty: null,//69. Are you under a final order of civil penalty for violating INA section 274C for use of fraudulent documents?
      //Removal, Unlawful Presence, or Illegal Reentry After Previous Immigration Violations
      everRemovedfromUs: null,//70. Have you EVER been excluded, deported, or removedfrom the United States or have you ever departed theUnited States on your own after having been ordered excluded, deported, or removed from the United States?
      everEnterUSWithoutInspAdmit: null, //71.Have you EVER entered the United States without being inspected and admitted or paroled?
      everSince010497More180DLessYrULFStayUS: null,//72.a. For more than 180 days but less than a year, and thendeparted the United States?
      everSince010497YrOrMoreULFDepartUS: null,//72.b.For one year or more and then departed the United States?  
      everSince010497ReEntMoreYrULFStayUS: null,//73.a.Having been unlawfully present in the United States for more than one year in the aggregate?
      everSince010497RmvFromUS: null,//73.b.Having been deported, excluded, or removed from the United States?
      //Miscellaneous Conduct
      planForPractPolyInUS: null,//Do you plan to practice polygamy in the United States?
      AreYouAccomOtherCountry: null,//75.Are you accompanying another foreign national who requires your protection or guardianship but who isinadmissible after being certified by a medical officer asbeing helpless from sickness, physical or mentaldisability, or infancy, as described in INA section 232(c)?
      everAnyUsChildUnderCustody: null,//76. Have you EVER assisted in detaining, retaining, or withholding custody of a U.S. citizen child outside theUnited States from a U.S. citizen who has been grantedcustody of the child?
      everVoilationAnyFedaral: null,//77.Have you EVER voted in violation of any Federal, state,or local constitutional provision, statute, ordinance, orregulation in the United States?
      everUsCtzshipAvoidTax: null,//78.Have you EVER renounced U.S. citizenship to avoidbeing taxed by the United States?
      everAppliedForExemptServiceUS: null,//79.a. Applied for exemption or discharge from training or service in the U.S. armed forces or in the U.S. NationalSecurity Training Corps on the ground that you are aforeign national?
      everReliServTrainAreYouForeignNation: null,//79.b. Been relieved or discharged from such training or serviceon the ground that you are a foreign national?
      everConvictDestUSArmedForce: null,//79.c. Been convicted of desertion from the U.S. armed forces?
      everRemOutsideUSAviodTrainArmedForce: null,//80.a. Have you EVER left or remained outside the United States to avoid or evade training or service in the U.S.armed forces in time of war or a period declared by thePresident to be a national emergency?
      nationImgrstaIfAviodTrainArmForcUS: '',//80.b. If your answer to Item Number 80.a. is “Yes,” what was your nationality or immigration status immediately beforeyou left (for example, U.S. citizen or national, lawfulpermanent resident, nonimmigrant, parolee, present without admission or parole, or any other status)?
        
      };
      this.i485AdditionalInfo = _.cloneDeep(obj);
      this.$validator.reset();
    },
    selct_all_docs(category, callFromSelectall = false, childCategory, subCategory=''){
      if(callFromSelectall){
        if(category == 'beneficiary' && subCategory !='uploadAfterUSCIS' ){
          setTimeout(()=>{
            let action = this.beneficiaryDownloadDoc.selectedAll
            _.map(this.beneficiaryDownloadDoc['documents'], (item) => {
              item["selectedForDownload"] = action;
              if ( this.checkProperty(item, "reverse_document_versions") && item["reverse_document_versions"].length > 0 ) {
                _.map(item["reverse_document_versions"], (vItem) => {
                  vItem.selectedForDownload = false;
                });
              }
            });
          },10)
        }
        if(category == 'beneficiary' && subCategory =='uploadAfterUSCIS'  ){
          setTimeout(()=>{
            let action = this.uscisbeneficiaryDownloadDoc.selectedAll
            _.map(this.uscisbeneficiaryDownloadDoc['documents'], (item) => {
              item["selectedForDownload"] = action;
              if ( this.checkProperty(item, "reverse_document_versions") && item["reverse_document_versions"].length > 0 ) {
                _.map(item["reverse_document_versions"], (vItem) => {
                  vItem.selectedForDownload = false;
                });
              }
            });
          },10)
        }
        if(category == 'spouse'  && subCategory !='uploadAfterUSCIS'){
          setTimeout(()=>{
            let action = this.spouseDownloadDoc.selectedAll
            _.map(this.spouseDownloadDoc['documents'], (item) => {
              item["selectedForDownload"] = action;
              if ( this.checkProperty(item, "reverse_document_versions") && item["reverse_document_versions"].length > 0 ) {
                _.map(item["reverse_document_versions"], (vItem) => {
                  vItem.selectedForDownload = false;
                });
              }
            });
          },10)
          
        }
        if(category == 'spouse'  && subCategory =='uploadAfterUSCIS'){
          setTimeout(()=>{
            let action = this.uscisspouseDownloadDoc.selectedAll
            _.map(this.uscisspouseDownloadDoc['documents'], (item) => {
              item["selectedForDownload"] = action;
              if ( this.checkProperty(item, "reverse_document_versions") && item["reverse_document_versions"].length > 0 ) {
                _.map(item["reverse_document_versions"], (vItem) => {
                  vItem.selectedForDownload = false;
                });
              }
            });
          },10)
          
        }
        if(category == 'child' && subCategory !='uploadAfterUSCIS'){
          setTimeout(()=>{
            _.map(this.childrenDownloadDoc, (childItm)=>{
              if(_.has(childItm, 'docUserType') && childItm['docUserType'] == childCategory ){
                let action = childItm['selectedAll'];
                _.map(childItm['documents'], (item) => {
                  item["selectedForDownload"] = action;
                  if ( this.checkProperty(item, "reverse_document_versions") && item["reverse_document_versions"].length > 0 ) {
                    _.map(item["reverse_document_versions"], (vItem) => {
                      vItem.selectedForDownload = false;
                    });
                  }
                });
              }
            })
          },10)
        }
        if(category == 'child' && subCategory =='uploadAfterUSCIS'){
          setTimeout(()=>{
            _.map(this.uscischildrenDownloadDoc, (childItm)=>{
              if(_.has(childItm, 'docUserType') && childItm['docUserType'] == childCategory ){
                let action = childItm['selectedAll'];
                _.map(childItm['documents'], (item) => {
                  item["selectedForDownload"] = action;
                  if ( this.checkProperty(item, "reverse_document_versions") && item["reverse_document_versions"].length > 0 ) {
                    _.map(item["reverse_document_versions"], (vItem) => {
                      vItem.selectedForDownload = false;
                    });
                  }
                });
              }
            })
          },10)
        }
      }else{
        if(category == 'beneficiary' && subCategory !='uploadAfterUSCIS' ){
          setTimeout(()=>{
            let self = this;
            let totalCount =0;
            let selectedCount =0;
            let unSelectedCount =0;
            _.forEach(this.beneficiaryDownloadDoc['documents'], (item) => {
              totalCount = totalCount+1;
              if(_.has(item, 'selectedForDownload') && item['selectedForDownload']){
                selectedCount = selectedCount+1
              }else{
                unSelectedCount = unSelectedCount+1
              }
            });
            if(selectedCount>0 &&  unSelectedCount== 0 &&  selectedCount ==totalCount ){
              self.beneficiaryDownloadDoc['selectedAll'] = true;
            }else{
              self.beneficiaryDownloadDoc['selectedAll'] = false;
            }
          },10)
        }
        if(category == 'beneficiary' && subCategory =='uploadAfterUSCIS' ){
          setTimeout(()=>{
            let self = this;
            let totalCount =0;
            let selectedCount =0;
            let unSelectedCount =0;
            _.forEach(this.uscisbeneficiaryDownloadDoc['documents'], (item) => {
              totalCount = totalCount+1;
              if(_.has(item, 'selectedForDownload') && item['selectedForDownload']){
                selectedCount = selectedCount+1
              }else{
                unSelectedCount = unSelectedCount+1
              }
            });
            if(selectedCount>0 &&  unSelectedCount== 0 &&  selectedCount ==totalCount ){
              self.uscisbeneficiaryDownloadDoc['selectedAll'] = true;
            }else{
              self.uscisbeneficiaryDownloadDoc['selectedAll'] = false;
            }
          },10)
        }
        if(category == 'spouse' && subCategory !='uploadAfterUSCIS'){
          setTimeout(()=>{
            let self = this;
            let totalCount =0;
            let selectedCount =0;
            let unSelectedCount =0;
            _.forEach(this.spouseDownloadDoc['documents'], (item) => {
              totalCount = totalCount+1;
              if(_.has(item, 'selectedForDownload') && item['selectedForDownload']){
                selectedCount = selectedCount+1
              }else{
                unSelectedCount = unSelectedCount+1
              }
            });
            if(selectedCount>0 &&  unSelectedCount== 0 &&  selectedCount ==totalCount ){
              self.spouseDownloadDoc['selectedAll'] = true;
            }else{
              self.spouseDownloadDoc['selectedAll'] = false;
            }
          },10)
        }
        if(category == 'spouse' && subCategory =='uploadAfterUSCIS' ){
          setTimeout(()=>{
            let self = this;
            let totalCount =0;
            let selectedCount =0;
            let unSelectedCount =0;
            _.forEach(this.uscisspouseDownloadDoc['documents'], (item) => {
              totalCount = totalCount+1;
              if(_.has(item, 'selectedForDownload') && item['selectedForDownload']){
                selectedCount = selectedCount+1
              }else{
                unSelectedCount = unSelectedCount+1
              }
            });
            if(selectedCount>0 &&  unSelectedCount== 0 &&  selectedCount ==totalCount ){
              self.uscisspouseDownloadDoc['selectedAll'] = true;
            }else{
              self.uscisspouseDownloadDoc['selectedAll'] = false;
            }
          },10)
        }
        if(category == 'child'  && subCategory !='uploadAfterUSCIS'){
          setTimeout(()=>{
            _.map(this.childrenDownloadDoc, (childItm)=>{
              if(_.has(childItm, 'docUserType') && childItm['docUserType'] == childCategory ){
                let totalCount =0;
                let selectedCount =0;
                let unSelectedCount =0;
                _.forEach(childItm['documents'], (item) => {
                  totalCount = totalCount+1;
                  if(_.has(item, 'selectedForDownload') && item['selectedForDownload']){
                    selectedCount = selectedCount+1
                  }else{
                    unSelectedCount = unSelectedCount+1
                  }
                });
                if(selectedCount>0 &&  unSelectedCount== 0 &&  selectedCount ==totalCount ){
                  childItm['selectedAll'] = true;
                }else{
                  childItm['selectedAll'] = false;
                }
              }
            })
          },10)
        }
        if(category == 'child' && subCategory =='uploadAfterUSCIS'){
          setTimeout(()=>{
            _.map(this.uscischildrenDownloadDoc, (childItm)=>{
              if(_.has(childItm, 'docUserType') && childItm['docUserType'] == childCategory ){
                let totalCount =0;
                let selectedCount =0;
                let unSelectedCount =0;
                _.forEach(childItm['documents'], (item) => {
                  totalCount = totalCount+1;
                  if(_.has(item, 'selectedForDownload') && item['selectedForDownload']){
                    selectedCount = selectedCount+1
                  }else{
                    unSelectedCount = unSelectedCount+1
                  }
                });
                if(selectedCount>0 &&  unSelectedCount== 0 &&  selectedCount ==totalCount ){
                  childItm['selectedAll'] = true;
                }else{
                  childItm['selectedAll'] = false;
                }
              }
            })
          },10)
        }
      }
    },
    downloadallFormslatters(downLoadZip = true) {
      let postdata = {
        petitionId: this.petition._id,
        documentIds: [],
        downloadType: "zip",
        entityType: "case",
      };
      if (!downLoadZip) {
        postdata["downloadType"] = "pdf";
      }
      let self = this;
      Object.assign(this.formerrors, { msg: "" });
      // beneficiaryDownloadDoc   uscisbeneficiaryDownloadDoc uscisspouseDownloadDoc uscischildrenDownloadDoc
      if(this.checkProperty(this.beneficiaryDownloadDoc, 'documents') && this.checkProperty(this.beneficiaryDownloadDoc, 'documents', 'length')>0){
        _.forEach(this.beneficiaryDownloadDoc['documents'], (doc)=>{
          if ( doc["selectedForDownload"] &&  postdata["documentIds"].indexOf(doc._id) <= -1 ) {
            postdata["documentIds"].push(doc._id);
          }
          if ( this.checkProperty(doc, "reverse_document_versions") && doc["reverse_document_versions"].length > 0 ) {
            _.forEach(doc["reverse_document_versions"], (vItem) => {
              if (
                vItem["selectedForDownload"] &&
                postdata["documentIds"].indexOf(vItem._id) <= -1
              ) {
                postdata["documentIds"].push(vItem._id);
              }
            });
          }
        })
      }
      if(this.checkProperty(this.uscisbeneficiaryDownloadDoc, 'documents') && this.checkProperty(this.uscisbeneficiaryDownloadDoc, 'documents', 'length')>0 && this.checkSubmitToUscisCompleted){
        _.forEach(this.uscisbeneficiaryDownloadDoc['documents'], (doc)=>{
          if ( doc["selectedForDownload"] &&  postdata["documentIds"].indexOf(doc._id) <= -1 ) {
            postdata["documentIds"].push(doc._id);
          }
          if ( this.checkProperty(doc, "reverse_document_versions") && doc["reverse_document_versions"].length > 0 ) {
            _.forEach(doc["reverse_document_versions"], (vItem) => {
              if (
                vItem["selectedForDownload"] &&
                postdata["documentIds"].indexOf(vItem._id) <= -1
              ) {
                postdata["documentIds"].push(vItem._id);
              }
            });
          }
        })
      }
      if(this.checkProperty(this.spouseDownloadDoc, 'documents') && this.checkProperty(this.spouseDownloadDoc, 'documents', 'length')>0){
        _.forEach(this.spouseDownloadDoc['documents'], (doc)=>{
          if ( doc["selectedForDownload"] &&  postdata["documentIds"].indexOf(doc._id) <= -1 ) {
            postdata["documentIds"].push(doc._id);
          }
          if ( this.checkProperty(doc, "reverse_document_versions") && doc["reverse_document_versions"].length > 0 ) {
            _.forEach(doc["reverse_document_versions"], (vItem) => {
              if (
                vItem["selectedForDownload"] &&
                postdata["documentIds"].indexOf(vItem._id) <= -1
              ) {
                postdata["documentIds"].push(vItem._id);
              }
            });
          }
        })
      }
      if(this.checkProperty(this.uscisspouseDownloadDoc, 'documents') && this.checkProperty(this.uscisspouseDownloadDoc, 'documents', 'length')>0 && this.checkSubmitToUscisCompleted){
        _.forEach(this.uscisspouseDownloadDoc['documents'], (doc)=>{
          if ( doc["selectedForDownload"] &&  postdata["documentIds"].indexOf(doc._id) <= -1 ) {
            postdata["documentIds"].push(doc._id);
          }
          if ( this.checkProperty(doc, "reverse_document_versions") && doc["reverse_document_versions"].length > 0 ) {
            _.forEach(doc["reverse_document_versions"], (vItem) => {
              if (
                vItem["selectedForDownload"] &&
                postdata["documentIds"].indexOf(vItem._id) <= -1
              ) {
                postdata["documentIds"].push(vItem._id);
              }
            });
          }
        })
      }
      if(this.childrenDownloadDoc && this.checkProperty(this.childrenDownloadDoc, 'length')>0){
       let self = this;
        _.forEach(this.childrenDownloadDoc, (chidItm)=>{
          if(_.has(chidItm, 'documents') && self.checkProperty(chidItm, 'documents', 'length')>0){
            _.forEach(chidItm['documents'], (doc)=>{
              if ( doc["selectedForDownload"] &&  postdata["documentIds"].indexOf(doc._id) <= -1 ) {
                postdata["documentIds"].push(doc._id);
              }
              if ( this.checkProperty(doc, "reverse_document_versions") && doc["reverse_document_versions"].length > 0 ) {
                _.forEach(doc["reverse_document_versions"], (vItem) => {
                  if (
                    vItem["selectedForDownload"] &&
                    postdata["documentIds"].indexOf(vItem._id) <= -1
                  ) {
                    postdata["documentIds"].push(vItem._id);
                  }
                });
              }
            })
          }
        })
        
      }
      if(this.uscischildrenDownloadDoc && this.checkProperty(this.uscischildrenDownloadDoc, 'length')>0 && this.checkSubmitToUscisCompleted){
       let self = this;
        _.forEach(this.uscischildrenDownloadDoc, (chidItm)=>{
          if(_.has(chidItm, 'documents') && self.checkProperty(chidItm, 'documents', 'length')>0){
            _.forEach(chidItm['documents'], (doc)=>{
              if ( doc["selectedForDownload"] &&  postdata["documentIds"].indexOf(doc._id) <= -1 ) {
                postdata["documentIds"].push(doc._id);
              }
              if ( this.checkProperty(doc, "reverse_document_versions") && doc["reverse_document_versions"].length > 0 ) {
                _.forEach(doc["reverse_document_versions"], (vItem) => {
                  if (
                    vItem["selectedForDownload"] &&
                    postdata["documentIds"].indexOf(vItem._id) <= -1
                  ) {
                    postdata["documentIds"].push(vItem._id);
                  }
                });
              }
            })
          }
        })
        
      }

      //  }

      if (postdata["documentIds"].length >= 2 ) {
        if (
          [3].indexOf(this.checkProperty(this.petition, "typeDetails", "id")) > -1 &&
          [15].indexOf(this.checkProperty(this.petition, "subTypeDetails", "id")) > -1
        ) {
          postdata["entityType"] = "perm";
        }

        this.downloading = true;
        this.$store
          .dispatch("downloadFormslatters", postdata)
          .then((response) => {
            this.downloading = false;
            this.openDownloadAllPopup(false);
            window.open(
              this.$globalgonfig._APIURL + "/common/viewfile?path=" + response.path,
              "_blank"
            );
            // window.open(response.data.result.data, '_blank');
          })
          .catch((error) => {
            this.downloading = false;
            Object.assign(this.formerrors, { msg: error });
            //this.showToster({ message: error, isError: true });
          });
      } else {
        Object.assign(this.formerrors, { msg: "Atleast two document is required." });
      }
    },
    updateFormat(){
      this.$refs['fileUploadComponent'].updateFormatType(this.formLetterType)
    },
    updateData(docs, category, subCategory){
      if(category == 'pdocuments'){
        this.uploadFinalMainDocuments = docs
      }
      if(category == 'Documents'){
        this.newFormsAndLetters = docs
      }
      if(subCategory == 'recruitmentInfo'){ 
        this.petitionDetails.recruitmentInfo.documents[category] = docs
      }
      if(category == 'documentData'){
        this.version_documentUploaded = docs
      }
    },
    showHistoryComment(item){
      this.$emit('showHistoryComment', item)
    },
    getcaseHistory() {
      this.petitionhistory = null;
      if (this.checkProperty(this.petition, '_id') && this.checkProperty(this.petition, 'completedActivities') && this.checkProperty(this.petition, 'completedActivities', 'length')>0 && 
      this.petition['completedActivities'].indexOf('REQUEST_PETITIONER_SIGN')>-1) {
        this.$store.dispatch("petitionhistory", this.checkProperty(this.petition, '_id')).then((response) => {
          if(response && this.checkProperty(response, 'result') && this.checkProperty(response, 'result', 'list') && this.checkProperty(response['result'], 'list', 'length')>0){
            let list = response.result.list;
            let templist = _.filter(list,(item)=>{
              if(_.has(item, 'action') && item['action'] == 'REQUEST_PETITIONER_SIGN'){
                return item;
              }
            });
            if(templist && this.checkProperty(templist, 'length')>0){
              templist.sort((a, b) => b.createdOn - a.createdOn);
              this.petitionhistory = templist;
            }
            
            //this.petitionhistory = response.result.list;
          }
        });
      }
    },
    selct_all(callFromSellectAll=false){
      setTimeout(()=>{ 
      
      let self =this;
      let totalCount =0;
      let selectedCount =0;
      let unSelectedCount =0;
     
     if (
      self.checkProperty(self.masterFormsAndLatters, "audit_response", "length") > 0 &&
      self.checkProperty(self.petition, "typeDetails", "id") == 3 &&
      self.checkProperty(self.petition, "subTypeDetails", "id") == 15
      ) {
        _.map(self.masterFormsAndLatters["audit_response"], (obj) => {
          totalCount =totalCount+1;
          if(callFromSellectAll){

            if(self.selectAll){
             obj['isSelectedCurrentVersion'] = true;
             
            }else{
              obj['isSelectedCurrentVersion'] = false;
              
            }

          }else{

            if(self.checkProperty(obj,'isSelectedCurrentVersion')){
              selectedCount = selectedCount+1;
            }else{
              unSelectedCount =unSelectedCount+1
            }
          }
        });
      }else{
        if (self.checkProperty(self.masterFormsAndLatters, 'beneficiary', 'coverLetters') && self.checkProperty(self.masterFormsAndLatters['beneficiary'], 'coverLetters', 'documents')
        && self.checkProperty(self.masterFormsAndLatters['beneficiary']['coverLetters'], 'documents', 'length')>0 ) {
          _.map(self.masterFormsAndLatters['beneficiary']['coverLetters']['documents'], (obj) => {
            totalCount =totalCount+1;
            if(callFromSellectAll){
              if(self.selectAll){
                obj['isSelectedCurrentVersion'] = true;
              }else{
                obj['isSelectedCurrentVersion'] = false;
              }
            }else{
              if(self.checkProperty(obj,'isSelectedCurrentVersion')){
                selectedCount = selectedCount+1;
              }else{
                unSelectedCount =unSelectedCount+1
              }
            }
          });
        }
        if (self.checkProperty(self.masterFormsAndLatters, 'beneficiary', 'supportLetters') && self.checkProperty(self.masterFormsAndLatters['beneficiary'], 'supportLetters', 'documents')
        && self.checkProperty(self.masterFormsAndLatters['beneficiary']['supportLetters'], 'documents', 'length')>0 ) {
          _.map(self.masterFormsAndLatters['beneficiary']['supportLetters']['documents'], (obj) => {
            totalCount =totalCount+1;
            if(callFromSellectAll){

                if(self.selectAll){
                obj['isSelectedCurrentVersion'] = true;
                
                }else{
                  obj['isSelectedCurrentVersion'] = false;
                  
                }

              }else{

                if(self.checkProperty(obj,'isSelectedCurrentVersion')){
                  selectedCount = selectedCount+1;
                }else{
                  unSelectedCount =unSelectedCount+1
                }
            }
          });
        }
        if (self.checkProperty(self.masterFormsAndLatters, 'beneficiary', 'forms') && self.checkProperty(self.masterFormsAndLatters['beneficiary'], 'forms', 'documents')
        && self.checkProperty(self.masterFormsAndLatters['beneficiary']['forms'], 'documents', 'length')>0 ) {
          _.map(self.masterFormsAndLatters['beneficiary']['forms']['documents'], (obj) => {
            totalCount =totalCount+1;
            if(callFromSellectAll){
                if(self.selectAll){
                obj['isSelectedCurrentVersion'] = true;
                
                }else{
                  obj['isSelectedCurrentVersion'] = false;
                }
              }else{
                if(self.checkProperty(obj,'isSelectedCurrentVersion')){
                  selectedCount = selectedCount+1;
                }else{
                  unSelectedCount =unSelectedCount+1
                }
            }
          });
        }
        if (self.checkProperty(self.masterFormsAndLatters, "spouse", "length") > 0) {
          _.map(self.masterFormsAndLatters["spouse"], (obj) => {
            totalCount =totalCount+1;
            if(callFromSellectAll){

              if(self.selectAll){
                  obj['isSelectedCurrentVersion'] = true;

              }else{
                obj['isSelectedCurrentVersion'] = false;
                
              }

              }else{

                if(self.checkProperty(obj,'isSelectedCurrentVersion')){
                  selectedCount = selectedCount+1;
                }else{
                  unSelectedCount =unSelectedCount+1
                }
            }
          });
        }
        if (self.checkProperty( Object.entries(self.masterFormsAndLatters["child"]), "length") > 0  ) {
          _.map(Object.entries(self.masterFormsAndLatters["child"]), (val, key) => {
            if (
              self.checkProperty(val, "length") > 1 &&
              self.checkProperty(val[1], "length") > 0
            ) {
              _.map(val[1], (obj) => {
                totalCount =totalCount+1;
                 if(callFromSellectAll){

                    if(self.selectAll){
                        obj['isSelectedCurrentVersion'] = true;

                    }else{
                      obj['isSelectedCurrentVersion'] = false;
                      
                    }

                  }else{

                    if(self.checkProperty(obj,'isSelectedCurrentVersion')){
                      selectedCount = selectedCount+1;
                    }else{
                      unSelectedCount =unSelectedCount+1
                    }
                }
              });
            }
          });
        }
      }
      if(!callFromSellectAll){
        if(selectedCount>0 &&  unSelectedCount== 0 &&  selectedCount ==totalCount ){
          self.selectAll =true;
        }else{
          self.selectAll =false;
        }

      }

  
    },100);
  
            },
    redirectQuestionnaire(){
      let obj= {
        currentTab : 'employment'
      }
      const string = JSON.stringify(obj) // convert Object to a String
      this.encodedString = btoa(string) // Base64 encode the String
      let routedId = this.checkProperty(this.petition, '_id')
      this.$router.push({ path: `/questionnaire/${routedId}` ,query: {'filter':this.encodedString} }).catch(err => {});
    },
    checkReloadPetition(callFromErr=false){
      if([3].indexOf(this.checkProperty(this.petition, "typeDetails", "id"))>-1 && [16,17].indexOf(this.checkProperty(this.petition, "subTypeDetails", "id"))>-1 && 
      (this.updateReload || callFromErr ) ){
        this.$emit("updatepetition", "Forms and Letters");
      }
    },
    submiti140Form(updateCall = true){
        this.$validator.validateAll('newI140Form').then((result) => {
          if(result){
            if(updateCall){
              let payload={
                petitionId: this.checkProperty(this.petition, '_id'),
                i140AdditionalInfo:{
                  petitionBeingFieldFor: "",
                  petitionBeingField: "", 
                  prevPetiReceiptNumber: "",
                  anyOtherPetiOrApplications: "",
                  petiOrApplicAllApplicableBoxes: [],
                  petiOrApplicAllApplicableBoxOther: "",
                  removalProceedings: "",
                  immiVisaPetitionOrPerson: "",
                  supportOfAnotherFormi140: "",
                  departmentOfLabor: "",
                  considerBnfEmpInfoForLetters:''
                },
              }
              if(this.checkProperty(this.i140AdditionalInfo,'anyOtherPetiOrApplications') != 'Yes'){
                this.i140AdditionalInfo.petiOrApplicAllApplicableBoxes = [];
                this.i140AdditionalInfo.petiOrApplicAllApplicableBoxOther = '';
              }
              if(this.checkAdditionalInfo == false){
                this.i140AdditionalInfo.petiOrApplicAllApplicableBoxOther = '';
              }
              if(this.i140AdditionalInfo.petitionBeingField != 'aa'){
                this.i140AdditionalInfo.prevPetiReceiptNumber = ''
              };
              this.loadingI140= true;
              this.updateReload = false;
              payload['i140AdditionalInfo'] = _.cloneDeep(this.i140AdditionalInfo);;
              if(this.checkProperty(this.i140AdditionalInfo,'petiOrApplicAllApplicableBoxes') && this.checkProperty(this.i140AdditionalInfo,'petiOrApplicAllApplicableBoxes','length')>0){
                payload['i140AdditionalInfo']['petiOrApplicAllApplicableBoxes'] =  this.i140AdditionalInfo['petiOrApplicAllApplicableBoxes'].map(item =>item.id);
              }
              let path = '/petition/update-questionnaire-form-i140-form'
              this.$store.dispatch('commonAction',{data:payload,'path':path}).then((response)=>{
                this.showToster({message:response.message,isError:false });
                this.updateReload = true;
                this.getMasetFormsAndLatters(true);
                this.showDetailsPopup=false
                // this.$modal.hide('showI140PopUp');
                this.loadingI140= false;
                setTimeout(()=>{
                  this.loadingI140= false;
                })
              }).catch((err)=>{
                this.loadingI140= false;
                this.formerrors.msg = err;
              })
            }else{
              this.updateReload = false;
              this.showDetailsPopup=false
              // this.$modal.hide('showI140PopUp');
              this.getMasetFormsAndLatters(true);
            }
          }
        })
    },
    openI140Form(){
      if(_.has(this.petition,'i140AdditionalInfo') && this.checkProperty(this.petition, 'i140AdditionalInfo') 
      && this.checkProperty(this.petition, 'i140AdditionalInfo','petitionBeingFieldFor')){
        this.i140AdditionalInfo = _.cloneDeep(this.petition['i140AdditionalInfo'])
        if(this.i140AdditionalInfo && this.checkProperty(this.i140AdditionalInfo,'petiOrApplicAllApplicableBoxes') 
        && this.checkProperty(this.i140AdditionalInfo,'petiOrApplicAllApplicableBoxes','length')>0){
          let list = [];
           _.forEach(this.i140AdditionalInfo['petiOrApplicAllApplicableBoxes'],(item)=>{
            let findObj = _.find(this.filingFormsList,({'id':item}));
            if(findObj){
              list.push(findObj)
            }
          })
          this.i140AdditionalInfo['petiOrApplicAllApplicableBoxes'] = list;
        }
      }else{
        this.i140AdditionalInfo={
          petitionBeingFieldFor: "",
          petitionBeingField: "", 
          prevPetiReceiptNumber: "",
          anyOtherPetiOrApplications: "",
          petiOrApplicAllApplicableBoxes: [],
          petiOrApplicAllApplicableBoxOther: "",
          removalProceedings: "",
          immiVisaPetitionOrPerson: "",
          supportOfAnotherFormi140: "",
          departmentOfLabor: "",
          considerBnfEmpInfoForLetters:''
        }
      }
      this.updatePreEmployDetails = '';
      this.updateReload = false;
      this.loadingI140= false;
      this.formerrors.msg = '';
      this.showDetailsPopup=true
      // this.$modal.show('showI140PopUp')
    },
    openI485Form(){
      if(this.checkProperty(this.applicantList, 'length')>0){
        let findObj = _.find(this.applicantList, {'id':'beneficairy'});
        if(findObj){
          this.selectedApplicant = findObj
        }
      }
      if(this.checkProperty(this.selectedApplicant, 'id')){
        this.changeAddInfo()
      }else{
        this.resetKeys();
      }
      this.formerrors.msg=''
      this.considerForDependents = false;
      this.yesToAll = false;
      this.noToAll = false;
      this.updateReload = false;
      this.formerrors.msg = '';
      this.showAdditionalQuestionnaire = true;
    },
    setdocUserType(docUserType = 'Beneficiary'){
      setTimeout(()=>{
        this.docUserType = docUserType;

      },300);
    },
    splitAfterUscisChildrensFormsAndLetters(){
      this.childUscisFormsAndLetters ={};
      let allChildList  =_.filter(this.uscisFormsAndLettersList, { "depType":'child',"docUserType":'Dependent' } );
      if(allChildList && allChildList.length>0){
        this.childUscisFormsAndLetters = _.groupBy(allChildList ,'depLabel');
      }
    },
    
    splitChildrensFormsAndLetters(){
      this.childrenFormsAndLetters ={};
     // depType //child
     let allChildList  =_.filter(this.formsAndLettersList, { "depType":'child',"docUserType":'Dependent' } );
     if(allChildList && allChildList.length>0){
      this.childrenFormsAndLetters = _.groupBy(allChildList ,'depLabel');
      //console.log(JSON.stringify(this.childrenFormsAndLetters))
     }
    },
    getContent(){
      let self = this
      setTimeout(() => {
        try{
        if(self.$refs['NoDataFoundReff']){

          self.$refs['NoDataFoundReff'].updateLoading(false);

        }


      }catch(err){
        
        
        
      }
      }, 100);
      return '';
    },
    // this.formLetterType = "Form";
    //this.formLetterType = "Letter";
    changeTab(tab ,document ,docUserType='Beneficiary') {
      this.resetForms();
     // this.showPreviousVersions =false;
      this.fileuploadPopup =false;
   //   this.reversion_fileuploadPopup =false;
      this.selectedDocument = document;
      this.$store.commit("selectedForEditDocument", document);
      this.generatingFiles = false;
      Object.assign(this.formerrors, { msg: "" });
      //'Letter' 'Audit Response'
      if (tab == "Form") {
        this.formLetterType = "Form";
        
        this.acceptedFiles = "application/pdf";
      } else if (tab == "Letter") {
        this.formLetterType = "Letter";
        this.acceptedFiles =
          "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      } else if (this.checkProperty(this.petition, "subTypeDetails", "id") == 15) {
        this.acceptedFiles =
          "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      } else {
        this.formLetterType = "Audit Response";
        this.acceptedFiles =
          "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      }
      this.togleFileUpload = true;

   //   this.parentId = "";
      this.formerrors.msg = "";
      this.documentData = [{ type: "Forms, Letters and Others", documentUploaded: [] }];
     // this.getFormsAndLetters();
      this.docUserType = docUserType //'Beneficiary'
      this.entityId ='cover_letter';
    },
    changedOffice(callFromMounted=false) {
      
     
     // this.selectedOffice
     this.courierAddress ='';
     this.isValiedCourierAddress = false;
    
     if(this.selectedCourier && this.selectedOffice  && this.checkProperty(this.selectedOffice ,'addressConfig' )){
      let selectedCourierCenter = _.find(  this.masterCourierList ,{"id":this.selectedCourier});
      let msg ="Service Center Address is not available.";
      if(selectedCourierCenter && this.checkProperty(selectedCourierCenter ,"name")){
        msg ="Service Center Address is not available for "+selectedCourierCenter['name'];
      }

     
      let addressConfig = this.checkProperty(this.selectedOffice ,'addressConfig');
      if(addressConfig && this.checkProperty(addressConfig ,'length')>0 ){
        let matchedCourier = _.find(addressConfig ,{"courierId":this.selectedCourier});
       // alert(JSON.stringify(matchedCourier))
        if(matchedCourier && _.has(matchedCourier ,'address')){
          this.courierAddress = matchedCourier['address'];
          this.isValiedCourierAddress =true;
         

        }else{
          if(!callFromMounted){
             this.showToster({message:msg,isError:true });
          }
        }

      }else{
      
       if(!callFromMounted){
        this.showToster({message:msg,isError:true });
       }

        
       
      }

     }else{

      if(!callFromMounted){
        let msg = 'Service Center is required'
        if(!this.selectedCourier){
          msg = 'Courier Center is required'
        }
           //  this.$validator.validateAll();
             this.showToster({message:msg,isError:true });
          }


     }



    },
    getMasetFormsAndLatters(generateAction = false) {
      ///petition-config/details
          this.selectedCourier ='';
          this.courierAddress='';
          this.isValiedCourierAddress = false;

      if (generateAction) {
        this.loadingFormLatters = true;
        this.getCourierList();
      }

      let postData = { petitionId: "" };
      postData["petitionId"] = this.checkProperty(this.petition, "_id");

      let path = "/petition/get-forms-and-letters-to-generate";
      if (
        this.checkProperty(this.petition, "typeDetails", "id") == 3 &&
        this.checkProperty(this.petition, "subTypeDetails", "id") == 15
      ) {
        path = "/perm/get-forms-and-letters-to-generate";
        postData["docTypeIds"] = ["audit_response"];
      }

      this.$store
        .dispatch("commonActionWithErrorData", { data: postData, path: path })
        .then((response) => {
          this.masterFormsAndLatters = {
            beneficiary: {
              coverLetters:{
                toggleHeader:false,
                HeaderLabel:'Cover Letter',
                documents:[]
              },
              supportLetters:{
                toggleHeader:false,
                HeaderLabel:'Support Letter',
                documents:[]
              },
              forms:{
                toggleHeader:false,
                HeaderLabel:'Forms',
                documents:[]
              },
            },
            spouse: [],
            child: {},
            audit_response: [],
          };

          let childCouments = [];
          if (this.checkProperty(response, "length") > 0) {
            _.forEach(response, (item) => {
              item = Object.assign(item, {
                isSelectedNewVersion: false,
                isSelectedCurrentVersion: true,
                availableNewVersion: false,
                priorFormsInformation: null,
                isedited: false,
              });
              //this.formsAndLettersList
              let priorFormsEffectiveDays = 7;
              if (this.checkProperty(this.configDetails, "priorFormsEffectiveDays") > 0) {
                priorFormsEffectiveDays = this.configDetails["priorFormsEffectiveDays"];
              }
              //check document is edited
              if (this.checkProperty(item, "entityId")) {
                let generatedEditedItem = _.find(this.formsAndLettersList, {
                  editedDocument: true,
                  entityId: item["entityId"],
                });
                if (generatedEditedItem) {
                  item["isedited"] = true;
                }
              }

              if (
                _.has(item, "effectiveDate") &&
                this.checkProperty(item, "effectiveDate") &&
                this.checkProperty(item, "documentRef", "name")
              ) {
                let today = moment();
                let effectiveDate = moment(item["effectiveDate"]);
                let priorFormsInformation = moment().subtract(
                  priorFormsEffectiveDays,
                  "days"
                );
                if (effectiveDate.isAfter(today, "day")) {
                  if (today.isSameOrAfter(priorFormsInformation, "day")) {
                    item["availableNewVersion"] = true;
                    item["priorFormsInformation"] = priorFormsInformation;
                  } else {
                    _.forEach(item["documentRef"], (val, key) => {
                      item[key] = val;
                    });
                  }
                }
              }

              //beneficiary Doduments

              if (this.checkProperty(item, "type") == "audit_response") {
                this.masterFormsAndLatters["audit_response"].push(item);
              }
              if (this.checkProperty(item, "depType") == "beneficiary") { 
                if(_.has(item, 'type') && this.checkProperty(item, 'type') != 'Letter'){
                  this.masterFormsAndLatters['beneficiary']['forms']['documents'].push(item)
                }else{
                  if(_.has(item, 'type') && this.checkProperty(item, 'type') == 'Letter' && _.has(item, 'entityId')  && this.checkProperty(item, 'entityId') == 'support_letter'){
                    this.masterFormsAndLatters['beneficiary']['supportLetters']['documents'].push(item)
                  }
                  if(_.has(item, 'type') && this.checkProperty(item, 'type') == 'Letter' && _.has(item, 'entityId')  && this.checkProperty(item, 'entityId') != 'support_letter'){
                    this.masterFormsAndLatters['beneficiary']['coverLetters']['documents'].push(item)
                  }
                }
              } else if (this.checkProperty(item, "depType") == "spouse") {
                this.masterFormsAndLatters["spouse"].push(item);
              } else if (this.checkProperty(item, "depType") == "child") {
                if (_.has(this.masterFormsAndLatters["child"], item["depLabel"])) {
                  this.masterFormsAndLatters["child"][item["depLabel"]].push(item);
                } else {
                  this.masterFormsAndLatters["child"][item["depLabel"]] = [];
                  this.masterFormsAndLatters["child"][item["depLabel"]].push(item);
                }
              }
            });

            this.masterFormsAndLatters = _.cloneDeep(this.masterFormsAndLatters);
          } else {
            this.masterFormsAndLatters = _.cloneDeep(this.masterFormsAndLatters);
          }

          
         
          
          
          this.loadingFormLatters = false;
          this.generateFormsLattersPopup = generateAction;
          this.selectAll = generateAction;
         
          
          
          this.updateLoading(false);
          setTimeout(()=>{ this.updateLoading(false); setTimeout(()=>{ this.updateLoading(false);  },10);
          
        
          

        },10);
        })
        .catch((err) => {
          if (generateAction &&  err && err.message) {
            this.showToster({ message: err.message, isError: true });
          }
          if(err &&  this.checkProperty(this.petition, 'subTypeDetails', 'id') == 16){
            if(_.has(err, 'error_code') && this.checkProperty(err, 'error_code', 'length')>0){
              let code = err['error_code'][0];
              let mssage = this.checkProperty(err, 'message');
              if(code == 'wage'){
                this.$store.commit('updateWageReceivedErrMsg',mssage);
                this.$emit("updatepetition" , 'Wages Info');
                // console.log(this.$store.state.wageReceivedErrMsg)
              }
              if(code == 'tax'){
                this.$store.commit('updateTaxReturnsErrMsg',mssage);
                this.$emit("updatepetition" ,'Tax Info')
                // console.log(this.$store.state.taxReturnsErrMsg)
              }
            }
            // console.log(JSON.stringify(err.error_code))
          }else{
            this.checkReloadPetition(true)
          }
          

          this.generateFormsLattersPopup = false;
          this.masterFormsAndLatters = {
            beneficiary: {
              coverLetters:{
                toggleHeader:false,
                HeaderLabel:'Cover Letter',
                documents:[]
              },
              supportLetters:{
                toggleHeader:false,
                HeaderLabel:'Support Letter',
                documents:[]
              },
              forms:{
                toggleHeader:false,
                HeaderLabel:'Forms',
                documents:[]
              },
            },
            spouse: [],
            child: {},
            audit_response: [],
          };

          this.masterFormsAndLatters = _.cloneDeep(this.masterFormsAndLatters);

          this.loadingFormLatters = false;
          this.updateLoading(false);
          setTimeout(()=>{
            this.updateLoading(false);
          },10);
        });
    },
    getCourierList(){

let postdata = {};
this.$store
        .dispatch("getList", { data: postdata, path: "/tracking/courierlist" }).then((response) => {
            if (this.checkProperty(response, "list")) {
                 this.masterCourierList = response['list'];
                 this.courierListTemp = response['list'];
            }

 
 
  if(this.checkProperty(this.petitionDetails, "defaultCourierIds" ,"length")>0){
    this.courierListTemp = _.filter( this.masterCourierList,(itm)=>{
      return this.petitionDetails['defaultCourierIds'].indexOf(itm.id)>-1
    });
  }
  if(this.courierListTemp.length==1){
    this.selectedCourier = this.courierListTemp[0]['id'];
   
    this.showCourier =false;
  }else if(this.courierListTemp.length>1){


   
            let fedexItem = _.find(this.courierListTemp ,{ "id":2});
            if(_.has(fedexItem ,'code')){
              const $ = JQuery;
              
              $("#courier_"+fedexItem['code']).trigger('click');
              this.selectedCourier = fedexItem['id']

            }else{
              this.selectedCourier = this.courierListTemp[0]['id'];
            }
           
            this.showCourier =true;
            

          

  }
  this.changedOffice(true);
  

});

},
    changedBeneficiarycheck(){
    
      //bendocUserType
    },
    resetForms(){
      this.showentityIdError=false;
      this.showTypeIdError =false;
      this.entityId='cover_letter';  
      
      this.fuploder = false;
     // this.docUserType ='Beneficiary';
      this.$validator.reset();
     
        //let _self =this;
         
      // setTimeout(()=>{
      //     try{
      //       _self.$refs['bendocUserType'].click();
      //     }catch(err){
      //     alert(err)
      //     }
      // },100);
      
    },
    togglePreviousVersions(category=''){
     // alert()
      if( this.showPreviousVersions){
        this.showPreviousVersions =false;
      }else{
        this.showPreviousVersions = true;
      }  
      if(category){
        if(this.showPreviousVersionsList.indexOf(category) >-1){
          this.showPreviousVersionsList = _.filter(this.showPreviousVersionsList ,(item)=>{
            return category !=item
          })
        }else{
          this.showPreviousVersionsList.push(category);
        }
       

      }    

    },
    toggleUscisPreviousVersions(category=''){
     // alert()
      if( this.showUscisPreviousVersions){
        this.showUscisPreviousVersions =false;
      }else{
        this.showUscisPreviousVersions = true;
      }  
      if(category){
        if(this.showPreviousVersionsList.indexOf(category) >-1){
          this.showPreviousVersionsList = _.filter(this.showPreviousVersionsList ,(item)=>{
            return category !=item
          })
        }else{
          this.showPreviousVersionsList.push(category);
        }
       

      }    

    },
    copyingData() {
      var data = _.merge(this.petitionDetails, this.petition);
      this.petitionDetails = _.cloneDeep(data);
    },
    uploadAdv(fils, category) {
      let model = _.clone(fils);
      this.fvalue = [];
      let mapper = model.map(
        (item) =>
          (item = {
            name: item.name,
            file: item.file ? item.file : null,
            url: item.url ? item.url : "",
            path: item.path ? item.path : "",
            isNew: item.isNew ? item.isNew : false,
            status: item.status === false || item.status === true ? item.status : true,
            mimetype: item.type ? item.type : item.mimetype,
          })
      );
      if (mapper.length > 0) {
        this.filesUploading = true;
        _.map(this.docsLists, (obj) => {
          if (obj.key == category) {
            obj["loading"] = true;
          }
        });
        let count = 0;
        mapper.forEach((doc, index) => {
          if (doc.file) {
            let formData = new FormData();
            formData.append("files", doc.file);
            formData.append("secureType", "private");
            formData.append("getDetails", true);
            this.$store.dispatch("uploadS3File", formData).then((response) => {
              response.data.result.forEach((urlGenerated) => {

                if(_.has(urlGenerated ,'size' )){
                  doc['size'] = urlGenerated['size'];
                }
                doc.isNew = true;
                doc.url = urlGenerated['path'];
                doc.path = urlGenerated['path'];
                delete doc.file;
                mapper[index] = doc;
              });
              this.petitionDetails.recruitmentInfo.documents[category].push(doc);

              count = count + 1;
              if (mapper.length >= count) {
                this.filesUploading = false;
                _.map(this.docsLists, (obj) => {
                  if (obj.key == category) {
                    obj["loading"] = false;
                  }
                });
              }
            });
          }
        });
        model.splice(0, mapper.length, ...mapper);
      }
    },

    //Approve - reject Documents
    openApproveOrRejectDocs(action = "") {
      this.formErrors = "";
      this.comments = "";
      //this.loading = false;
      this.approveOrRejectDocs = true;
      this.approveOrRejectDocsTitle = "Approve Documents";
      this.selectedAction = action;

      if(this.selectedAction == 'REJECT_BY_DOC_MANAGER'){
        this.approveOrRejectDocsTitle = "Reject Documents";
      }
      if(this.selectedAction == 'APPROVED_BY_DOC_MANAGER'){
        this.approveOrRejectDocsTitle = "Approve Documents";
      }
      this.$validator.reset();
    },
    approveOrRejectDocsAction(action = "") {
      this.approveOrRejectDocs = true;
     this.selectedAction = action;
      this.formErrors = "";

      this.$validator.validateAll("approveOrRejectDocsForm").then((result) => {
        if (
          result &&
          ["APPROVED_BY_DOC_MANAGER", "REJECT_BY_DOC_MANAGER"].lastIndexOf(
            this.selectedAction
          ) > -1
        ) {
          var postData = {
            petitionId: this.checkProperty(this.petition, "_id"),
            typeName: this.checkProperty(this.petition, "typeDetails", "name"),
            subTypeName: this.checkProperty(this.petition, "subTypeDetails", "name"),
            comment: this.comments, // Required on APPROVED_BY_DOC_MANAGER and REJECT_BY_DOC_MANAGER
            action: this.selectedAction, //"UPLOAD_BY_DOC_EXECUTIVE",//APPROVED_BY_DOC_MANAGER, REJECT_BY_DOC_MANAGER
            today: moment().format("YYYY-MM-DD"),
          };
          //this.loading = true;
          this.$store
            .dispatch("commonAction", {
              data: postData,
              path: "/petition/manage-offshore-document-upload",
            })
            .then((response) => {
              this.approveOrRejectDocs = false;
              this.showToster({ message: response.message, isError: false });
              this.reloadWallList();
            })
            .catch((error) => {
              this.formErrors = error;
              // this.loading = false;
            });
        }
      });
    },
    reloadWallList() {
      setTimeout(() => {
        //this.loading = false;
        this.$emit("rloadActionWidjet");
      }, 100);
    },
    restoreDocument(parentId, document) {
      // this.parentId = parentId;

      this.disable_uploadBtn = false;
      this.uploadFinalMainDocuments = [];

      this.disable_reversion_uploadBtn = false;
      this.rfuploder = false;
      this.version_documentUploaded = [];
      this.version_documentUploaded.push(document);
      this.documentId = parentId;
      this.parentId =parentId;
      this.updateDocument_Version(true);
    },

    //<!----'isSelectedNewVersion':false ,"isSelectedCurrentVersion" selectDocument--->
    selectDocument(document, type = "") {
      let self =this;
      setTimeout(() => {
        if (
          this.checkProperty(document, "isSelectedNewVersion") &&
          type == "isSelectedNewVersion"
        ) {
          document["isSelectedCurrentVersion"] = false;
        } else if (
          this.checkProperty(document, "isSelectedCurrentVersion") &&
          type == "isSelectedCurrentVersion"
        ) {
          document["isSelectedNewVersion"] = false;
        }
       
        
      }, 1);
     
      //this.masterFormsAndLatters  =_.cloneDeep(this.masterFormsAndLatters);
    },
   
    openGenerateFormsLattersPopup() {
      if (
        this.petition["permId"] == null &&
        this.checkProperty(this.petition, "typeDetails", "id") == 3 &&
        this.checkProperty(this.petition, "subTypeDetails", "id") == 16
      ) {
        if (!this.checkProperty(this.petition, "jobDetails", "jobTitle")) {
          this.$store.dispatch("setPetitionTab", "PERM-INFO");
          this.showToster({ message: "Job Details are required", isError: true });
          // this.$emit("updatepetition" ,'PERM-INFO');
          return false;
        }
      }

      this.generatingFiles = false;
      Object.assign(this.formerrors, { msg: "" });

      this.regeneratingFormAndLetter = false;
      if(this.checkProperty(this.petition, "typeDetails", "id") == 3 &&
        this.checkProperty(this.petition, "subTypeDetails", "id") == 16){
          this.openI140Form();
      }
      else if([3,4].indexOf(this.checkProperty(this.petition, "typeDetails", "id"))>-1 &&
        [17,19].indexOf(this.checkProperty(this.petition, "subTypeDetails", "id")) >-1 ){
          this.openI485Form();
      }else{
        this.getMasetFormsAndLatters(true);
      }
      //alert(" shfs sdf ");
      
    },
    generateFormsAndLatters() {
    //  this.changedOffice(false);
      if(this.isValiedCourierAddress==false){
       
        this.changedOffice(false);
        return false;
      }
      let self = this;
     let  hasG28Form =false
      Object.assign(this.formerrors, { msg: "" });

      let selectedItems = [];
      // _.filter(this.masterFormsAndLatters ,{isSelectedNewVersion:true});
      //'isSelectedNewVersion':false ,"isSelectedCurrentVersion" availableNewVersion masterFormsAndLatters
      //get selected beneficiary documents
      let findSelectedItems = (item) => {

        if(self.checkProperty(item,'path') && self.checkProperty(item,'docTypeId')=='g-28' ){
          hasG28Form = true;
        }
        if (
          this.checkProperty(this.petition, "typeDetails", "id") == 3 &&
          this.checkProperty(this.petition, "subTypeDetails", "id") == 15
        ) {
          item["docTypeId"] = "audit_report";
          item["type"] = "Audit Response";
        }

        if (
          this.checkProperty(item, "isSelectedNewVersion") ||
          this.checkProperty(item, "isSelectedCurrentVersion")
        ) {
          if (this.checkProperty(item, "availableNewVersion")) {
            if (item["isSelectedCurrentVersion"] && !item["isSelectedNewVersion"]) {
              //get path from doc ref
              _.forEach(item["documentRef"], (val, key) => {
                item[key] = val;
              });
              selectedItems.push(item);
            } else if (
              !item["isSelectedCurrentVersion"] &&
              item["isSelectedNewVersion"]
            ) {
              selectedItems.push(item);
            }
          } else {
            selectedItems.push(item);
          }
        }
      };

      if (
        this.checkProperty(this.masterFormsAndLatters, "audit_response", "length") > 0 &&
        this.checkProperty(this.petition, "typeDetails", "id") == 3 &&
        this.checkProperty(this.petition, "subTypeDetails", "id") == 15
      ) {
        _.forEach(this.masterFormsAndLatters["audit_response"], (obj) => {
          findSelectedItems(obj);
        });
      }
      if (this.checkProperty(this.petition, "subTypeDetails", "id") != 15) { 
        if (this.checkProperty(this.masterFormsAndLatters, "beneficiary") && this.checkProperty(this.masterFormsAndLatters, 'beneficiary','supportLetters') 
        && this.checkProperty(this.masterFormsAndLatters['beneficiary'],'supportLetters','documents') && this.checkProperty(this.masterFormsAndLatters['beneficiary']['supportLetters'],'documents', 'length')>0) {
          _.forEach(this.masterFormsAndLatters["beneficiary"]['supportLetters']['documents'], (obj) => {
            findSelectedItems(obj);
          });
        }
        if (this.checkProperty(this.masterFormsAndLatters, "beneficiary" ) && this.checkProperty(this.masterFormsAndLatters, 'beneficiary','coverLetters') 
        && this.checkProperty(this.masterFormsAndLatters['beneficiary'],'coverLetters','documents') && this.checkProperty(this.masterFormsAndLatters['beneficiary']['coverLetters'],'documents', 'length')>0) {
          _.forEach(this.masterFormsAndLatters["beneficiary"]['coverLetters']['documents'], (obj) => {
            findSelectedItems(obj);
          });
        }
        if (this.checkProperty(this.masterFormsAndLatters, "beneficiary") && this.checkProperty(this.masterFormsAndLatters, 'beneficiary','forms') 
        && this.checkProperty(this.masterFormsAndLatters['beneficiary'],'forms','documents') && this.checkProperty(this.masterFormsAndLatters['beneficiary']['forms'],'documents', 'length')>0) {
          _.forEach(this.masterFormsAndLatters["beneficiary"]['forms']['documents'], (obj) => {
            findSelectedItems(obj);
          });
        }
        if (this.checkProperty(this.masterFormsAndLatters, "spouse", "length") > 0) {
          _.forEach(this.masterFormsAndLatters["spouse"], (obj) => {
            findSelectedItems(obj);
          });
        }
        if (this.checkProperty(Object.entries(this.masterFormsAndLatters["child"]), "length") > 0) {
          _.forEach(Object.entries(this.masterFormsAndLatters["child"]), (val, key) => {
            if (
              this.checkProperty(val, "length") > 1 &&
              this.checkProperty(val[1], "length") > 0
            ) {
              _.forEach(val[1], (doc) => {
                findSelectedItems(doc);
              });
            }
          });
        }
      }

      if (!this.checkProperty(this.selectedOffice, "id")) {
        Object.assign(this.formerrors, { msg: "Select Sevice Center" });

         this.showToster({ message: "Select Sevice Center", isError: true });
        return false;
      }

      if (selectedItems.length <= 0) {
        Object.assign(this.formerrors, {
          msg: "Select atleast one document to generate.",
        });
        this.showToster({ message: "Select atleast one document to generate.", isError: true });
        return false;
      }
      let postData = {
        petitionId: self.petition._id,
        today: moment().format("YYYY-MM-DD"),
        uploadedformsAndLetters: self.newFormsAndLetters,
        serviceCenter: self.selectedOffice,
        serviceCenterId: self.selectedOffice["id"],
        selectedFormsAndLetters: selectedItems,
        hasG28Form:hasG28Form
      };
      if (this.checkIsloginUserDoce) {
        postData = Object.assign(postData, { uploadByExecutive: true });
      }
      
      if(this.selectedCourier){
        postData = Object.assign(postData, { "finalCourierId": this.selectedCourier });
      }
      this.generatingFiles = true;
      let path = "/petition/generate-forms-and-letters";
      if (
        this.checkProperty(this.petition, "typeDetails", "id") == 3 &&
        this.checkProperty(this.petition, "subTypeDetails", "id") == 15
      ) {
        path = "/perm/generate-forms-and-letters";
        postData["auditAdvDocuments"] = this.checkProperty(
          this.petitionDetails["recruitmentInfo"],
          "documents"
        );
      }
      this.$store
        .dispatch("commonAction", { data: postData, path: path })
        .then((response) => {
          // self.selectedOffice = null;
          self.getFormsAndLetters();
          self.showToster({ message: response.message, isError: false });
          self.generatePopup = false;
          self.generatingFiles = false;
          self.regeneratingFormAndLetter = false;
          
        //  this.$route['params']['tabname'] ="Forms and Letters";
        //  this.$emit("updatepetition", "Forms and Letters");

          setTimeout(() => {

           

            self.getFormsAndLetters();
            self.reloadPetition();
            self.generateFormsLattersPopup = false;
            self.$modal.hide("generateFormsLattersPopup");
            this.$route['params']['tabname'] ="Forms and Letters";
            this.$emit("updatepetition", "Forms and Letters");
          }, 10);
        })
        .catch((error) => {
          this.generatingFiles = false;
          this.regeneratingFormAndLetter = false;
          this.showToster({ message: error, isError: true });
          Object.assign(this.formerrors, {
            msg: error,
          });
        });
    },
    editDocument(selectedForm = null) {
      let self = this;
      let item = _.cloneDeep(selectedForm)
      if(item !=null){
        item = Object.assign(item ,{ "viewmode":false})
        item['viewmode'] = false;
        item = Object.assign(item ,{ "savedDocumentId":null});
        item['savedDocumentId'] = null;
      }
      this.$store.commit("selectedForEditDocument", item);
      this.fetchSignedUrl(item);
      if( _.has(item,'type') && self.checkProperty(item, 'type') == 'Letter' && _.has(item,'generated') &&
       (self.checkProperty(item, 'generated') == true || self.checkProperty(item, 'generated') == 'true') && !item['parentId'] ){
        //&& !item['parentId'] removed parentId in above condition as per requirement
        let  tempObj = _.cloneDeep(item);
        if(_.has(tempObj, '_id')){
          delete tempObj._id
        }
        this.selDoc(null, tempObj, true);
      }
    },
    uploadEditedDocs(doc){
      //alert(doc['type'])  this.selDoc(self.checkProperty(item, 'mainParentId'), item, true);
    },

    pdfEdit(pdfDoc) {
      let postdata = { keyName: pdfDoc.path };
      this.gettingUrl = true;
      this.$store
        .dispatch("getSignedUrl", postdata)
        .then((response) => {
          //alert(JSON.stringify(response.data.result.data));
          this.pdfUrl = response.data.result.data;

          var loadingTask = pdf.createLoadingTask(this.pdfUrl);

          loadingTask.promise.then((pdf) => {
            this.numPdfPages = pdf.numPages;
            this.$modal.show("pdfEditorPopup");
            this.gettingUrl = false;
          });
        })
        .catch(() => {
          this.gettingUrl = false;
        });
    },

    resetOffice() {
      // this.selectedOffice =null
    },
   
    hideModel(modelItem = "download_files_model", isShow = false) {
      if (isShow) {
        this.$modal.show(modelItem);
      } else {
        this.$modal.hide(modelItem);
      }
    },
   
    openConformPopUp(item) {
      this.selectedItem = item;
      this.approveConformpopUp = true;
      Object.assign(this.formerrors, { msg: "" });
    },
    openUscisDownloadPopup(action = false) {
      _.forEach(this.uscisFormsAndLettersList, (item) => {
        item["selectedForDownload"] = true;
        if (
          this.checkProperty(item, "reverse_document_versions") &&
          item["reverse_document_versions"].length > 0
        ) {
          _.forEach(item["reverse_document_versions"], (vItem) => {
            vItem.selectedForDownload = false;
          });
        }
      });
      this.downloadFiles = action;
      this.downloading = false;
      Object.assign(this.formerrors, { msg: "" });
      this.openItem = true;
      this.hideModel("download_uscis_files_model", action);
    },
    //selectedForDownload
    openDownloadPopup(action = false) {
      _.forEach(this.formsAndLettersList, (item) => {
        item["selectedForDownload"] = true;
        if (
          this.checkProperty(item, "reverse_document_versions") &&
          item["reverse_document_versions"].length > 0
        ) {
          _.forEach(item["reverse_document_versions"], (vItem) => {
            vItem.selectedForDownload = false;
          });
        }
      });
      this.downloadFiles = action;
      this.downloading = false;
      Object.assign(this.formerrors, { msg: "" });
      this.openItem = true;
      this.hideModel("download_files_model", action);
    },
    openDownloadAllPopup(action = false) {
    //   uscisbeneficiaryDownloadDoc:null,
    // uscisspouseDownloadDoc:null,
    // uscischildrenDownloadDoc:[],
      if(this.checkProperty(this.beneficiaryDownloadDoc, 'documents') && this.checkProperty(this.beneficiaryDownloadDoc, 'documents', 'length')>0){
        this.beneficiaryDownloadDoc['selectedAll'] = true;
        _.forEach(this.beneficiaryDownloadDoc['documents'], (item) => {
          item["selectedForDownload"] = true;
          if ( this.checkProperty(item, "reverse_document_versions") && item["reverse_document_versions"].length > 0 ) {
            _.forEach(item["reverse_document_versions"], (vItem) => {
              vItem.selectedForDownload = false;
            });
          }
        });
      }
      if(this.checkProperty(this.uscisbeneficiaryDownloadDoc, 'documents') && this.checkProperty(this.uscisbeneficiaryDownloadDoc, 'documents', 'length')>0){
        this.uscisbeneficiaryDownloadDoc['selectedAll'] = true;
        _.forEach(this.uscisbeneficiaryDownloadDoc['documents'], (item) => {
          item["selectedForDownload"] = true;
          if ( this.checkProperty(item, "reverse_document_versions") && item["reverse_document_versions"].length > 0 ) {
            _.forEach(item["reverse_document_versions"], (vItem) => {
              vItem.selectedForDownload = false;
            });
          }
        });
      }
      if(this.checkProperty(this.spouseDownloadDoc, 'documents') && this.checkProperty(this.spouseDownloadDoc, 'documents','length')>0){
        this.spouseDownloadDoc['selectedAll'] = true;
        _.forEach(this.spouseDownloadDoc['documents'], (item) => {
          item["selectedForDownload"] = true;
          if ( this.checkProperty(item, "reverse_document_versions") && item["reverse_document_versions"].length > 0 ) {
            _.forEach(item["reverse_document_versions"], (vItem) => {
              vItem.selectedForDownload = false;
            });
          }
        });
      }
      if(this.checkProperty(this.uscisspouseDownloadDoc, 'documents') && this.checkProperty(this.uscisspouseDownloadDoc, 'documents','length')>0){
        this.uscisspouseDownloadDoc['selectedAll'] = true;
        _.forEach(this.uscisspouseDownloadDoc['documents'], (item) => {
          item["selectedForDownload"] = true;
          if ( this.checkProperty(item, "reverse_document_versions") && item["reverse_document_versions"].length > 0 ) {
            _.forEach(item["reverse_document_versions"], (vItem) => {
              vItem.selectedForDownload = false;
            });
          }
        });
      }
      if(this.checkProperty(this.childrenDownloadDoc, 'length')>0){
        _.forEach(this.childrenDownloadDoc, (citem) => {
          citem["selectedAll"] = true;
          _.forEach(citem['documents'], (item)=>{
            item["selectedForDownload"] = true;
            if ( this.checkProperty(item, "reverse_document_versions") && item["reverse_document_versions"].length > 0 ) {
              _.forEach(item["reverse_document_versions"], (vItem) => {
                vItem.selectedForDownload = false;
              });
            }
          })
         
        });
      }
      if(this.checkProperty(this.uscischildrenDownloadDoc, 'length')>0){
        _.forEach(this.uscischildrenDownloadDoc, (citem) => {
          citem["selectedAll"] = true;
          _.forEach(citem['documents'], (item)=>{
            item["selectedForDownload"] = true;
            if ( this.checkProperty(item, "reverse_document_versions") && item["reverse_document_versions"].length > 0 ) {
              _.forEach(item["reverse_document_versions"], (vItem) => {
                vItem.selectedForDownload = false;
              });
            }
          })
         
        });
      }
      this.downloadFiles = action;
      this.downloading = false;
      Object.assign(this.formerrors, { msg: "" });
      this.openItem = true;
      this.hideModel("download_all_files_model", action);
    },

    uploadNewFormsandLatters(files, type = "") {
      let model = _.cloneDeep(files);
      this.value = [];

      this.newFormsAndLetters = [];

      var _current = this;
      this.$vs.loading();
      let formData = new FormData();

      let tempFiles = [];
      if (model.length > 0) {
        model.forEach((doc, index) => {
          if (
            (this.formLetterType == "Form" &&
              (doc.mimetype == "application/pdf" || doc.type == "application/pdf")) ||
            (this.formLetterType == "Letter" &&
              (doc.mimetype == "application/msword" ||
                doc.type == "application/msword" ||
                doc.mimetype ==
                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                doc.type ==
                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"))
          ) {
            formData.append("files", doc.file);
            formData.append("secureType", "private");
            formData.append("getDetails", true);

            this.$store.dispatch("uploadS3File", formData).then((response) => {
              response.data.result.forEach((urlGenerated) => {
                if(_.has( urlGenerated ,'size')){
                  doc["size"] = urlGenerated['size'];
                }
                doc.url = urlGenerated;
                doc["path"] = urlGenerated;
                delete doc.file;
                let temp_file = urlGenerated;

                tempFiles.push(temp_file);
                let fl = {
                  name: temp_file["name"],
                  url: temp_file["path"],
                  mimetype: temp_file["mimetype"],
                  size:0
                };
                if(_.has( urlGenerated ,'size')){
                  fl["size"] = urlGenerated['size'];
                }
                this.newFormsAndLetters.push(urlGenerated);

                if (tempFiles.length >= model.length) {
                  _current.$vs.loading.close();
                }
              });
            });
          } else {
            _current.$vs.loading.close();
          }
        });
      }
      //  model.splice(0, mapper.length, ...mapper);
    },

    selDoc(mainParentId, doc = null,callfromEdit=false, category = '') {
     this.formLetterType = this.checkProperty(doc ,'type');
      Object.assign(this.formerrors, { msg: "" });
      this.parentId = mainParentId;
      this.selectedDoc = doc;
      this.versionUploadAfterUSCIS = false;
      if(category == 'uploadAfterUSCIS'){
        this.versionUploadAfterUSCIS = true;
      }
      if(!callfromEdit){
        this.reversion_fileuploadPopup = true;
      }
      //this.resetForms();
      this.version_documentUploaded = [];
      this.disable_reversion_uploadBtn = false;
      this.selectedDocument = doc;
      this.docUserType ='Beneficiary'
      this.entityId ='cover_letter';
      this.showentityIdError=false;
      this.showTypeIdError =false;
      this.entityId='cover_letter';  
      this.fuploder = false;
      
    if(this.checkProperty(doc,'entityId' )){
        //support_letter cover_letter
     
    
      if(this.checkProperty(doc,'entityId' ) =='support_letter' && this.checkProperty(doc ,'type') =='Letter'){
        this.entityId ='support_letter';  
        setTimeout(()=>{
          this.entityId ='support_letter';  
        },100);
      }
    
     
    }
    if(!callfromEdit){
      this.reversion_fileuploadPopup = true;
    }
    if(callfromEdit){
      this.version_documentUploaded.push(this.selectedDoc);
      //this.updateDocument_Version(false, false);
    }
      this.$validator.reset();
     
    },
    reversion_fileNameChenged(fileindex) {
      let fname = this.version_documentUploaded[fileindex]["name"];
      fname = fname.trim();
      this.disable_reversion_uploadBtn = false;
      if (!fname) {
        this.disable_reversion_uploadBtn = true;
      }
    },
    remove_reversion_file() {
      this.version_documentUploaded = [];
    },

    chengefileName(index, fileindex){
        this.disable_uploadBtn = false;
      _.forEach(this.uploadFinalMainDocuments, (doc, value) => {
            let fname = doc.name
            fname = fname.trim();

            if (!fname) {
              this.disable_uploadBtn = true;
            }

      })
      
    },  

    fileNameChenged(index, fileindex) {
      this.disable_uploadBtn = false;

      _.forEach(this.documentData, (doc, value) => {
        if (doc.documentUploaded.length > 0) {
          _.forEach(doc.documentUploaded, (fl, value) => {
            //let fname = fl.name;
            let fname = fl.document.name;
            fname = fname.trim();

            if (!fname) {
              this.disable_uploadBtn = true;
            }
          });
        }
      });
    },
    //Download 1
    fetchSignedUrl(value, download = false, viewmode = true) {
     
      value.download = download;
      
      if( !_.has(value ,'viewmode')){
        value.viewmode = viewmode;
      }
      this.$emit("download_or_view", value);
      // window.open(this.$globalgonfig._APIURL+"/common/viewfile?path="+value.path, "_blank");
    },
    download_or_view(value) {
        
        if (_.has(value, "path")) {
            value['url'] = value['path'];
            value['document'] = value['path'];
        }

        if (_.has(value, "url")) {
            value['path'] = value['url'];
            value['document'] = value['url'];
        }

        if (_.has(value, "document")) {
            value['path'] = value['document'];
            value['url'] = value['document'];
        }
        

        this.selectedFile = value;
        this.docValue = '';
        this.docPrivew = false;
        this.docType = false;
        this.docType = this.findmsDoctype(value);

        if (false && (this.docType == "office" || this.docType == "image")) {

            value.url = value.url.replace(this.$globalgonfig._S3URL, "");
            value.url = value.url.replace(this.$globalgonfig._S3URLAWS, "");
            let postdata = {
                keyName: value.url
            };
            this.$store.dispatch("getSignedUrl", postdata).then((response) => {
                this.docValue = response.data.result.data;

                if (this.docType == "office") {
                    this.docValue = encodeURIComponent(response.data.result.data);
                }
                this.docPrivew = true;
            });

        } else {

            this.downloads3file(value);
        }

    },
    remove(item, type) {
      type.splice(type.indexOf(item), 1);
      this.removeFileFromS3(item)
      return false;
    },

    getformated(item) {
      if(this.checkProperty(item,'generated') == true || this.checkProperty(item,'generated') == 'true' ){
        if (item.uploadedOn) {
          return (
            "Updated On  " +
            moment(item.uploadedOn).format("MMM DD, YYYY hh:mm:ss a") +
            " - Updated By " +
            item.updatedByName
          );
        } else if (item.createdOn) {
          return (
            "Generated On  " +
            moment(item.createdOn).format("MMM DD, YYYY hh:mm:ss a") +
            " - Generated By " +
            item.createdByName
          );
        } else {
          return "Generated By " + item.createdByName;
        }
      }else if (this.checkProperty(item,'editedDocument') == true || this.checkProperty(item, 'editedDocument') == 'true' ){
        if (item.updatedOn) {
          let txt = "Updated On  " + moment(item.updatedOn).format("MMM DD, YYYY hh:mm:ss a");
          if(item.updatedByName){
            txt =txt+" - Updated By " + item.updatedByName
          }else if(item.createdByName){
            txt =txt+" - Updated By " + item.createdByName
          }
        return txt;
        } else if (item.createdOn) {
          return (
            "Updated On  " +
            moment(item.createdOn).format("MMM DD, YYYY hh:mm:ss a") +
            " - Updated By " +
            item.createdByName
            // +" "+item.parentId +" id="+item._id
          );
        } else {
          return "Updated By " + item.createdByName;
        }
      }else{
        if (item.updatedOn) {
          let txt = "Updated On  " + moment(item.updatedOn).format("MMM DD, YYYY hh:mm:ss a");
          if(item.updatedByName){
            txt =txt+" - Updated By " + item.updatedByName
          }else if(item.createdByName){
            txt =txt+" - Updated By " + item.createdByName
          }
          return txt;
        } else if (item.createdOn) {
          return (
            "Uploaded On  " +
            moment(item.createdOn).format("MMM DD, YYYY hh:mm:ss a") +
            " - Uploaded By " +
            item.createdByName
          );
        } else {
          return "Uploaded By " + item.createdByName;
        }
      }
    },
    deleteDocument() {
      let postdata = {
        documentId: this.selectedItem._id,
      };
      this.$store
        .dispatch("deleteFormAndLetter", postdata)
        .then((response) => {
          this.showToster({ message: response.message, isError: false });
          this.selectedItem = null;
          this.approveConformpopUp = false;
          this.getFormsAndLetters();
          setTimeout(() => {
            //this.$emit("updatepetition" ,'Forms and Letters');
          }, 100);
        })
        .catch((error) => {
          Object.assign(this.formerrors, { msg: error });
          //this.showToster({ message: error, isError: true });
          this.approveConformpopUp = true;
        });
    },
    fetchFormsMasterData() {
      this.$store.dispatch("getmasterdata", "forms_and_letter").then((response) => {
        this.types = [];
        this.types.push({
          name: "Selecte form",
          id: "",
        });
        //  this.types = response;

        _.forEach(response, (item) => {
          this.types.push(item);
        });
        // alert(JSON.stringify(this.types));
      });
    },
    //uploadMainDocuments
    uploadToS3MainDocuments(docs) {
      docs = docs.map(
        (item) =>{
          item = {
            name: item.name,
            size:item.size ? item.size : null,
            file: item.file,
            document: "",
            path: "",
            mimetype: item.type,
          }
          const newName = item.name.replace(/[^\w.]/g, '');
                item.name = newName;
                return item;
        }
      );
      this.formerrors.msg = "";

      if (docs.length > 0) {
        let filIndex = 0;

        docs.forEach((doc) => {
          
          if (
            (this.formLetterType == "Form" &&
              (doc.mimetype == "application/pdf" || doc.type == "application/pdf")) ||
            ((this.formLetterType == "Letter" ||
              this.checkProperty(this.petition, "subTypeDetails", "id") == 15) &&
              (doc.mimetype == "application/msword" ||
                doc.type == "application/msword" ||
                doc.mimetype ==
                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                doc.type ==
                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"))
          ) {
            this.disable_uploadBtn = true;
            this.fuploder = true;
            let formData = new FormData();
            formData.append("files", doc.file);
            formData.append("secureType", "private");
            formData.append("getDetails", true);

            this.$store.dispatch("uploadS3File", formData).then((response) => {
              filIndex++;
              if (filIndex >= this.uploadMainDocuments.length) {
                this.fuploder = false;
                this.disable_uploadBtn = false;
              }

              response.data.result.forEach((urlGenerated) => {
                doc.document = urlGenerated;
                doc.path = urlGenerated["path"];
                if(_.has(urlGenerated ,'size' )){
                  doc['size'] = urlGenerated['size'];
                }
                //this.uploadMainDocuments.push(doc);
                this.uploadFinalMainDocuments.push(doc);
              });
            });
          } else {
            this.disable_uploadBtn = false;
            this.fuploder = false;
            if (this.formLetterType == "Form") {
              this.formerrors.msg = " Froms Accept only pdf Documents";
            } else if (this.formLetterType == "Letter") {
              this.formerrors.msg = " Letters Accept only MS documents";
            } else if (this.checkProperty(this.petition, "subTypeDetails", "id") == 15) {
              this.formerrors.msg = " Audit Resopnse Accept only MS documents";
            } else {
              this.formerrors.msg = "";
            }
          }
        });
      }
    },
    selectedDocuments(index, docs) {
      docs = docs.map(
        (item) =>
          (item = {
            size:item.size?item.size:0,
            name: item.name,
            file: item.file,
            document: "",
            path: "",
            mimetype: item.type,
          })
      );
      this.documentData[index].documentUploaded = [];
      this.documentData[index].documentUploaded = docs;
      this.fuploder = false;
      this.disable_uploadBtn = false;
      if (docs.length > 0) {
        let filIndex = 0;
        this.fuploder = true;
        this.disable_uploadBtn = true;
        this.documentData[index].documentUploaded.forEach((doc) => {
          
          if (
            (this.formLetterType == "Form" &&
              (doc.mimetype == "application/pdf" || doc.type == "application/pdf")) ||
            (this.formLetterType == "Letter" &&
              (doc.mimetype == "application/msword" ||
                doc.type == "application/msword" ||
                doc.mimetype ==
                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                doc.type ==
                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"))
          ) {
            let formData = new FormData();
            formData.append("files", doc.file);
            formData.append("secureType", "private");
            formData.append("getDetails", true);

            this.$store.dispatch("uploadS3File", formData).then((response) => {
              filIndex++;
              if (filIndex >= this.documentData[index].documentUploaded.length) {
                this.fuploder = false;
                this.disable_uploadBtn = false;
              }

              response.data.result.forEach((urlGenerated) => {
                //alert(JSON.stringify(urlGenerated));
                doc.document = urlGenerated;
                doc.path = urlGenerated;
                
                if (this.documentData[index].documentUploaded[filIndex]) {
                  this.documentData[index].documentUploaded[filIndex][
                    "document"
                  ] = urlGenerated;
                  this.documentData[index].documentUploaded[filIndex][
                    "path"
                  ] = urlGenerated;
                }
              });

              
            });
          }
        });
      }
      this.docUserType ='Beneficiary'
      this.entityId ='cover_letter';
      this.fileuploadPopup = true;
    },

    remove_uploadedfile(index, fileindex) {
      this.documentData[index].documentUploaded.splice(fileindex, 1);
    },
   
    updateFormsAndDocuments() {
      let self =this;
      this.showTypeIdError =false;
      this.showentityIdError =false;
     if(this.formLetterType =='Letter' && !this.entityId ){
      this.showentityIdError =true;
      
     }
  
       if(!this.docUserType){
      //  this.showTypeIdError=true;
       }
        if(!this.showentityIdError || this.formLetterType !='Letter'){

       
      Object.assign(this.formerrors, { msg: "" });
      if (this.disable_uploadBtn) {
        return false;
      }
      // this.fileuploadPopup = false;
      let postData = {
        petitionId: this.petition._id,
        formLetterType: this.formLetterType,
        documents: [],

      };
      
      if (this.parentId) {
        postData = Object.assign(postData, { parentId: this.parentId });
      }
      if(this.petitionDetails.beneficiaryInfo.maritalStatus ==1 ){
          
          postData['docUserType'] = 'Beneficiary'
      }else if( this.docUserType){
        postData['docUserType'] = this.docUserType
        }
        

        // {{ "depType ==="+ depType +"; depLabel ="+depLabel + ' ;docUserType ==='+docUserType }}
       if(this.depType && this.depLabel &&  this.checkProperty(this.petition, "subTypeDetails", "id") != 15){
        postData['depType'] = this.depType;
        postData['depLabel'] = this.depLabel;

       }
       if(this.uploadAfterUSCIS){
        postData['uploadAfterUSCIS'] = true;
       }
       
        if(this.formLetterType =='Letter' && this.entityId){
           postData =Object.assign(postData, { 'entityId': this.entityId });
       }
      
      

      if (this.uploadFinalMainDocuments.length > 0) {
        this.uploadFinalMainDocuments.forEach((doc) => {
          // let document = doc.document;
          // document = Object.assign(document, { name: doc.name });

          // document['uploadedBy'] =self.checkProperty(self.getUserData,'userId')!=''?self.checkProperty(self.getUserData,'userId'):null,
          // document['uploadedByName'] =self.checkProperty(self.getUserData,'name')!=''?self.checkProperty(self.getUserData,'name'):'',
          // document['uploadedByRoleId'] = self.getUserRoleId?self.getUserRoleId:null,
          // document['uploadedByRoleName'] =self.checkProperty(self.getUserData,'loginRoleName'),

          postData["documents"].push(doc);
        });
      }
      this.fuploder = true;
      this.disable_uploadBtn = true;
      let count = 0;
      // alert(JSON.stringify(postData))
      if (this.checkIsloginUserDoce) {
        postData = Object.assign(postData, { uploadByExecutive: true });
      }
      let dispatch = "uploadFormsAndLetters";
      if (
        this.checkProperty(this.petition, "typeDetails", "id") == 3 &&
        this.checkProperty(this.petition, "subTypeDetails", "id") == 15
      ) {
        dispatch = "uploadPermFormsAndLetters";
      }
     
    
      this.$store
        .dispatch(dispatch, postData)
        .then((response) => {
          this.depType ='';
          this.depLabel ='';
          this.showToster({ message: response.message, isError: false });
          this.fileuploadPopup = false;
          self.fileuploadPopup = false;
          this.fuploder = false;
          this.disable_uploadBtn = false;
          this.fileuploadPopup = false;
          self.fileuploadPopup = false;
          this.uploadAfterUSCIS = false;
          self.uploadAfterUSCIS = false;
          self.getFormsAndLetters();
          setTimeout(() => {
            self.$emit("updatepetition", "Forms and Letters");
          }, 100);
        })
        .catch((error) => {
          Object.assign(this.formerrors, { msg: error });
          //this.showToster({ message: error, isError: true });
          this.fuploder = false;
          this.disable_uploadBtn = false;
          this.uploadAfterUSCIS = false;
        });
      }
      
    },

    doUpload(id, documents, typeId = "") {
      this.documentId = id;

      let formData = new FormData();
      documents = documents.map(
        (item) =>
          (item = {
            typeId: typeId,
            name: item.name,
            file: item.file,
            path: "",
            size: item.size?item.size:0,

            mimetype: item.type,
          })
      );
      this.disable_reversion_uploadBtn = false;
      this.rfuploder = false;
      if (documents.length > 0) {
        this.rfuploder = true;
        this.disable_reversion_uploadBtn = true;
        let findx = 0;

        this.version_documentUploaded.forEach((doc) => {
          //:title="(checkProperty(petition ,'subTypeDetails' ,'id') ==15)?'Upload Audit Response': 'Upload '+formLetterType+'s and Others'"

          if (
            (this.formLetterType == "Form" &&
              (doc.mimetype == "application/pdf" || doc.type == "application/pdf")) ||
            ((this.formLetterType == "Letter" ||
              this.checkProperty(this.petition, "subTypeDetails", "id") == 15) &&
              (doc.mimetype == "application/msword" ||
                doc.type == "application/msword" ||
                doc.mimetype ==
                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                doc.type ==
                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"))
          ) {
            formData.append("files", doc.file);
            formData.append("secureType", "private");
            formData.append("getDetails", true);
            this.$store.dispatch("uploadS3File", formData).then((response) => {
              response.data.result.forEach((urlGenerated) => {
                if(_.has(urlGenerated ,'size' )){
                  doc['size'] = urlGenerated['size'];
                }
                doc.path = urlGenerated['path'];
                this.reversionFile = doc;
                this.disable_reversion_uploadBtn = false;
                this.rfuploder = false;
              });
            });
            findx++;
          }
        });
        if (findx == 0) {
          this.disable_reversion_uploadBtn = false;
          this.rfuploder = false;
          this.version_documentUploaded = [];
        }
      }
    },
    updateDocument_Version(fromRestore = false, showresponse = true) {
      let self =this;
      this.showentityIdError =false;
      this.showTypeIdError =false;
      if(!this.docUserType){
       // this.showTypeIdError=true;
        
       }
      if(!fromRestore){
        //formerrors.msg
        if (this.version_documentUploaded.length <= 0){
     
          Object.assign(this.formerrors, { msg: "" });
          Object.assign(this.formerrors, { msg: "Upload Revision Document" });
          return false;
        }
       
        if (this.formLetterType =='Letter' && this.checkProperty(this.selectedDocument, "entityId")=='support_letter'){
          this.entityId ='support_letter'; 
        }

        if(this.formLetterType =='Letter' && !this.entityId ){
           this.showentityIdError =true;
           return false;
       }
       
      }
      Object.assign(this.formerrors, { msg: "" });
      if (this.version_documentUploaded.length > 0 && !this.disable_reversion_uploadBtn) {
        this.disable_reversion_uploadBtn = true;
        this.rfuploder = false;

        let postData = {
          petitionId: this.petition._id,
          formLetterType: this.formLetterType,
          documents: [],
          restore: false,
        };

        if(this.formLetterType =='Letter' && this.entityId){
           postData =Object.assign(postData, { 'entityId': this.entityId });
       }

      if(this.checkProperty(this.selectedDocument, "entityId") ){
        postData =Object.assign(postData, { 'entityId':  this.checkProperty(this.selectedDocument, "entityId") });
      }
       
      if(this.versionUploadAfterUSCIS){
        postData['uploadAfterUSCIS'] = true;
      }
        
        if(this.petitionDetails.beneficiaryInfo.maritalStatus ==1 ){
          postData['docUserType'] = 'Beneficiary'
        }else if(this.docUserType){
        postData['docUserType'] = this.docUserType
        }  
     //  alert(postData['entityId']);
        if (fromRestore) {
          postData.restore = true;
        }
        this.version_documentUploaded.forEach((doc) => {
         // console.log(doc)
          //alert()
          let docum = doc;

          if (_.has(docum, "type") && !_.has(docum, 'mimetype')) {
            docum = Object.assign(docum, { mimetype: docum['type'] });
          }

          
          if (_.has(docum, "name") && !_.has(docum, 'extn')) {
            let docName = docum["name"];
            
            let nameArray = docName.split(".");
            if (nameArray.length > 1) {
              let length = nameArray.length;
              let ext = nameArray[length - 1];

              if (ext) {
                docum = Object.assign(docum, { extn: ext });
              }
            }
        
          }

        
          docum['uploadedBy'] =self.checkProperty(self.getUserData,'userId')!=''?self.checkProperty(self.getUserData,'userId'):null,
          docum['uploadedByName'] =self.checkProperty(self.getUserData,'name')!=''?self.checkProperty(self.getUserData,'name'):'',
          docum['uploadedByRoleId'] = self.getUserRoleId?self.getUserRoleId:null,
          docum['uploadedByRoleName'] =self.checkProperty(self.getUserData,'loginRoleName'),

          postData["documents"].push(docum);
        });
        
       
        if (this.parentId) {
          postData = Object.assign(postData, { parentId: this.parentId });
        }
        if (this.checkIsloginUserDoce) {
          postData = Object.assign(postData, { uploadByExecutive: true });
        }

        //    "depType": "beneficiary",// spouse, child, other
        //"depLabel": "beneficiary", // spouse, child_1, child_2, other
        if (
          this.checkProperty(this.selectedDocument, "depType") &&
          this.checkProperty(this.selectedDocument, "depLabel")
          &&  this.checkProperty(this.petition, "subTypeDetails", "id") != 15
        ) {
          postData["depType"] = this.checkProperty(this.selectedDocument, "depType");
          postData["depLabel"] = this.checkProperty(this.selectedDocument, "depLabel");
        }
        if(this.checkProperty(this.selectedDocument, "docUserType")){
          postData["docUserType"] = this.checkProperty(this.selectedDocument, "docUserType");
        }
         
        
        let dispatch = "uploadFormsAndLetters";
        if (
          this.checkProperty(this.petition, "typeDetails", "id") == 3 &&
          this.checkProperty(this.petition, "subTypeDetails", "id") == 15
        ) {
          dispatch = "uploadPermFormsAndLetters";
        }



        this.$store
          .dispatch(dispatch, postData)
          .then((response) => {
            this.getFormsAndLetters();
            if(showresponse == false && _.has(response, '_id')){
              if(this.checkProperty( this.$store.state ,'selectedForEditDocument') ){
                let ite = this.checkProperty( this.$store.state ,'selectedForEditDocument');
                ite['savedDocumentId'] = response['_id'];
                this.$store.commit("selectedForEditDocument", ite);
              }
             
            }
            this.versionUploadAfterUSCIS = false;
            this.selectedDocument = null;
            this.reversion_fileuploadPopup = false;
            this.version_documentUploaded = [];
            this.disable_reversion_uploadBtn = true;
            //this.getFormsAndLetters();
            this.parentId ='';
            if(showresponse){
              this.showToster({ message: response.message, isError: false });
            }
            this.getFormsAndLetters();
            setTimeout(() => {
              //  this.$emit("updatepetition" ,'Forms and Letters');
            }, 100);
          })
          .catch((error) => {
            if (fromRestore) {
              this.selectedDocument = null;
            }
            this.versionUploadAfterUSCIS = false;

            Object.assign(this.formerrors, { msg: error });
            this.showToster({ message: error, isError: true });
          });
      }
    },
    updateFilingFee() {
      this.$emit("showfilingFeesPopup");
    },
    cancelpopups() {
      this.documentData = [
        {
          type: "Forms, Letters and Others",
          documentUploaded: [],
        },
      ];
    },
    downloadFormslatters(downLoadZip = true, category='') {
      let postdata = {
        petitionId: this.petition._id,
        documentIds: [],
        downloadType: "zip",
        entityType: "case",
      };
      if (!downLoadZip) {
        postdata["downloadType"] = "pdf";
      }
      let self = this;
      //petition/download-forms-letters,
      //  if([3,4,5,6,7,8,9,10,11].indexOf(this.getUserRoleId)>-1){ 
      Object.assign(this.formerrors, { msg: "" });
      if(category == 'uscisForms' && this.uscisFormsAndLettersList){
        _.forEach(this.uscisFormsAndLettersList, (item) => {
          if((item.depType == self.depType && item.depLabel == self.depLabel && item.docUserType == self.docUserType && self.checkProperty( self.petition ,'subTypeDetails' ,'id') !=15) 
          || self.checkProperty( self.petition ,'subTypeDetails' ,'id') ==15 ){
            if ( item["selectedForDownload"] &&  postdata["documentIds"].indexOf(item._id) <= -1 ) {
              postdata["documentIds"].push(item._id);
            }
            if ( this.checkProperty(item, "reverse_document_versions") && item["reverse_document_versions"].length > 0 ) {
              _.forEach(item["reverse_document_versions"], (vItem) => {
                if (
                  vItem["selectedForDownload"] &&
                  postdata["documentIds"].indexOf(vItem._id) <= -1
                ) {
                  postdata["documentIds"].push(vItem._id);
                }
              });
            }
          }
        });
      }else{
        _.forEach(this.formsAndLettersList, (item) => {
          if((item.depType == self.depType && item.depLabel == self.depLabel && item.docUserType == self.docUserType && self.checkProperty( self.petition ,'subTypeDetails' ,'id') !=15) 
          || self.checkProperty( self.petition ,'subTypeDetails' ,'id') ==15 ){
            if ( item["selectedForDownload"] &&  postdata["documentIds"].indexOf(item._id) <= -1 ) {
              postdata["documentIds"].push(item._id);
            }
            if ( this.checkProperty(item, "reverse_document_versions") && item["reverse_document_versions"].length > 0 ) {
              _.forEach(item["reverse_document_versions"], (vItem) => {
                if (
                  vItem["selectedForDownload"] &&
                  postdata["documentIds"].indexOf(vItem._id) <= -1
                ) {
                  postdata["documentIds"].push(vItem._id);
                }
              });
            }
          }
        });
      }
     

      //  }

      if (postdata["documentIds"].length > 0) {
        if (
          [3].indexOf(this.checkProperty(this.petition, "typeDetails", "id")) > -1 &&
          [15].indexOf(this.checkProperty(this.petition, "subTypeDetails", "id")) > -1
        ) {
          postdata["entityType"] = "perm";
        }

        this.downloading = true;
        this.$store
          .dispatch("downloadFormslatters", postdata)
          .then((response) => {
            this.downloading = false;
            this.openDownloadPopup(false);
            this.openUscisDownloadPopup(false);
            window.open(
              this.$globalgonfig._APIURL + "/common/viewfile?path=" + response.path,
              "_blank"
            );
            // window.open(response.data.result.data, '_blank');
          })
          .catch((error) => {
            this.downloading = false;
            Object.assign(this.formerrors, { msg: error });
            //this.showToster({ message: error, isError: true });
          });
      } else {
        Object.assign(this.formerrors, { msg: "Atleast one document is required." });
      }
    },
    reloadPetition() {
      let self = this;
      setTimeout(() => {

       
        self.$route['params']['tabname'] ="Forms and Letters"; 
        self.$route['params']['tabname'] ="Forms and Letters"; 
        self.$emit("updatepetition", "Forms and Letters");
      }, 100);
    },
    getFormsAndLetters() {
      this.fileuploadPopup = false;
      this.uploadAfterUSCIS = false;
      this.reversion_fileuploadPopup = false;
      this.formsAndLettersList = [];
      this.uscisFormsAndLettersList = [];
      let finalList = [];
      let finalPrevousAfteruscis = [];
      this.previousVersionList = [];
      this.previousVersionAfteruscisList= [];
      this.previousExisted = false;
      let postData = {
        petitionId: this.petition._id,
        matcher: { typeIds: ["Form" ,'Letter'] },
        page: 1,
        perpage: 100000,
      };
    //  postData["matcher"]["typeIds"] = [this.formLetterType];

      if (
        this.checkProperty(this.petition, "typeDetails", "id") == 3 &&
        this.checkProperty(this.petition, "subTypeDetails", "id") == 15
      ) {
        postData["matcher"]["typeIds"] = ["Audit Response"];
        this.formLetterType = "Audit Response";
        //audit_response
      }
      this.updateLoading(true ,'NoDataFoundReff');
      this.$store
        .dispatch("getList", {
          data: postData,
          // path:"/petition/filled-forms-and-letters-list"
          path: "/filled-forms-and-letters/list",
        })
        .then((response) => {
          let lst = [];
 let subList = [];
          let mainList =[];
          let previousMainList =[];
          _.forEach(response.list, (mainItem) => {
            mainItem = Object.assign(mainItem, {
              reverse_document_versions: [],
              mainParentId: "",
              showMe: true,
              selectedForDownload: false,
              "viewmode":true,
            });
            if (mainItem.parentId) {
              mainItem["mainParentId"] = mainItem["parentId"];
            } else {
              mainItem["mainParentId"] = mainItem["_id"];
            }

            lst.push(mainItem);
          });
          // if(response){
          //    this.ActiveList = _.filter(response.list, (item) => {
          //     return item.statusId != 1
          //    });
          // }
          
         
          //reverse_document_versions
          _.forEach(lst, (mainItem) => {
            if (this.checkProperty(mainItem, "depType") != "child") {
              _.forEach(lst, (subItem) => {
                if (
                  mainItem.parentId &&
                  (mainItem.parentId == subItem["parentId"] ||
                    mainItem.parentId == subItem["_id"]) &&
                  mainItem["_id"] != subItem["_id"]
                ) {
                  subItem["showMe"] = false;
                  if (subList.indexOf(subItem["_id"]) <= -1) {
                    mainItem["reverse_document_versions"].push(subItem);
                    this.previousExisted = true;
                    subList.push(subItem["_id"]);
                    
                  }

                  // mainItem['showMe'] =true;
                }
              });
              
              
              if (mainItem.showMe && mainList.indexOf(mainItem['_id'])<= -1  && !mainItem['generateNewVersion']) {
                mainList.push(mainItem['_id'])
                finalList.push(_.cloneDeep(mainItem));
              }
              if (mainItem.showMe && previousMainList.indexOf(mainItem['_id'])<= -1 && mainItem['generateNewVersion']) {
                previousMainList.push(mainItem['_id'])
                finalPrevousAfteruscis.push(_.cloneDeep(mainItem));
              }
            } else {
             
              _.forEach(lst, (subItem) => {
                if (
                  this.checkProperty(mainItem, "depType") ==
                    this.checkProperty(subItem, "depType") &&
                  this.checkProperty(mainItem, "depLabel") ==
                    this.checkProperty(subItem, "depLabel") &&
                  mainItem.parentId &&
                  (mainItem.parentId == subItem["parentId"] ||
                    mainItem.parentId == subItem["_id"]) &&
                  mainItem["_id"] != subItem["_id"]
                ) {
                  subItem["showMe"] = false;
                  if (subList.indexOf(subItem["_id"]) <= -1) {
                    mainItem["reverse_document_versions"].push(subItem);
                    this.previousExisted = true;
                    subList.push(subItem["_id"]);
                   
                  } 

                  // mainItem['showMe'] =true;
                }
              });

              if (mainItem.showMe && mainList.indexOf(mainItem['_id'])<= -1 && !mainItem['generateNewVersion']) {
                mainList.push(mainItem['_id'])
                finalList.push(_.cloneDeep(mainItem));
              }
              if (mainItem.showMe && previousMainList.indexOf(mainItem['_id'])<= -1 && mainItem['generateNewVersion']) {
                previousMainList.push(mainItem['_id'])
                finalPrevousAfteruscis.push(_.cloneDeep(mainItem));
              }
            }
          });
          // if(this.checkProperty(finalList, 'length')>0){
          //   let sel = this
          //   _.forEach(finalList, (item)=>{
          //     if(_.has(item, 'reverse_document_versions') && sel.checkProperty(item, 'reverse_document_versions', 'length')>0){
          //       item  = _.orderBy(item, ["reverse_document_versions",'updatedOn' ] ,["desc",'desc'] );
          //     }
          //   })
          // }

          this.previousVersionList = _.cloneDeep(finalList);
          this.previousVersionAfteruscisList = _.cloneDeep(finalPrevousAfteruscis);
          this.totalpages = Math.ceil(response.totalCount / this.perpage);
          //this.formsAndLettersList = _.cloneDeep(finalList); // JSON.parse(JSON.stringify(finalList));
         let tempList = _.filter(finalList,(ite)=>{
          let findObj =  _.find(finalList,{'parentId':ite['_id']});
            if(!findObj && (!ite['generateNewVersion'] || ite['generateNewVersion'] == false)){
              return true
            }else{
              return false
            }
          });
          let newGenerateList = _.filter(finalPrevousAfteruscis,(ite)=>{
          let findOj =  _.find(finalPrevousAfteruscis,{'parentId':ite['_id']});
            if(!findOj && ite['generateNewVersion']){
              return true
            }else{
              return false
            }
          });
          this.uscisFormsAndLettersList = _.cloneDeep(newGenerateList);
          //console.log(JSON.stringify(this.uscisFormsAndLettersList))
          this.formsAndLettersList = _.cloneDeep(tempList);
          this.splitChildrensFormsAndLetters();
          this.splitAfterUscisChildrensFormsAndLetters();
          if(this.checkProperty(this.formsAndLettersList, 'length')>0){
            this.splitFormsAndLettersByCategory('beneficiary');
            this.splitFormsAndLettersByCategory('spouse');
            this.splitFormsAndLettersByCategory('child');
          }
          if(this.checkProperty(this.uscisFormsAndLettersList, 'length')>0){
            this.splitFormsAndLettersByCategory('beneficiary','uploadAfterUSCIS');
            this.splitFormsAndLettersByCategory('spouse','uploadAfterUSCIS');
            this.splitFormsAndLettersByCategory('child','uploadAfterUSCIS');
          }
         // this.getMasetFormsAndLatters(false);
          this.updateLoading(false, 'NoDataFoundReff');
          setTimeout(() => {
            this.updateLoading(false, 'NoDataFoundReff');
            this.updateLoading(false, 'NoDataFoundReff');
            this.updateLoading(false, 'NoDataFoundReff');
               setTimeout(() => { 
                this.updateLoading(false ,'NoDataFoundReff'); 
                setTimeout(() => { this.updateLoading(false, 'NoDataFoundReff');  }, 100);
               }, 10);
          }, 10);
        })
        .catch((err) => {
          this.updateLoading(false);
          this.formsAndLettersList = [];
          setTimeout(() => {
            this.updateLoading(false);
          }, 10);
        });
    }, 
    splitFormsAndLettersByCategory(category, type=''){
      if(type == 'uploadAfterUSCIS'){
        if(this.checkProperty(this.uscisFormsAndLettersList, 'length')>0 && this.checkSubmitToUscisCompleted){
          if(category == 'beneficiary' || category == 'spouse' ){
            let categoryList  =_.filter(this.uscisFormsAndLettersList, { "depType":category } );
            if(categoryList.length > 0){
              if(category == 'beneficiary'){
                let benobj = {};
                benobj = Object.assign( benobj ,{'selectedAll':true});
                benobj = Object.assign( benobj ,{'documents':categoryList})
                this.uscisbeneficiaryDownloadDoc = _.cloneDeep(benobj);
              }
              if(category == 'spouse'){
                let spouseobj = {};
                spouseobj = Object.assign( spouseobj ,{'selectedAll':true});
                spouseobj = Object.assign( spouseobj ,{'documents':categoryList})
                this.uscisspouseDownloadDoc = _.cloneDeep(spouseobj);
              } 
            } 
          }
          if(category == 'child'){
            let allChildList  =_.filter(this.uscisFormsAndLettersList, { "depType":'child',"docUserType":'Dependent' } );
            if(allChildList && allChildList.length>0){
              let childrenDownloadDoc = _.groupBy(allChildList ,'depLabel');
              let childCatDocs = Object.entries(childrenDownloadDoc);
              let self = this;
              if(this.checkProperty(childCatDocs, 'length')>0){
                _.forEach(childCatDocs, (childItm)=>{
                  let obj = {}
                  if(self.checkProperty(childItm, 'length')>0){
                    let categty = _.cloneDeep(childItm[0]);
                    categty = categty.trim();
                    if(self.checkProperty(childItm[1], 'length')>0){
                      obj = Object.assign( obj ,{'selectedAll':true});
                      obj = Object.assign( obj ,{'docUserType':categty});
                      obj = Object.assign( obj ,{'documents':childItm[1]});
                    }
                    let findObj = _.find(self.uscischildrenDownloadDoc ,{ 'docUserType': categty})
                    if(!findObj){
                      self.uscischildrenDownloadDoc.push(obj)
                    }
                  }
                })
                if(self.checkProperty(self.uscischildrenDownloadDoc, 'length')>0){
                  self.uscischildrenDownloadDoc = self.uscischildrenDownloadDoc.reverse();
                }
              }
              
            }
          }
        }
      }else{
        if(this.checkProperty(this.formsAndLettersList, 'length')>0){
          if(category == 'beneficiary' || category == 'spouse' ){
            let categoryList  =_.filter(this.formsAndLettersList, { "depType":category } );
            if(categoryList.length > 0){
              if(category == 'beneficiary'){
                let benobj = {};
                benobj = Object.assign( benobj ,{'selectedAll':true});
                benobj = Object.assign( benobj ,{'documents':categoryList})
                this.beneficiaryDownloadDoc = _.cloneDeep(benobj);
              }
              if(category == 'spouse'){
                let spouseobj = {};
                spouseobj = Object.assign( spouseobj ,{'selectedAll':true});
                spouseobj = Object.assign( spouseobj ,{'documents':categoryList})
                this.spouseDownloadDoc = _.cloneDeep(spouseobj);
              } 
            }
          }
          if(category == 'child'){
            let allChildList  =_.filter(this.formsAndLettersList, { "depType":'child',"docUserType":'Dependent' } );
            if(allChildList && allChildList.length>0){
              let childrenDownloadDoc = _.groupBy(allChildList ,'depLabel');
              let childCatDocs = Object.entries(childrenDownloadDoc);
              let self = this;
              if(this.checkProperty(childCatDocs, 'length')>0){
                _.forEach(childCatDocs, (childItm)=>{
                  let obj = {}
                  if(self.checkProperty(childItm, 'length')>0){
                    let categty = _.cloneDeep(childItm[0]);
                    categty = categty.trim();
                    if(self.checkProperty(childItm[1], 'length')>0){
                      obj = Object.assign( obj ,{'selectedAll':true});
                      obj = Object.assign( obj ,{'docUserType':categty});
                      obj = Object.assign( obj ,{'documents':childItm[1]});
                    }
                    let findObj = _.find(self.childrenDownloadDoc ,{ 'docUserType': categty})
                    if(!findObj){
                      self.childrenDownloadDoc.push(obj)
                    }
                  }
                })
                if(self.checkProperty(self.childrenDownloadDoc, 'length')>0){
                  self.childrenDownloadDoc = self.childrenDownloadDoc.reverse();
                  //console.log(JSON.stringify(self.childrenDownloadDoc))
                }
              }
              
            }
          }
        }
      }
      
    },
    pageNate(pageNum) {
      this.page = pageNum;
      this.getFormsAndLetters();
    },
    openGeneratePopup() {
      this.formerrors.msg = "";
      this.newFormsAndLetters = []
      this.generatePopup = true;
    },
    handleSignForms(forms){
      this.$emit('pet_view_and_sign' ,forms)
   },
  },

  data: () => ({
    workFlowDetails:null,
    changingLoader:false,
    ignore485Keys:['criminalActsAndViolationsAddiInfo','genEligAndInadmisGroundsQ46aTo50AddiInfo','genEligAndInadmisGroundsQ51AddiInfo',
    'genEligAndInadmisGroundsQ52To60AddiInfo', 'rmvProcFiledResonWriteStmt', 'nationImgrstaIfAviodTrainArmForcUS'],
    selectedApplicant:null,
    applicantList:[],
    i485AdditionalInfo:{
      everDeniedAdmissionInUS: null, // 14.Have you EVER been denied admission to the United States?
      isVisaDenieedTOUS: null, /// 15.HAVE YOU EVER BEEN DENIED A VISA TO THE UNITED STATES?
      everWorkedInUSWithoutAuth: null, // 16. Have you EVER worked in the United States without authorization?
      everViolatedTandCofYourNonImmStatus: null, // 17. Have you EVER violated the terms or conditions of your nonimmigrant status?
      everBeenInRemovalExcl: null, // 18. Are you presently or have you EVER been in removal, exclusion, rescission, or deportation proceedings?
      everBeenIssuedOrderExclRemoval: null, // 19. Have you EVER been issued a final order of exclusion, deportation, or removal?
      everHadPriorOrderExclDeport: null, // 20. Have you EVER had a prior final order of exclusion, deportation, or removal reinstated?
      
      everHeldPermResidentStatus: null, //21.Have you EVER held lawful permanent resident status which was later rescinded?
      everGrantedVolDepartimmgOfficer: null,//22.Have you EVER been granted voluntary departure by an immigration officer or an immigration judge but failed todepart within the allotted time?
      everAppliedReliefOrExclDeport: null,//23.Have you EVER applied for any kind of relief or protection from removal, exclusion, or deportation?
      everJNonImmmExchangeVistor: null,//24.a. Have you EVER been a J nonimmigrant exchange visitor who was subject to the two-year foreign residencerequirement?
      //if 24.a yes
      everCompailedForeignResi: null, //24.b Have you complied with the foreign residence requirement?
      everGrantedWavierRecomndLtr: null, //24.c Have you been granted a waiver or has Department of State issued a favorable waiver recommendation letter for you? 
      
      //Criminal Acts and Violations
      everArrested: null, //25. Have you EVER been arrested, cited, charged, or detained for any reason by any law enforcement official(including but not limited to any U.S. immigrationofficial or any official of the U.S. armed forces or U.S.Coast Guard)?
      everCommittedCrime: null, //26.Have you EVER committed a crime of any kind (even if you were not arrested, cited, charged with, or tried for thatcrime)? 
      everPledGuilty: null, //27.Have you EVER pled guilty to or been convicted of a crime or offense (even if the violation was subsequently expunged or sealed by a court, or if you were granted apardon, amnesty, a rehabilitation decree, or other act ofclemency)?
      everPunishedByJudge: null, //28.Have you EVER been ordered punished by a judge or had conditions imposed on you that restrained your liberty(such as a prison sentence, suspended sentence, housearrst, parole, alternative sentencing, drug or alcoholtreatment, rehabilitative programs or classes, probation, orcommunity service)?
      everAccusedCrimProc: null, //29.Have you EVER been a defendant or the accused in acriminal proceeding (including pre-trial diversion,deferred prosecution, deferred adjudication, or any withheld adjudication)? 
      everViolated: null, //30.Have you EVER violated (or attempted or conspired toviolate) any controlled substance law or regulation of astate, the United States, or a foreign country?
      everConvictedTwoOrMoreOffens: null,//31.Have you EVER been convicted of two or more offenses(other than purely political offenses) for which thecombined sentences to confinement were five years ormore?
      everIlleglTraf: null, //32.Have you EVER illicitly (illegally) trafficked or benefitedfrom the trafficking of any controlled substances, such aschemicals, illegal drugs, or narcotics?
      everKnowinglyIlleglTraf: null, //33.Have you EVER knowingly aided, abetted, assisted,conspired, or colluded in the illicit trafficking of anyillegal narcotic or other controlled substances?
      everSpouseSondaughterIlleglTraf: null,//34. Are you the spouse, son, or daughter of a foreign nationalwho illicitly trafficked or aided (or otherwise abetted,assisted, conspired, or colluded) in the illicit trafficking ofa controlled substance, such as chemicals, illegal drugs, ornarcotics and you obtained, within the last five years, anyfinancial or other benefit from the illegal activity of yourspouse or parent, although you knew or reasonably shouldhave known that the financial or other benefit resultedfrom the illicit activity of your spouse or parent?
      everEngageProst: null,//35.Have you EVER engaged in prostitution or are you coming to the United States to engage in prostitution?
      everdirOrIndirectProst: null, //36.Have you EVER directly or indirectly procured (or attempted to procure) or imported  prostitutes or persons for the purpose of prostitution?
      everReceiveMoneyFronProst: null, //37.Have you EVER received any proceeds or money fromprostitution?
      everIntentIllegalGamblUS: null, //38.Do you intend to engage in illegal gambling or any other form of commercialized vice, such as prostitution,bootlegging, or the sale of child pornography, while in the United States?
      everImmunityCriminalOffensedInUS: null, //39.Have you EVER exercised immunity (diplomatic or otherwise) to avoid being prosecuted for a criminaloffense in the United States?
      everViolateReliFreedomAsForeignGovOffi: null,//40. Have you EVER, while serving as a foreign governmentofficial, been responsible for or directly carried outviolations of religious freedoms?
      everForceFraudCommercialSexActs: null,//41.Have you EVER induced by force, fraud, or coercion (orotherwise been involved in) the trafficking of persons forcommercial sex acts?
      everTraffPersonIntoInvolSlavery: null, //42.Have you EVER trafficked a person into involuntary servitude, peonage, debt bondage, or slavery? Trafficking includes recruiting, harboring, transporting, providing, or obtaining a person for labor or services through the use offorce, fraud, or coercion.
      everKnowWithTraffPersonCommSexAct: null, //43.Have you EVER knowingly aided, abetted, assisted, conspired, or colluded with others in trafficking persons for commercial sex acts or involuntary servitude, peonage, debt bondage, or slavery?
      everSpouseSonDughterEngTraffAnyFinBef: null,//44.Are you the spouse, son or daughter of a foreign national who engaged in the trafficking of persons and have received or obtained, within the last five years, any financial or other benefits from the illicit activity of your spouse or your parent, although you knew or reasonably should have known that this benefit resulted from the illicit activity of your spouse or parent?
      everEngMoneyLaundering: null,//45.Have you EVER engaged in money laundering or have you EVER knowingly aided, assisted, conspired, or colluded with others in money laundering or do you seek to enter the United States to engage in such activity?
      
      //Security and Related
      everViolateEvidenceLawRelatedInUS: null,//46.a. Engage in any activity that violates or evades any law relating to espionage (including spying) or sabotage in theUnited States?
      everViolateExpGoodsSensInfoTechInUS: null,//46.b. Engage in any activity in the United States that violates or evades any law prohibiting the export from the United States of goods, technology, or sensitive information? 
      everOverthrowingUSGovtByForceViolence: null,//46.c. Engage in any activity whose purpose includes opposing,controlling, or overthrowing the U.S. Government byforce, violence, or other unlawful means while in theUnited States?
      everActivityDangerScurityOfUs: null,//46.d.Engage in any activity that could endanger the welfare,safety, or security of the United States? 
      everEngUnlawfulActivity: null,//46.e.Engage in any other unlawful activity?
      everEngActSeriousForeignPolicyforUs: null,//47.Are you engaged in or, upon your entry into the United States, do you intend to engage in any activity that could have potentially serious adverse foreign policy consequences for the United States?
      everCommitedKidnapHjkEtc: null,//48.a. Committed, threatened to commit, attempted to commit,conspired to commit, incited, endorsed, advocated,planned, or prepared any of the following: hijacking,sabotage, kidnapping, political assassination, or use of aweapon or explosive to harm another individual or causesubstantial damage to property? 
      everCommMemberGrpOrgKidnapHjkEtc: null, //48.b. Participated in, or been a member of, a group ororganization that did any of the activities described in Item Number 48.a.? 
      everAskMoneyRecruGrpKidnapHijackEtc: null, //48.c.Recruited members or asked for money or things of value for a group or organization that did any of the activitiesdescribed in Item Number 48.a.?
      everProvideMoneyForAssiKidnapHjkEtc: null, //48.d.Provided money, a thing of value, services or labor, orany other assistance or support for any of the activitiesdescribed in Item Number 48.a.? 
      everProvideMoneyForAssiIndiGrpKidnapHjkEtc: null,//48.e. Provided money, a thing of value, services or labor, or any other assistance or support for an individual, group,or organization who did any of the activities described inItem Number 48.a.?
      everTraiParaOrMilataryWepons: null,//49.Have you EVER received any type of military,paramilitary, or weapons training? 
      everEngKidnapHjkEtc: null,//50.Do you intend to engage in any of the activities listed in any part of Item Numbers 48.a. - 49.?
      //if answered yes items b/w 46.a to 50
      //Additional info
      everSpoOrChiEngKidnapHjkEtc: null,//51.a. Committed, threatened to commit, attempted to commit,conspired to commit, incited, endorsed, advocated,planned, or prepared any of the following: hijacking,sabotage, kidnapping, political assassination, or use of a weapon or explosive to harm another individual or cause substantial damage to property? 
      everHSpoOrChiPartMemberKidnapHjkEtc: null, //51.b. Participated in, or been a member or a representative of agroup or organization that did any of the activities described in Item Number 51.a.? 
      everSpoOrChiRecrutKidnapHjkEtc: null, //51.c. Recruited members, or asked for money or things of value,for a group or organization that did any of the activities described in Item Number 51.a.? 
      everSpoOrChiAskMoneyAssiKidnapHjkEtc: null,//51.d. Provided money, a thing of value, services or labor, or any other assistance or support for any of the activities described in Item Number 51.a.? 
      everSpoOrChiForAssiIndiGrpKidnapHjkEtc: null,//51.e. Provided money, a thing of value, services or labor, or any other assistance or support to an individual, group, or ganization who did any of the activities described in Item Number 51.a.? 
      everSpoOrChiTraiParaOrMilataryWeponKidnapHjkEtc: null,//51.f. Received any type of military, paramilitary, or weapons training from a group or organization that did any of the activities described in Item Number 51.a.? 
      //if answered yes items of 51
      //Additional info
      everSellProvideTransWepon: null,//52. Have you EVER assisted or participated in selling,providing, or transporting weapons to any person who,to your knowledge, used them against another person?
      everWorkedPrisionAndDetained: null,//53. Have you EVER worked, volunteered, or otherwiseserved in any prison, jail, prison camp, detention facility,labor camp, or any other situation that involved detainingpersons?
      everUsingWeponPartGrpOrgThreatPerson: null,//54.Have you EVER been a member of, assisted, or participated in any group, unit, or organization of anykind in which you or other persons used any type ofweapon against any person or threatened to do so?
      everServedParaOrMilataryEtc: null,//55.Have you EVER served in, been a member of, assisted,or participated in any military unit, paramilitary unit,police unit, self-defense unit, vigilante unit, rebel group,guerilla group, militia, insurgent organization, or anyother armed group?
      everMemberCommPartyInUS: null,//56.Have you EVER been a member of, or in any way affiliated with, the Communist Party or any othertotalitarian party (in the United States or abroad)?
      ever080545To230393AssoNaziGerGov: null,//57.During the period from March 23, 1933 to May 8, 1945,did you ever order, incite, assist, or otherwise participatein the persecution of any person because of race, religion,national origin, or political opinion, in association witheither the Nazi government of Germany or anyorganization or government associated or allied with theNazi government of Germany?
      everInvolveTorture: null,//58.a. Acts involving torture or genocide?
      everKillAnyPerson: null,//58.b.Killing any person?
      everSeverInjuAnyPerson: null,//58.c.Intentionally and severely injuring any person?
      everEngAnySexualContent: null,//58.d. Engaging in any kind of sexual contact or relations with any person who did not consent or was unable to consent, or was being forced or threatened?
      everLimitReligBnf: null,//58.e. Limiting or denying any person's ability to exercise religious beliefs?
      everUsedBelow15yrsPerson: null,//59.Have you EVER recruited, enlisted, conscripted, or usedany person under 15 years of age to serve in or help anarmed force or group?
      everHelpUnder15yrsPerson: null,//60. Have you EVER used any person under 15 years of age to take part in hostilities, or to help or provide services to people in combat?
      //if answered yes items b/w 52 to 60
      //Public Assistance
      everRcvPublicAssiInUS: null,//61.Have you received public assistance in the United Statesfrom any source, including the U.S. Government or anystate, county, city, or municipality (other than emergencymedical treatment)?
      everFutureRcvPublicAssiInUs: null,//62.Are you likely to receive public assistance in the future inthe United States from any source, including the U.S.Government or any state, county, city, or municipality(other than emergency medical treatment)?
      //Illegal Entries and Other Immigration Violations
      everAttenRmvProcFiledAfter010497: null,//63.a. Have you EVER failed or refused to attend or to remain in attendance at any removal proceeding filed against youon or after April 1, 1997?
      everRmvProcFiledReason: null,//63.b. If your answer to Item Number 63.a. is "Yes," do youbelieve you had reasonable cause?
      rmvProcFiledResonWriteStmt: '',//63.c.If your answer to Item Number 63.b. is "Yes," attach a written statement explaining why you had reasonable cause.
      everSubmitFraudDocUSGov: null,//64.Have you EVER submitted fraudulent or counterfeit documentation to any U.S. Government official to obtainor attempt to obtain any immigration benefit, including avisa or entry into the United States?
      everLiedMisrepreInfoEnterUS: null,//65.Have you EVER lied about, concealed, or misrepresented any information on an application or petition to obtain avisa, other documentation required for entry into theUnited States, admission to the United States, or any otherkind of immigration benefit?
      everClaimFlaslyUSCitizen: null,//66.Have you EVER falsely claimed to be a U.S. citizen (inwriting or any other way)?
      everStowawayOnVessel: null,//67.Have you EVER been a stowaway on a vessel or aircraft arriving in the United States?
      everTrytoEnterUsIllegaly: null,//68. Have you EVER knowingly encouraged, induced, assisted,abetted, or aided any foreign national to enter or to try toenter the United States illegally (alien smuggling)?
      everFinalOrderCivilPenalty: null,//69. Are you under a final order of civil penalty for violating INA section 274C for use of fraudulent documents?
      //Removal, Unlawful Presence, or Illegal Reentry After Previous Immigration Violations
      everRemovedfromUs: null,//70. Have you EVER been excluded, deported, or removedfrom the United States or have you ever departed theUnited States on your own after having been ordered excluded, deported, or removed from the United States?
      everEnterUSWithoutInspAdmit: null, //71.Have you EVER entered the United States without being inspected and admitted or paroled?
      everSince010497More180DLessYrULFStayUS: null,//72.a. For more than 180 days but less than a year, and thendeparted the United States?
      everSince010497YrOrMoreULFDepartUS: null,//72.b.For one year or more and then departed the United States?  
      everSince010497ReEntMoreYrULFStayUS: null,//73.a.Having been unlawfully present in the United States for more than one year in the aggregate?
      everSince010497RmvFromUS: null,//73.b.Having been deported, excluded, or removed from the United States?
      //Miscellaneous Conduct
      planForPractPolyInUS: null,//Do you plan to practice polygamy in the United States?
      AreYouAccomOtherCountry: null,//75.Are you accompanying another foreign national who requires your protection or guardianship but who isinadmissible after being certified by a medical officer asbeing helpless from sickness, physical or mentaldisability, or infancy, as described in INA section 232(c)?
      everAnyUsChildUnderCustody: null,//76. Have you EVER assisted in detaining, retaining, or withholding custody of a U.S. citizen child outside theUnited States from a U.S. citizen who has been grantedcustody of the child?
      everVoilationAnyFedaral: null,//77.Have you EVER voted in violation of any Federal, state,or local constitutional provision, statute, ordinance, orregulation in the United States?
      everUsCtzshipAvoidTax: null,//78.Have you EVER renounced U.S. citizenship to avoidbeing taxed by the United States?
      everAppliedForExemptServiceUS: null,//79.a. Applied for exemption or discharge from training or service in the U.S. armed forces or in the U.S. NationalSecurity Training Corps on the ground that you are aforeign national?
      everReliServTrainAreYouForeignNation: null,//79.b. Been relieved or discharged from such training or serviceon the ground that you are a foreign national?
      everConvictDestUSArmedForce: null,//79.c. Been convicted of desertion from the U.S. armed forces?
      everRemOutsideUSAviodTrainArmedForce: null,//80.a. Have you EVER left or remained outside the United States to avoid or evade training or service in the U.S.armed forces in time of war or a period declared by thePresident to be a national emergency?
      nationImgrstaIfAviodTrainArmForcUS: '',//80.b. If your answer to Item Number 80.a. is “Yes,” what was your nationality or immigration status immediately beforeyou left (for example, U.S. citizen or national, lawfulpermanent resident, nonimmigrant, parolee, present without admission or parole, or any other status)?
        
    },
    loadingI485:false,
    considerForDependents:false,
    yesToAll:false,
    noToAll:false,
    showAdditionalQuestionnaire:false,
    showDetailsPopup:false,
    toggleAccord:false,
    petitionhistory:null,
    previousVersionList:[],
    previousVersionAfteruscisList:[],
    selectAll:false,
    encodedString:'',
    updatePreEmployDetails:'',
    updateReload:false,
    loadingI140:false,
    filingFormsList:[{'id':'i485',name:'Form I-485'},
    {'id':'i131',name:'Form I-131 '},{'id':'i765',name:'Form I-765'},{'id':'other',name:'Other'}],
    i140AdditionalInfo:{
      petitionBeingFieldFor: "",
      petitionBeingField: "", 
      prevPetiReceiptNumber: "",
      anyOtherPetiOrApplications: "",
      petiOrApplicAllApplicableBoxes: [],
      petiOrApplicAllApplicableBoxOther: "",
      removalProceedings: "",
      immiVisaPetitionOrPerson: "",
      supportOfAnotherFormi140: "",
      departmentOfLabor: "",
      considerBnfEmpInfoForLetters:''
    },
    depType:'',
    depLabel:'',
    docUserType:'Beneficiary',
    showPreviousVersionsList:[],
    childrenFormsAndLetters:{},
    childUscisFormsAndLetters:{},
    showDocType:false,
    isValiedCourierAddress:false,
    courierAddress:'',
    showCourier:true,
    selectedCourier:null,
    masterCourierList:[],
    courierListTemp:[],
    
    showentityIdError:false,
    showTypeIdError:false,
    entityId:'cover_letter',
    
    entityIdDetails:null,
    entityIds:[{"id":"'cover_letter'" ,"name":"Cover Letter"},{"id":'support_letter' ,"name":'Support Letter'}],
   // DocTypeIds:[{"id":"'Beneficiary'","name":"Beneficiary"},{"id":"'Dependent'","name":"Dependent"}],
    editor: ClassicEditor,
 editorConfig: {
     toolbar: [ 'bold', 'italic', '|', 'undo','redo'  ,'NumberedList', 'BulletedList', ],
 },
    filesUploading: false,
    fvalue: [],

    docsLists: [
      {
        key: "sunday",
        fieldName: "sunday",
        required: false,
        label: "Copy of Sunday edition of the newspaper",
        display: true,
        loading: false,
      },
      {
        key: "jobFair",
        fieldName: "jobFair",
        required: false,
        label: "Copy of advertised at job fair",
        display: true,
        loading: false,
      },
      {
        key: "campusRecruitment",
        fieldName: "campusRecruitment",
        required: false,
        label: "Copy of advertised at on-campus recruiting",
        display: true,
        loading: false,
      },
      {
        key: "empWebsite",
        fieldName: "empWebsite",
        required: false,
        label: "Copy of advertised at on employer website",
        display: true,
        loading: false,
      },
      {
        key: "profOrgOrTrade",
        fieldName: "profOrgOrTrade",
        required: false,
        label: "Copy of advertised with trade or professional organization",
        display: true,
        loading: false,
      },
      {
        key: "pvtEmpmtFirm",
        fieldName: "pvtEmpmtFirm",
        required: false,
        label: "Copy of advertised at employment firm",
        display: true,
        loading: false,
      },
      {
        key: "jobSearchWebsite",
        fieldName: "jobSearchWebsite",
        required: false,
        label: "Copy of advertised at job search website",
        display: true,
        loading: false,
      },
      {
        key: "empRefProgram",
        fieldName: "empRefProgram",
        required: false,
        label: "Copy of advertised at employee referral program",
        display: true,
        loading: false,
      },
      {
        key: "campusPlacement",
        fieldName: "campusPlacement",
        required: false,
        label: "Copy of advertised at campus placement office ",
        display: true,
        loading: false,
      },
      {
        key: "localNewsPaper",
        fieldName: "localNewsPaper",
        required: false,
        label: "Copy of advertised at local or ethnic newspaper",
        display: true,
        loading: false,
      },
      {
        key: "tvAds",
        fieldName: "tvAds",
        required: false,
        label: "Copy of advertised at radio or TV ads",
        display: true,
        loading: false,
      },
      {
        key: "intrOfcMemomandum",
        fieldName: "intrOfcMemomandum",
        required: false,
        label: "Copy of Signed documents",
        display: true,
        loading: false,
      },
      {
        key: "recruReportSummary",
        fieldName: "recruReportSummary",
        required: false,
        label:
          "Copy of Recruitment Report and Summary describing the recruitment efforts and results",
        display: true,
        loading: false,
      },
      {
        key: "busNecLetterByEplr",
        fieldName: "busNecLetterByEplr",
        required: false,
        label: "Copy of Business Necessity Letter Provided by Employer",
        display: true,
        loading: false,
      },
    ],
    selectedAction: "",
    index: "",
    approveOrRejectDocs: false,
    approveOrRejectDocsTitle:"Approve Documents",
    formErrors: "",
    comments: "",
    //loading: false,
    selectedDocument: null,
    loadingFormLatters: false,
    previousExisted: false,
    showPreviousVersions:false,
    showUscisPreviousVersions:false,
    formSubmited: false,
    regeneratingFormAndLetter: false,
    generateFormsLattersPopup: false,
    masterFormsAndLatters: {
      beneficiary: {
        coverLetters:{
          toggleHeader:false,
          HeaderLabel:'Cover Letter',
          documents:[]
        },
        supportLetters:{
          toggleHeader:false,
          HeaderLabel:'Support Letter',
          documents:[]
        },
        forms:{
          toggleHeader:false,
          HeaderLabel:'Forms',
          documents:[]
        },
      },
      spouse: [],
      child: {},
    },
    gettingUrl: false,
    numPdfPages: 1,
    pdfPage: 1,
    pdfUrl: "",
    selectedOffice: null,
    officeList: [],
    togleFileUpload: true,
    acceptedFiles: "application/pdf",
    approveConformpopUp: false,
    selectedItem: null,
    generatingFiles: false,
    openItem: true,
    formLetterType: "Form", //'Letter',
    downloading: false,
    downloadFiles: false,
    parentId: "",
    uploading: false,
    value: [],
    formerrors: {
      msg: "",
    },
    newFormsAndLetters: [],
    all_formTypes: [
      { name: "Form", id: "Form" },
      { name: "Letter", id: "Letter" },
    ],
    generatePopup: false,
    totalpages: 0,
    page: 1,
    perpage: 25,
    formsAndLettersList: [],
    uscisFormsAndLettersList:[],
    beneficiaryDownloadDoc:null,
    spouseDownloadDoc:null,
    childrenDownloadDoc:[],
    uscisbeneficiaryDownloadDoc:null,
    uscisspouseDownloadDoc:null,
    uscischildrenDownloadDoc:[],
    types: [],
    typeSelected: "",
    documents: [],
    documentData: [
      {
        type: "Forms, Letters and Others",
        documentUploaded: [],
      },
    ],
    formsData: [],
    formsAndLetterSignedUrls: [],
    downloadSamplespopup: false,
    documentId: "",
    version_documentUploaded: [],
    fileuploadPopup: false,
    uploadAfterUSCIS:false,
    disable_uploadBtn: false,
    selectedDoc: "",
    reversion_fileuploadPopup: false,
    disable_reversion_uploadBtn: false,
    reversionFile: null,
    fuploder: false,
    rfuploder: false,
    uploadMainDocuments: [],
    uploadFinalMainDocuments: [],
    adminsList: [],
    ManagerList: [],
    petitionDetails: {},
  }),
  mounted() {
   // console.log('this.workFlowDetails',this.workFlowDetails)
    this.generateApplicantList();
    this.getCourierList();
    this.getcaseHistory();
   // this.docUserType = 'Beneficiary';
    setTimeout(() => {



      var data = _.merge(this.petitionDetails, this.petition);
      this.petitionDetails = _.cloneDeep(data);
      setTimeout(() => {
        var data = _.merge(this.petitionDetails, this.petition);
        this.petitionDetails = _.cloneDeep(data);
//alert(this.checkProperty(this.petitionDetails,'workflowId'))
//alert(this.checkProperty(this.workFlowDetails,'assignUsersOn'))
      if(this.checkProperty(this.petitionDetails,'workflowId')){
       this.getWorkflowDetails(this.checkProperty(this.petitionDetails,'workflowId'))
      }
      }, 100);

      

    }, 10);
    // let adminsactiVityList =[];
    // if (_.has(this.workFlowDetails, "config")) {
      
    //   let adminsactiVityList = _.find(this.workFlowDetails.config, {
    //    code: "MANAGER_LIST",
    //  });
    // if (adminsactiVityList && adminsactiVityList.editors) {
    //  this.adminsList = _.map(adminsactiVityList.editors, "roleId");
    //  }
     
    // }
    // let docsManagerList = _.find(this.workFlowDetails.config, {
    // code: "DOCUMENTATION_MANAGER_LIST",
    // });
    // if (docsManagerList && docsManagerList.editors) {
    //   this.ManagerList = _.map(docsManagerList.editors, "roleId");
    // }

    this.$store.commit("selectedForEditDocument", null);

    //  md_service_centerlet
    // this.checkProperty(this.petition,'typeDetails','id')
    let postData = { page: 1, perpage: 1000,
      filters: {
        typeIds: [],
        petitionId:this.checkProperty(this.petition,'_id')
        }, 
      };
      if(this.checkProperty(this.petition,'typeDetails','id')){
        postData['filters']['typeIds'].push(this.checkProperty(this.petition,'typeDetails','id'))
      }
    this.$store
      .dispatch("commonAction", { data: postData, path: "/service-centers/list" })
      .then((res) => {
        this.officeList = res["list"];
        if (this.checkProperty(this.getPetitionDetails, "serviceCenter", "id")) {
          this.selectedOffice = this.checkProperty(
            this.getPetitionDetails,
            "serviceCenter"
          );
        } else if (this.checkProperty(this.officeList, "length") > 0) {
         // this.selectedOffice = this.officeList[0];
        }
      });

    this.fetchFormsMasterData();
    if(this.$route.params && this.$route.params.openGeneratePopup && this.$route.params.openGeneratePopup=='openGeneratePopup' ){
      
      //this.$route['params']['openGeneratePopup'] ='';
     // this.$route['query']['openGenForms'] ='';
     // this.getMasetFormsAndLatters(true);
    }
    this.getFormsAndLetters(false);
    this.getFormsAndLetters();

   
    if (this.checkProperty(this.petition, "subTypeDetails", "id") == 15) {
      this.acceptedFiles =
        "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    }
  },
  computed: {
    checkDependentsExists(){
      let returnVal = false;
      let spouseObj = _.find(this.applicantList, {'id':'spouse'});
      let childObj = _.find(this.applicantList, {'id':'children'});
      if(spouseObj || childObj){
        returnVal = true;
      }
      return returnVal
    },
    checkActionBtn(){
      let returnVal = false;
      if(this.checkProperty(this.selectedApplicant, 'id') == 'beneficairy'){
        if(_.has(this.petition['beneficiaryInfo'],'i485AdditionalInfo') && this.checkProperty(this.petition['beneficiaryInfo'], 'i485AdditionalInfo')
        && _.has(this.petition['beneficiaryInfo'],'i485AdditionalInfoFilled') && this.checkProperty(this.petition,'beneficiaryInfo', 'i485AdditionalInfoFilled') === true){
          returnVal = true;
        }
      }
      if(this.checkProperty(this.selectedApplicant, 'id') == 'spouse'){
        if(this.checkProperty(this.petition['dependentsInfo'], 'spouse') && _.has(this.petition['dependentsInfo']['spouse'],'i485AdditionalInfo') && this.checkProperty(this.petition['dependentsInfo'], 'spouse', 'i485AdditionalInfo')
        && _.has(this.petition['dependentsInfo']['spouse'],'i485AdditionalInfoFilled') && this.checkProperty(this.petition['dependentsInfo'],'spouse', 'i485AdditionalInfoFilled') === true){
          returnVal = true;
        }
      }
      if(this.checkProperty(this.selectedApplicant, 'id') == 'children' && this.checkProperty(this.petition,'dependentsInfo','childrens') && this.checkProperty(this.petition['dependentsInfo'],'childrens','length')>0){
        _.forEach(this.petition['dependentsInfo']['childrens'], (cItem)=>{
          if(cItem['_id'] == this.checkProperty(this.selectedApplicant, 'childId')){
            if(_.has(cItem, 'i485AdditionalInfo') && this.checkProperty(cItem, 'i485AdditionalInfo')
            && _.has(cItem,'i485AdditionalInfoFilled') && this.checkProperty(cItem, 'i485AdditionalInfoFilled') === true){
              returnVal = true;
            }
          }
        })
      }
      return returnVal
    },
    IsSponsorLogin(){
      let returnVal =false;
      let loginUserData = this.$store.state.loginUserData;
      if(this.checkProperty(loginUserData,'accountType') && this.checkProperty(loginUserData,'accountType')=='Individual' 
       && this.checkProperty(loginUserData,'accountSubType') && this.checkProperty(loginUserData,'accountSubType')=='Sponsor'){
        returnVal =true
      }else{
        returnVal =false
      }
    return returnVal;   
    },
    checkYesToAll(){
      let returnVal = true;
      let catKeys =Object.entries(this.i485AdditionalInfo);
      let count = 0;
      let totalCount = 0;
      let truCount = 0;
      _.forEach(catKeys, (item)=>{
        if(item && item[0] && this.ignore485Keys.indexOf(item[0])<=-1){
          totalCount = totalCount+1
          if(this.i485AdditionalInfo[item[0]] == false){
            count = count+1
            returnVal = true;
            this.yesToAll = false;
            return returnVal
          }
          if(this.i485AdditionalInfo[item[0]] === true){
            truCount = truCount+1
          }
        }
      })
      if(truCount > 0 && totalCount > 0  && truCount == totalCount){
        this.yesToAll = true;
      }
      return returnVal
    },
    checkNoToAll(){
      let returnVal = true;
      let catKeys =Object.entries(this.i485AdditionalInfo);
      let count = 0;
      let totalCount = 0;
      let falsCount = 0;
      _.forEach(catKeys, (item)=>{
        if(item && item[0] && this.ignore485Keys.indexOf(item[0])<=-1){
          totalCount = totalCount+1
          if(this.i485AdditionalInfo[item[0]] == true){
            count = count+1
            returnVal = true;
            this.noToAll = false;
            return returnVal
          }
          if(this.i485AdditionalInfo[item[0]] === false){
            falsCount = falsCount+1
          }
        }
      })
      if(falsCount > 0 && totalCount > 0  && falsCount == totalCount){
        this.noToAll = true;
      }
      return returnVal
    },
    showChildForms(){
      let returnVal = false;
      if([2].indexOf(this.checkProperty(this.petition, 'typeDetails', 'id'))>-1 && this.checkProperty(this.petition, 'dependentsInfo', 'childrens') && this.checkProperty(this.petition['dependentsInfo'], 'childrens', 'length')>0
      && this.petition.dependentsInfo.childrens[0].firstName != '' && this.petition.dependentsInfo.childrens[0].firstName != null)
      {
        returnVal = true;
      }
      return returnVal
    },
    checkCommentLength(){
      return (comment='')=>{
        let textcomment = comment;
        let self = this;
        let returnVal = false;
        if(textcomment){
          var plainText = textcomment.replace(/<[^>]*>/g, '');
          let plainext = plainText.replace(/&nbsp;|&nbsp/g, ' ');
          if(plainext){
            var htmlString = plainext.trim();
            if(htmlString && self.checkProperty(htmlString, 'length') >200 ){
              returnVal = true
            }
          }
        }
        return returnVal
      }
    },
    returnCommentText(){
      return (comment='')=>{
        let returnVal = '';
        if(comment){
          var plainText = comment.replace(/<[^>]*>/g, ' ');
          let plainext = plainText.replace(/&nbsp;|&nbsp/g, ' ');
          if(plainext){
            returnVal = plainext.trim();
            
          }
        }
        return returnVal
      }
    },
    checkAdditionalInfo(){
      let returnVal = false;
      if(this.checkProperty(this.i140AdditionalInfo, 'petiOrApplicAllApplicableBoxes') && this.checkProperty(this.i140AdditionalInfo, 'petiOrApplicAllApplicableBoxes','length')>0){
        const index = this.i140AdditionalInfo['petiOrApplicAllApplicableBoxes'].findIndex(item => item.name === 'Other');
        if(index>=0){
          returnVal = true;
        }
      }
      return returnVal
    },
    //reverse_document_versions
    checkRevisionDocuments(){
      return (category)=>{
        // formsAndLettersList.length > 0 forms['docUserType'] !='Beneficiary'"
        if(!category){
          let revisionDocuments =_.filter(this.formsAndLettersList ,(item)=>{
                  return this.checkProperty(item ,'reverse_document_versions' ,'length')>0?true:false
                });
                if(revisionDocuments && revisionDocuments.length>0){
                  return true
                }else{
                  return false
                }


        }else{
          let categoryList  =_.filter(this.formsAndLettersList, { "depLabel":category } );
             //alert(JSON.stringify(categoryList))
              if(categoryList.length > 0){

                let revisionDocuments =_.filter(categoryList ,(item)=>{
                  return this.checkProperty(item ,'reverse_document_versions' ,'length')>0?true:false
                });
                if(revisionDocuments && revisionDocuments.length>0){
                  return true
                }else{
                  return false
                }

                
              }else{
                return false
              }

        }
        

      }
    },
    checkUscisRevisionDocuments(){
      return (category)=>{
        // formsAndLettersList.length > 0 forms['docUserType'] !='Beneficiary'"
        if(!category){
          let revisionDocuments =_.filter(this.uscisFormsAndLettersList ,(item)=>{
                  return this.checkProperty(item ,'reverse_document_versions' ,'length')>0?true:false
                });
                if(revisionDocuments && revisionDocuments.length>0){
                  return true
                }else{
                  return false
                }


        }else{
          let categoryList  =_.filter(this.uscisFormsAndLettersList, { "depLabel":category } );
             //alert(JSON.stringify(categoryList))
              if(categoryList.length > 0){

                let revisionDocuments =_.filter(categoryList ,(item)=>{
                  return this.checkProperty(item ,'reverse_document_versions' ,'length')>0?true:false
                });
                if(revisionDocuments && revisionDocuments.length>0){
                  return true
                }else{
                  return false
                }

                
              }else{
                return false
              }

        }
        

      }
    },

    checkFormsAndLetters(){
      return (category)=>{
        // formsAndLettersList.length > 0 forms['docUserType'] !='Beneficiary'"
        if(!category){
          if(this.formsAndLettersList.length > 0){
            return true
          }else{
            return false

          }


        }else{
          let categoryList  =_.filter(this.formsAndLettersList, { "depType":category } );
             //alert(JSON.stringify(categoryList))
              if(categoryList.length > 0){
                return true
              }else{
                return false
              }

        }
        

      }
    },

    checkNoNotifyUserIds(){
      let returnValue =true;
      if(_.has(this.petition, 'noNotifyUserIds')  ){
        if(this.petition['noNotifyUserIds'].length>0){
          if(this.petition['noNotifyUserIds'].indexOf(this.getUserData['userId']) >-1){
            returnValue = false;
          }

        }

      }
      return returnValue;
    },
    checkUserAccessBtn(){
      let returnVal = false;
      let accessRoleIds = this.checkProperty( this.petition ,'accessRoleIds')
      let accessUserIds = this.checkProperty( this.petition ,'accessUserIds' )
      let loginUserId = this.checkProperty(this.getUserData,'userId')
      // accessRoleIds.indexOf(this.getUserRoleId)>-1 || 
      if(accessUserIds.indexOf(loginUserId)>-1 ){
        returnVal = true
      }
      return returnVal
    },
    checkActionButton(){
      let returnVal = true
      if(this.checkProperty( this.petition ,'assignRoleLogs' ,'length')>0){
        let assignRoleLogs = this.checkProperty( this.petition ,'assignRoleLogs')
        let loginUserId = this.checkProperty(this.getUserData,'userId')
        let UserDetails = _.find(assignRoleLogs , {"userId":loginUserId})
        if(UserDetails ){
          let users = _.filter(assignRoleLogs , {"userId":loginUserId ,'hide':false})
          if(users && users.length>0){
            returnVal =true;
          }else{
            returnVal = false
          }
          
        }
        
      }
      return returnVal
    },
    checkIsActiveUser(){
      let returnVal = false
      if(this.checkProperty( this.petition ,'assignRoleLogs' ,'length')>0){
        let assignRoleLogs = this.checkProperty( this.petition ,'assignRoleLogs')
        let loginUserId = this.checkProperty(this.getUserData,'userId')
        let UserDetails = _.find(assignRoleLogs , {"userId":loginUserId})     
        if(UserDetails){
          let users = _.filter(assignRoleLogs , {"userId":loginUserId ,'hide':false})
          if(users && users.length>0){
            returnVal =true;
          }
        }
        else{
            returnVal = true
        }
        
      }
      return returnVal
    },
    checkSubmitToUscisCompleted(){
      let returnVal =false;
      if(this.petition && this.checkProperty(this.petition ,'completedActivities' ,'length' )>-1&& this.petition.completedActivities.indexOf('SUBMIT_TO_USCIS') >-1){
        returnVal =true;
      }
      return  returnVal;

    },
    isEnableApproveRejMenu(){
      return false;
    },
    isSubmitUscisCompleted(){
       if(
     
      
         ( _.has(this.petition ,'completedActivities')
         
           &&  this.petition.completedActivities.indexOf('SUBMIT_TO_USCIS') >-1
          
         )
  
      ){
       return true;
  
      }else{
        return false
      }
    },
    checkDocsLabel() {
      let self = this;
      return (data) => {
        if (_.has(data, "field")) {
          let filedKey = data["field"];
          let selectedKey = _.find(self.docsLists, { key: filedKey });
          if (_.has(data, "category") && data["category"] == "label") {
            let returnVal = null
            if(this.checkProperty(selectedKey,'label')){
              returnVal = this.checkProperty(selectedKey,'label')
            }
            return returnVal
            //return selectedKey['label'];
          }
          if (_.has(data, "category") && data["category"] == "loading") {
            let returnVal = false
            if(this.checkProperty(selectedKey,'loading')){
              returnVal = this.checkProperty(selectedKey,'loading')
            }
            return returnVal
            //return selectedKey['loading'];
          }
        } else {
          return null;
        }
      };
    },
    checkDocM() {
      let returnVal = false;
      let docsManagerList = null;
      if(this.workFlowDetails && this.workFlowDetails.config){
        docsManagerList = _.find(this.workFlowDetails.config, {
          code: "DOCUMENTATION_MANAGER_LIST",
        });
      }
      
      if (docsManagerList && docsManagerList.editors) {
        this.ManagerList = _.map(docsManagerList.editors, "roleId");
      }
      if (this.ManagerList && this.ManagerList.indexOf( this.getUserRoleId)>-1) {
        returnVal = true;
      }
      let adminsactiVityList = null;
      if(this.workFlowDetails && this.workFlowDetails.config){
        adminsactiVityList = _.find(this.workFlowDetails.config, {
        code: "MANAGER_LIST",
      });
      }
      
      let adminsList =[];
      if (adminsactiVityList && adminsactiVityList.editors) {
        adminsList = _.map(adminsactiVityList.editors, "roleId");
      }
      if (adminsList && adminsList.indexOf( this.getUserRoleId)>-1) {
        returnVal = true;
      }
      
      return returnVal;
    },
    IsAdminUser(){
      let returnVal = false
      if(this.adminsList && this.adminsList.indexOf(this.getUserRoleId)>-1){
          returnVal = true;
        }
        return returnVal
    },
    checkPendingDocs() {
      let returnVal = false;
      if ([3, 4, 9, 10].indexOf(this.getUserRoleId) <= -1) {
        if (
          this.formsAndLettersList &&
          this.checkProperty(this.formsAndLettersList, "length") > 0
        ) {
          let falseStautsListPen = _.filter(this.formsAndLettersList, (item) => {
            return this.checkProperty(item, "statusId") == 1;
          });
          let falseStautsListRej = _.filter(this.formsAndLettersList, (item) => {
            return this.checkProperty(item, "statusId") == 3;
          });
          if (
            (falseStautsListPen &&
              this.checkProperty(falseStautsListPen, "length") > 0) ||
            (falseStautsListRej && this.checkProperty(falseStautsListRej, "length") > 0)
          ) {
            if (
              this.checkProperty(falseStautsListPen, "length") ==
              this.checkProperty(this.formsAndLettersList, "length")
            ) {
              returnVal = true;
            }
          }
        }
      }
      return returnVal;
    },
    checkActiveList() {
      let returnVal = false;
      let activeItems = _.filter(this.formsAndLettersList, (item) => {
        return this.checkProperty(item, "statusId") == 2;
      });
      if (activeItems && this.checkProperty(activeItems, "length") > 0) {
        returnVal = true;
      }
      return returnVal;
    },
    checkUscisActiveList() {
      let returnVal = false;
      let activeItems = _.filter(this.uscisFormsAndLettersList, (item) => {
        return this.checkProperty(item, "statusId") == 2;
      });
      if (activeItems && this.checkProperty(activeItems, "length") > 0) {
        returnVal = true;
      }
      return returnVal;
    },
  },

  watch: {
    '$store.state.reloadPetitionHistory'(val){ 
      if(val){
        setTimeout(()=>{
          this.getcaseHistory();
        }, 1000)
        
      }
    },
   
            reversion_fileuploadPopup:function(value){
              if(!value){
                this.parentId ='';
                this.selectedDocument = null;
                

              }
            },

formLetterType:function(value){
    if(this.fileuploadPopup){
        this.uploadMainDocuments =[];
        this.uploadFinalMainDocuments =[];
        // :accept="acceptedFiles"
        if (value == "Form") {
    
            this.acceptedFiles = "application/pdf";
        } else if (value == "Letter") {
            this.acceptedFiles = "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        } 
      }

},
    fileuploadPopup:function(value){
     if(!value){
      this.showDocType =false;
     }
      
    
   },
    
    selectedCourier:function(value){
     
      setTimeout(()=>{
        this.changedOffice(true);
      } ,10);
     
    }
   // changedOffice selectedCourier
    // downloadFiles:function(value){
    //     if(value){
    //          // alert(value)
    //           //this.$modal.show('download_files_model');
    //           this.hideModel('download_files_model' ,true);
    //     }else{
    //         this.hideModel('download_files_model' ,false);
    //     }
    // }
  },
};
</script>
